/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ModelAxleBlueprintFilterInput = {
  and?: Array< ModelAxleBlueprintFilterInput | null > | null,
  axles?: ModelStringInput | null,
  centerlineLength?: ModelIntInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelAxleBlueprintFilterInput | null,
  or?: Array< ModelAxleBlueprintFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIntInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIDInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAxleBlueprintConnection = {
  __typename: "ModelAxleBlueprintConnection",
  items:  Array<AxleBlueprint | null >,
  nextToken?: string | null,
};

export type AxleBlueprint = {
  __typename: "AxleBlueprint",
  axles: string,
  centerlineLength: number,
  companyId: string,
  createdAt: string,
  description?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type ModelBusinessAdminFilterInput = {
  and?: Array< ModelBusinessAdminFilterInput | null > | null,
  cognitoId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  email?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelBusinessAdminFilterInput | null,
  or?: Array< ModelBusinessAdminFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  role?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBusinessAdminConnection = {
  __typename: "ModelBusinessAdminConnection",
  items:  Array<BusinessAdmin | null >,
  nextToken?: string | null,
};

export type BusinessAdmin = {
  __typename: "BusinessAdmin",
  cognitoId: string,
  createdAt: string,
  domain?: string | null,
  email: string,
  id: string,
  name: string,
  owner?: string | null,
  permissions?: string | null,
  role: string,
  updatedAt: string,
};

export type ModelStringKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelChangeLogEntryFilterInput = {
  and?: Array< ModelChangeLogEntryFilterInput | null > | null,
  changedBy?: ModelStringInput | null,
  changedByName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  newValue?: ModelStringInput | null,
  not?: ModelChangeLogEntryFilterInput | null,
  oldValue?: ModelStringInput | null,
  or?: Array< ModelChangeLogEntryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelChangeLogEntryConnection = {
  __typename: "ModelChangeLogEntryConnection",
  items:  Array<ChangeLogEntry | null >,
  nextToken?: string | null,
};

export type ChangeLogEntry = {
  __typename: "ChangeLogEntry",
  changedBy: string,
  changedByName: string,
  companyId: string,
  createdAt?: string | null,
  description: string,
  fieldName: string,
  id: string,
  newValue?: string | null,
  oldValue?: string | null,
  owner?: string | null,
  updatedAt: string,
  userId: string,
};

export type ModelClassificationFilterInput = {
  and?: Array< ModelClassificationFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelClassificationFilterInput | null,
  or?: Array< ModelClassificationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelClassificationConnection = {
  __typename: "ModelClassificationConnection",
  items:  Array<Classification | null >,
  nextToken?: string | null,
};

export type Classification = {
  __typename: "Classification",
  companyId: string,
  createdAt: string,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type ModelCompanyOwnerFilterInput = {
  and?: Array< ModelCompanyOwnerFilterInput | null > | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contactPhoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  discrepancyNotification?: ModelBooleanInput | null,
  discrepancyNotificationTypes?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  email?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelCompanyOwnerFilterInput | null,
  or?: Array< ModelCompanyOwnerFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  pmNotification?: ModelBooleanInput | null,
  pmNotificationTypes?: ModelStringInput | null,
  role?: ModelStringInput | null,
  siteAdmin?: ModelBooleanInput | null,
  subscriptionType?: ModelStringInput | null,
  trainingNotification?: ModelBooleanInput | null,
  trainingNotificationTypes?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBooleanInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelCompanyOwnerConnection = {
  __typename: "ModelCompanyOwnerConnection",
  items:  Array<CompanyOwner | null >,
  nextToken?: string | null,
};

export type CompanyOwner = {
  __typename: "CompanyOwner",
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  createdAt: string,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  email: string,
  id: string,
  name: string,
  owner?: string | null,
  permissions?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  role?: string | null,
  siteAdmin: boolean,
  subscriptionType: string,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
  updatedAt: string,
};

export type ArchivedDiscrepancy = {
  __typename: "ArchivedDiscrepancy",
  archivedDate?: string | null,
  companyId: string,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId: string,
  equipmentName: string,
  id: string,
  initialStatus?: string | null,
  log?: string | null,
  owner?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status: string,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type AuditLog = {
  __typename: "AuditLog",
  action: string,
  companyId: string,
  createdAt?: string | null,
  details?: string | null,
  id: string,
  resourceId: string,
  resourceName?: string | null,
  resourceType: string,
  ttl?: number | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
};

export type BillingRate = {
  __typename: "BillingRate",
  companyId: string,
  createdAt: string,
  id: string,
  owner?: string | null,
  ratePerCostTracking?: number | null,
  ratePerEquipment?: number | null,
  ratePerPM?: number | null,
  ratePerSafetyEnrollment?: number | null,
  ratePerSkillQualification?: number | null,
  ratePerTireMaint?: number | null,
  ratePerUser?: number | null,
  updatedAt: string,
};

export type Company = {
  __typename: "Company",
  accountNumber?: string | null,
  accountOrigin?: string | null,
  accountStatus?: string | null,
  addOnGracePeriodEndDate?: string | null,
  archived?: boolean | null,
  assignedRep?: string | null,
  billingAnchorDay?: number | null,
  billingContactAddress?: string | null,
  billingContactEmail?: string | null,
  billingContactName?: string | null,
  billingContactPhone?: string | null,
  billingCycle?: string | null,
  businessType?: string | null,
  cancelEffectiveDate?: string | null,
  cancelReason?: string | null,
  cancelReasonNote?: string | null,
  cancelRequestedAt?: string | null,
  companyOwnerId?: string | null,
  coreMonthlyRate?: number | null,
  costTrackingModuleEnrollment?: boolean | null,
  createdAt: string,
  dataRetentionEndDate?: string | null,
  description?: string | null,
  gracePeriodEndDate?: string | null,
  id: string,
  industryNAICS?: string | null,
  industrySIC?: string | null,
  initialContactDate?: string | null,
  initialStarterPackageEnrollment?: boolean | null,
  logo?: string | null,
  maxNumberEquipment: number,
  maxNumberUsers: number,
  name: string,
  nextBillingDate?: string | null,
  notes?: string | null,
  numberOfUsers?: number | null,
  paidStartDate?: string | null,
  paymentFailedAt?: string | null,
  paymentMethod?: string | null,
  pmModuleEnrollment?: boolean | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  primaryContactPhone?: string | null,
  primaryContactPosition?: string | null,
  primaryLocation?: string | null,
  referredBy?: string | null,
  retryAttempts?: number | null,
  safetyComplianceStandard?: string | null,
  secondaryContactEmail?: string | null,
  secondaryContactName?: string | null,
  secondaryContactPhone?: string | null,
  secondaryContactPosition?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  starterPackage?: string | null,
  status?: string | null,
  subscriptionExpiration: string,
  subscriptionType: string,
  tiresModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trialEndDate?: string | null,
  trialStartDate?: string | null,
  type?: string | null,
  updatedAt: string,
};

export type CompanyNote = {
  __typename: "CompanyNote",
  authorName: string,
  companyId: string,
  content: string,
  createdAt?: string | null,
  id: string,
  owner?: string | null,
  updatedAt: string,
};

export type CompanyResource = {
  __typename: "CompanyResource",
  category: string,
  companyId: string,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdAt: string,
  description?: string | null,
  fileType: string,
  folderName?: string | null,
  id: string,
  owner?: string | null,
  title: string,
  trainingTopicId?: string | null,
  updatedAt: string,
  uploadedByUserId?: string | null,
  uploadedByUserName?: string | null,
};

export type DOTInspectionReport = {
  __typename: "DOTInspectionReport",
  companyId: string,
  complianceStatus?: string | null,
  createdAt?: string | null,
  dotInspectionType?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  inspectorCertificationId?: string | null,
  locationId?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  regulatoryStandard?: string | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
  vehicleLicensePlate?: string | null,
  vehicleVIN?: string | null,
  warnCount?: number | null,
};

export type DailyServiceReport = {
  __typename: "DailyServiceReport",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  dailyServiceLogFormId?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtService?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtService?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type Discrepancy = {
  __typename: "Discrepancy",
  companyId: string,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId: string,
  equipmentName: string,
  id: string,
  initialStatus?: string | null,
  log?: string | null,
  owner?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status: string,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type Document = {
  __typename: "Document",
  assignedSafetyLesson?: string | null,
  contentPath: string,
  createdAt: string,
  folderName?: string | null,
  id: string,
  owner?: string | null,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title: string,
  updatedAt: string,
};

export type Equipment = {
  __typename: "Equipment",
  companyId: string,
  createdAt: string,
  formId: string,
  id: string,
  image?: string | null,
  name: string,
  units?: string | null,
  updatedAt: string,
};

export type EquipmentCategory = {
  __typename: "EquipmentCategory",
  companyId: string,
  createdAt: string,
  formId: string,
  id: string,
  image?: string | null,
  name: string,
  updatedAt: string,
};

export type Errors = {
  __typename: "Errors",
  createdAt: string,
  errors: string,
  id: string,
  updatedAt: string,
};

export type ExpenseCategory = {
  __typename: "ExpenseCategory",
  companyId: string,
  createdAt: string,
  id: string,
  name: string,
  owner?: string | null,
  startingBalance?: number | null,
  updatedAt: string,
};

export type ExpenseRecord = {
  __typename: "ExpenseRecord",
  attachments?: Array< string | null > | null,
  companyId: string,
  createdAt: string,
  dateOfInput: string,
  dateOfService: string,
  equipmentCategoryId?: string | null,
  expenseCategories?: string | null,
  id: string,
  invoiceNumber?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  owner?: string | null,
  pmExpense?: number | null,
  pmServiceLevelId?: string | null,
  pmServiceLevelName?: string | null,
  totalExpense: number,
  totalLaborCost?: number | null,
  unitId: string,
  updatedAt: string,
  vendorId?: string | null,
  vendorName?: string | null,
  workDescription?: string | null,
};

export type Form = {
  __typename: "Form",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt: string,
  dailyServiceLogForm?: boolean | null,
  equipmentType?: string | null,
  formData: string,
  formType?: string | null,
  id: string,
  inspectionForm?: boolean | null,
  name: string,
  noMachineHours?: boolean | null,
  noUMCounter?: boolean | null,
  owner?: string | null,
  pmServiceScheduleForm?: boolean | null,
  status?: string | null,
  umCounterLabel?: string | null,
  updatedAt: string,
};

export type FormTemplate = {
  __typename: "FormTemplate",
  createdAt: string,
  createdByCompanyOwnerId?: string | null,
  dailyServiceLogForm?: boolean | null,
  formTemplateGroupID?: string | null,
  id: string,
  inspectionForm?: boolean | null,
  originalCompanyId?: string | null,
  owner?: string | null,
  pmServiceScheduleForm?: boolean | null,
  templateData: string,
  templateName: string,
  updatedAt: string,
};

export type FormTemplateGroup = {
  __typename: "FormTemplateGroup",
  createdAt: string,
  description?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  resourceLibraryID?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  updatedAt: string,
};

export type HelpSupportDoc = {
  __typename: "HelpSupportDoc",
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdAt: string,
  createdByAdminId: string,
  description?: string | null,
  docType: string,
  id: string,
  owner?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  status: string,
  title: string,
  updatedAt: string,
  visibility: string,
};

export type InspectionReport = {
  __typename: "InspectionReport",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtInspection?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtInspection?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type Invoice = {
  __typename: "Invoice",
  amount: number,
  companyId: string,
  createdAt: string,
  date: string,
  description: string,
  id: string,
  invoiceNumber: string,
  lineItems?: string | null,
  owner?: string | null,
  pdfUrl?: string | null,
  status: string,
  updatedAt: string,
};

export type LaborCategory = {
  __typename: "LaborCategory",
  companyId: string,
  createdAt: string,
  id: string,
  isActive: boolean,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type LaborRate = {
  __typename: "LaborRate",
  categoryId: string,
  createdAt: string,
  effectiveDate: string,
  id: string,
  overtimeRate: number,
  owner?: string | null,
  standardRate: number,
  updatedAt: string,
};

export type LibraryPlanTemplate = {
  __typename: "LibraryPlanTemplate",
  categories: string,
  categoryCount?: number | null,
  createdAt: string,
  createdByAdminId: string,
  createdByAdminName?: string | null,
  cycleDuration: number,
  description?: string | null,
  governingStandard: string,
  id: string,
  minimumTimeRequired: number,
  name: string,
  owner?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  status: string,
  topicCount?: number | null,
  updatedAt: string,
  workingDays: Array< number | null >,
};

export type LibraryTopicTemplate = {
  __typename: "LibraryTopicTemplate",
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdAt: string,
  createdByAdminId: string,
  description: string,
  id: string,
  owner?: string | null,
  style: string,
  timeValue: number,
  topicId: string,
  updatedAt: string,
};

export type Location = {
  __typename: "Location",
  companyId: string,
  createdAt: string,
  description?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  regionalDivisionId: string,
  updatedAt: string,
};

export type ModuleSubscription = {
  __typename: "ModuleSubscription",
  activatedAt: string,
  cancelRequestedAt?: string | null,
  companyId: string,
  createdAt: string,
  effectiveEndDate?: string | null,
  id: string,
  moduleKey: string,
  monthlyRate: number,
  owner?: string | null,
  pricingModel: string,
  status: string,
  updatedAt: string,
};

export type PMConfiguration = {
  __typename: "PMConfiguration",
  companyId: string,
  createdAt: string,
  dueSoonPercentage?: number | null,
  id: string,
  laborCategoryId?: string | null,
  owner?: string | null,
  unitId: string,
  unitOfMeasure: string,
  updatedAt: string,
};

export type PMModuleContent = {
  __typename: "PMModuleContent",
  createdAt: string,
  id: string,
  owner?: string | null,
  pmServiceFormId: string,
  unitId: string,
  updatedAt: string,
};

export type PMNotificationSetting = {
  __typename: "PMNotificationSetting",
  createdAt: string,
  emailThresholdUM: number,
  id: string,
  lastNotificationSent?: string | null,
  notificationFrequency: string,
  owner?: string | null,
  pmConfigurationId: string,
  recipients?: Array< string | null > | null,
  serviceLevelId?: string | null,
  updatedAt: string,
};

export type PMPartsAndProcedure = {
  __typename: "PMPartsAndProcedure",
  category?: string | null,
  companyId?: string | null,
  createdAt: string,
  createdByUserId?: string | null,
  createdByUserName?: string | null,
  id: string,
  itemName: string,
  itemType?: string | null,
  manufacturer?: string | null,
  owner?: string | null,
  partNumber?: string | null,
  pmConfigurationId?: string | null,
  pmConfigurationIds?: Array< string | null > | null,
  price?: number | null,
  quantity?: number | null,
  sortOrder?: number | null,
  unitOfMeasure?: string | null,
  updatedAt: string,
  vendorId?: string | null,
  vendorName?: string | null,
};

export type PMReport = {
  __typename: "PMReport",
  actualUM: number,
  companyId: string,
  createdAt?: string | null,
  id: string,
  issueDescription?: string | null,
  issueTicketCreated?: boolean | null,
  issueTicketId?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  owner?: string | null,
  photos?: Array< string | null > | null,
  pmConfigurationId: string,
  reportData?: string | null,
  serviceDate: string,
  serviceLevelId: string,
  serviceLevelName?: string | null,
  signature?: string | null,
  status?: string | null,
  technicianId: string,
  technicianName?: string | null,
  totalLaborCost?: number | null,
  unitId: string,
  updatedAt: string,
};

export type PMServiceLevel = {
  __typename: "PMServiceLevel",
  createdAt: string,
  description?: string | null,
  id: string,
  intervalValue: number,
  lastServiceDate?: string | null,
  lastServiceUM?: number | null,
  levelIdentifier: string,
  owner?: string | null,
  pmConfigurationId: string,
  pmServiceFormId?: string | null,
  serviceLevelAssignments?: string | null,
  targetUM: number,
  updatedAt: string,
};

export type RegionalDivision = {
  __typename: "RegionalDivision",
  companyId: string,
  createdAt: string,
  description?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type Report = {
  __typename: "Report",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  dailyServiceLogReport?: boolean | null,
  equipmentId: string,
  equipmentLocationId?: string | null,
  equipmentName?: string | null,
  id: string,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name: string,
  signature?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  updatedAt: string,
  userData: string,
  userId: string,
  userLocation: string,
};

export type ReportAnswer = {
  __typename: "ReportAnswer",
  companyId: string,
  createdAt?: string | null,
  id: string,
  notes?: string | null,
  parentReportId: string,
  photos?: Array< string | null > | null,
  promptDescription?: string | null,
  promptKey: string,
  promptLabel?: string | null,
  promptTitle?: string | null,
  promptType?: string | null,
  reportType: string,
  sortOrder?: number | null,
  unitId?: string | null,
  updatedAt: string,
  value?: string | null,
};

export type ResourceLibrary = {
  __typename: "ResourceLibrary",
  companyOwnerId: string,
  createdAt: string,
  id: string,
  owner?: string | null,
  updatedAt: string,
};

export type SavedReportConfiguration = {
  __typename: "SavedReportConfiguration",
  companyId: string,
  compareDateRangeEnd?: string | null,
  compareDateRangeStart?: string | null,
  createdAt?: string | null,
  dateRangeEnd?: string | null,
  dateRangeStart?: string | null,
  dateRangeType?: string | null,
  filtersJson?: string | null,
  groupByField?: string | null,
  id: string,
  lastRunAt?: string | null,
  metricCategory?: string | null,
  metricKey: string,
  reportName: string,
  updatedAt: string,
  userId: string,
  visualizationType?: string | null,
};

export type SensitiveUserInfo = {
  __typename: "SensitiveUserInfo",
  cognitoId?: string | null,
  companyId?: string | null,
  createdAt: string,
  dateOfBirth?: string | null,
  driversLicenseClass?: string | null,
  driversLicenseExpirationDate?: string | null,
  driversLicenseNumber?: string | null,
  driversLicenseState?: string | null,
  emergencyContactName?: string | null,
  emergencyContactPhoneNumber?: string | null,
  emergencyContactRelationship?: string | null,
  id: string,
  owner?: string | null,
  updatedAt: string,
};

export type ShiftReport = {
  __typename: "ShiftReport",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  locationName?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  shiftType?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type SingleUnit = {
  __typename: "SingleUnit",
  annualProjectedUsage?: number | null,
  aquisitionCost?: number | null,
  aquisitionDate?: string | null,
  assignedTo?: string | null,
  axleConfiguration?: string | null,
  categoryId?: string | null,
  costTrackingModuleEnrollment?: boolean | null,
  createdAt: string,
  currentMachineHours?: number | null,
  currentUMCounterValue?: number | null,
  dailyServiceLogFormId?: string | null,
  description?: string | null,
  dispositionDate?: string | null,
  dispositionReason?: string | null,
  downReason?: string | null,
  engineManufacturer?: string | null,
  engineModelNumber?: string | null,
  equipmentStatus?: boolean | null,
  extraUnitInfo?: string | null,
  id: string,
  image?: string | null,
  inputByPerson?: string | null,
  inputDate?: string | null,
  lastDailyServiceDate?: string | null,
  lastInspectionDate?: string | null,
  lastServiceHours?: number | null,
  licenseNumber?: string | null,
  locationId?: string | null,
  machineHoursAtAquisition?: number | null,
  machineUMCounterAtAquisition?: number | null,
  manufactureDate?: string | null,
  manufacturerName?: string | null,
  modelNumber?: string | null,
  name: string,
  pmModuleEnrollment?: boolean | null,
  putInServiceDate?: string | null,
  removedFromServiceDate?: string | null,
  removedFromServiceReason?: string | null,
  replacedUMCounterHistory?: string | null,
  replacedUMCounterStatus?: boolean | null,
  replacedUMCounterValue?: number | null,
  serialNumber?: string | null,
  tiresModuleEnrollment?: boolean | null,
  unitOfMeasure?: string | null,
  updatedAt: string,
  utilizationAdjustmentDays?: number | null,
};

export type SkillAssignment = {
  __typename: "SkillAssignment",
  companyId: string,
  createdAt: string,
  evaluatedBy?: string | null,
  evaluatedByName?: string | null,
  evaluationDate?: string | null,
  id: string,
  owner?: string | null,
  skillLevel: string,
  subCategoryId?: string | null,
  taskId: string,
  updatedAt: string,
  userId: string,
};

export type SkillCategory = {
  __typename: "SkillCategory",
  allowMachineNumber?: boolean | null,
  classificationId: string,
  companyId: string,
  createdAt: string,
  equipmentCategoryId?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type SkillLevel = {
  __typename: "SkillLevel",
  color?: string | null,
  companyId: string,
  createdAt: string,
  description?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  sortOrder: number,
  updatedAt: string,
};

export type SkillTask = {
  __typename: "SkillTask",
  categoryId: string,
  companyId: string,
  createdAt: string,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type SubCategory = {
  __typename: "SubCategory",
  categoryId: string,
  companyId: string,
  createdAt: string,
  id: string,
  name: string,
  owner?: string | null,
  updatedAt: string,
};

export type Tire = {
  __typename: "Tire",
  assignedAxle?: string | null,
  assignedPosition?: string | null,
  companyId: string,
  createdAt: string,
  currentTirePressure?: number | null,
  currentTreadDepth?: number | null,
  dateInstalled?: string | null,
  dateUninstalled?: string | null,
  failureReason?: string | null,
  id: string,
  inflationMedium?: string | null,
  loadRating?: number | null,
  loadRatingUnit?: string | null,
  minimumTreadDepth?: number | null,
  name?: string | null,
  owner?: string | null,
  recommendedTirePressure?: number | null,
  removedFromService?: boolean | null,
  removedFromServiceDate?: string | null,
  tireCategory?: string | null,
  tireManufacturer?: string | null,
  tireModel?: string | null,
  tireSize?: string | null,
  tireStatus?: string | null,
  treadDepthAtInstall?: number | null,
  unitId?: string | null,
  updatedAt: string,
};

export type TireReport = {
  __typename: "TireReport",
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  equipmentLocationId?: string | null,
  id: string,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name: string,
  signature?: string | null,
  tireId?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  updatedAt: string,
  userData: string,
  userId: string,
  userLocation: string,
};

export type TrainingAffidavit = {
  __typename: "TrainingAffidavit",
  adminId: string,
  affidavitDate: string,
  companyId: string,
  createdAt: string,
  id: string,
  legalText: string,
  nextDueDate: string,
  owner?: string | null,
  planId: string,
  signaturePath: string,
  updatedAt: string,
  userId: string,
};

export type TrainingCompletion = {
  __typename: "TrainingCompletion",
  categoryId?: string | null,
  companyId: string,
  completionDate: string,
  createdAt: string,
  id: string,
  launched: boolean,
  markedAsViewed: boolean,
  owner?: string | null,
  planId: string,
  scheduleDate: string,
  signaturePath?: string | null,
  timeValueMinutes: number,
  topicId: string,
  updatedAt: string,
  userId: string,
};

export type TrainingEnrollment = {
  __typename: "TrainingEnrollment",
  companyId: string,
  createdAt: string,
  enrolledDate: string,
  id: string,
  lastCompletionDate?: string | null,
  nextDueDate?: string | null,
  owner?: string | null,
  planId: string,
  status: string,
  updatedAt: string,
  userId: string,
};

export type TrainingPlan = {
  __typename: "TrainingPlan",
  categories: string,
  companyId: string,
  createdAt: string,
  cycleDuration: number,
  governingStandard: string,
  holidays?: string | null,
  id: string,
  minimumTimeRequired: number,
  name: string,
  owner?: string | null,
  startDate?: string | null,
  status: string,
  updatedAt: string,
  workingDays?: Array< number | null > | null,
};

export type TrainingQuizResponse = {
  __typename: "TrainingQuizResponse",
  attemptNumber?: number | null,
  categoryId?: string | null,
  companyId: string,
  completedAt?: string | null,
  createdAt: string,
  cycleStartDate?: string | null,
  formId?: string | null,
  id: string,
  owner?: string | null,
  passed?: boolean | null,
  planId: string,
  responseData?: string | null,
  score?: number | null,
  signaturePath?: string | null,
  totalQuestions?: number | null,
  updatedAt: string,
  userId: string,
};

export type TrainingSchedule = {
  __typename: "TrainingSchedule",
  assignedUserId?: string | null,
  categoryId?: string | null,
  companyId: string,
  createdAt: string,
  dayNumber: number,
  id: string,
  locked?: boolean | null,
  owner?: string | null,
  planId: string,
  scheduledDate: string,
  topicId: string,
  updatedAt: string,
};

export type TrainingTopic = {
  __typename: "TrainingTopic",
  categoryIds?: Array< string | null > | null,
  companyId: string,
  companyResourceId?: string | null,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdAt: string,
  description: string,
  id: string,
  owner?: string | null,
  planIds?: Array< string | null > | null,
  style: string,
  timeValue: number,
  topicId: string,
  updatedAt: string,
};

export type UnitExpenseBudget = {
  __typename: "UnitExpenseBudget",
  companyId: string,
  createdAt: string,
  expenseCategoryId: string,
  id: string,
  owner?: string | null,
  startingBalance: number,
  unitId: string,
  updatedAt: string,
};

export type User = {
  __typename: "User",
  archived?: boolean | null,
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  contactPhoneType?: string | null,
  createdAt: string,
  currentJobClassification?: string | null,
  dateOfHire?: string | null,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  driversLicenseStatus?: boolean | null,
  email: string,
  globalLocationPermission?: boolean | null,
  id: string,
  inputByPerson?: string | null,
  inputDate?: string | null,
  locationAssignment?: Array< string | null > | null,
  name: string,
  notesAboutUser?: string | null,
  onHighwayEligibility?: boolean | null,
  owner?: string | null,
  permissions?: string | null,
  personalIdentification?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  position?: string | null,
  regionalAssignment?: Array< string | null > | null,
  role?: string | null,
  safetyLessons?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
  updatedAt: string,
  userPhoto?: string | null,
};

export type UserFile = {
  __typename: "UserFile",
  companyId: string,
  createdAt: string,
  fileName: string,
  fileSize: number,
  id: string,
  owner?: string | null,
  s3Path: string,
  updatedAt: string,
  uploadedAt: string,
  uploadedBy: string,
  uploadedByName: string,
  userId: string,
};

export type UserReportFavorite = {
  __typename: "UserReportFavorite",
  companyId: string,
  createdAt: string,
  id: string,
  reportTypeKey: string,
  updatedAt: string,
  userId: string,
};

export type UserSkillReport = {
  __typename: "UserSkillReport",
  assessorId?: string | null,
  assessorName?: string | null,
  companyId: string,
  createdAt?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  okCount?: number | null,
  passFailStatus?: string | null,
  photos?: Array< string | null > | null,
  qualificationLevel?: string | null,
  responseData?: string | null,
  signature?: string | null,
  skillCategory?: string | null,
  skillName?: string | null,
  totalItems?: number | null,
  updatedAt: string,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type VendorList = {
  __typename: "VendorList",
  address?: string | null,
  companyId: string,
  createdAt: string,
  faxNumber?: string | null,
  id: string,
  name: string,
  owner?: string | null,
  phoneNumber?: string | null,
  repName?: string | null,
  repPhoneNumber?: string | null,
  updatedAt?: string | null,
};

export type Video = {
  __typename: "Video",
  assignedSafetyLesson?: string | null,
  contentPath: string,
  createdAt: string,
  folderName?: string | null,
  id: string,
  owner?: string | null,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title: string,
  updatedAt: string,
};

export type ModelArchivedDiscrepancyFilterInput = {
  and?: Array< ModelArchivedDiscrepancyFilterInput | null > | null,
  archivedDate?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  initialStatus?: ModelStringInput | null,
  log?: ModelStringInput | null,
  not?: ModelArchivedDiscrepancyFilterInput | null,
  or?: Array< ModelArchivedDiscrepancyFilterInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  questionIndex?: ModelIntInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelArchivedDiscrepancyConnection = {
  __typename: "ModelArchivedDiscrepancyConnection",
  items:  Array<ArchivedDiscrepancy | null >,
  nextToken?: string | null,
};

export type ModelAuditLogFilterInput = {
  action?: ModelStringInput | null,
  and?: Array< ModelAuditLogFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  details?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelAuditLogFilterInput | null,
  or?: Array< ModelAuditLogFilterInput | null > | null,
  resourceId?: ModelStringInput | null,
  resourceName?: ModelStringInput | null,
  resourceType?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
};

export type ModelAuditLogConnection = {
  __typename: "ModelAuditLogConnection",
  items:  Array<AuditLog | null >,
  nextToken?: string | null,
};

export type ModelBillingRateFilterInput = {
  and?: Array< ModelBillingRateFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelBillingRateFilterInput | null,
  or?: Array< ModelBillingRateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  ratePerCostTracking?: ModelFloatInput | null,
  ratePerEquipment?: ModelFloatInput | null,
  ratePerPM?: ModelFloatInput | null,
  ratePerSafetyEnrollment?: ModelFloatInput | null,
  ratePerSkillQualification?: ModelFloatInput | null,
  ratePerTireMaint?: ModelFloatInput | null,
  ratePerUser?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFloatInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelBillingRateConnection = {
  __typename: "ModelBillingRateConnection",
  items:  Array<BillingRate | null >,
  nextToken?: string | null,
};

export type ModelCompanyFilterInput = {
  accountNumber?: ModelStringInput | null,
  accountOrigin?: ModelStringInput | null,
  accountStatus?: ModelStringInput | null,
  addOnGracePeriodEndDate?: ModelStringInput | null,
  and?: Array< ModelCompanyFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  assignedRep?: ModelStringInput | null,
  billingAnchorDay?: ModelIntInput | null,
  billingContactAddress?: ModelStringInput | null,
  billingContactEmail?: ModelStringInput | null,
  billingContactName?: ModelStringInput | null,
  billingContactPhone?: ModelStringInput | null,
  billingCycle?: ModelStringInput | null,
  businessType?: ModelStringInput | null,
  cancelEffectiveDate?: ModelStringInput | null,
  cancelReason?: ModelStringInput | null,
  cancelReasonNote?: ModelStringInput | null,
  cancelRequestedAt?: ModelStringInput | null,
  companyOwnerId?: ModelStringInput | null,
  coreMonthlyRate?: ModelFloatInput | null,
  costTrackingModuleEnrollment?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  dataRetentionEndDate?: ModelStringInput | null,
  description?: ModelStringInput | null,
  gracePeriodEndDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  industryNAICS?: ModelStringInput | null,
  industrySIC?: ModelStringInput | null,
  initialContactDate?: ModelStringInput | null,
  initialStarterPackageEnrollment?: ModelBooleanInput | null,
  logo?: ModelStringInput | null,
  maxNumberEquipment?: ModelIntInput | null,
  maxNumberUsers?: ModelIntInput | null,
  name?: ModelStringInput | null,
  nextBillingDate?: ModelStringInput | null,
  not?: ModelCompanyFilterInput | null,
  notes?: ModelStringInput | null,
  numberOfUsers?: ModelIntInput | null,
  or?: Array< ModelCompanyFilterInput | null > | null,
  paidStartDate?: ModelStringInput | null,
  paymentFailedAt?: ModelStringInput | null,
  paymentMethod?: ModelStringInput | null,
  pmModuleEnrollment?: ModelBooleanInput | null,
  primaryContactEmail?: ModelStringInput | null,
  primaryContactName?: ModelStringInput | null,
  primaryContactPhone?: ModelStringInput | null,
  primaryContactPosition?: ModelStringInput | null,
  primaryLocation?: ModelStringInput | null,
  referredBy?: ModelStringInput | null,
  retryAttempts?: ModelIntInput | null,
  safetyComplianceStandard?: ModelStringInput | null,
  secondaryContactEmail?: ModelStringInput | null,
  secondaryContactName?: ModelStringInput | null,
  secondaryContactPhone?: ModelStringInput | null,
  secondaryContactPosition?: ModelStringInput | null,
  skillTrackingModuleEnrollment?: ModelBooleanInput | null,
  starterPackage?: ModelStringInput | null,
  status?: ModelStringInput | null,
  subscriptionExpiration?: ModelStringInput | null,
  subscriptionType?: ModelStringInput | null,
  tiresModuleEnrollment?: ModelBooleanInput | null,
  trainingModuleEnrollment?: ModelBooleanInput | null,
  trialEndDate?: ModelStringInput | null,
  trialStartDate?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCompanyConnection = {
  __typename: "ModelCompanyConnection",
  items:  Array<Company | null >,
  nextToken?: string | null,
};

export type ModelCompanyNoteFilterInput = {
  and?: Array< ModelCompanyNoteFilterInput | null > | null,
  authorName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelCompanyNoteFilterInput | null,
  or?: Array< ModelCompanyNoteFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCompanyNoteConnection = {
  __typename: "ModelCompanyNoteConnection",
  items:  Array<CompanyNote | null >,
  nextToken?: string | null,
};

export type ModelCompanyResourceFilterInput = {
  and?: Array< ModelCompanyResourceFilterInput | null > | null,
  category?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelCompanyResourceFilterInput | null,
  or?: Array< ModelCompanyResourceFilterInput | null > | null,
  owner?: ModelStringInput | null,
  title?: ModelStringInput | null,
  trainingTopicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  uploadedByUserId?: ModelStringInput | null,
  uploadedByUserName?: ModelStringInput | null,
};

export type ModelCompanyResourceConnection = {
  __typename: "ModelCompanyResourceConnection",
  items:  Array<CompanyResource | null >,
  nextToken?: string | null,
};

export type ModelDOTInspectionReportFilterInput = {
  and?: Array< ModelDOTInspectionReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  complianceStatus?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dotInspectionType?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  inspectorCertificationId?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  not?: ModelDOTInspectionReportFilterInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelDOTInspectionReportFilterInput | null > | null,
  photos?: ModelStringInput | null,
  regulatoryStandard?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  vehicleLicensePlate?: ModelStringInput | null,
  vehicleVIN?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type ModelDOTInspectionReportConnection = {
  __typename: "ModelDOTInspectionReportConnection",
  items:  Array<DOTInspectionReport | null >,
  nextToken?: string | null,
};

export type ModelDailyServiceReportFilterInput = {
  and?: Array< ModelDailyServiceReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogFormId?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtService?: ModelFloatInput | null,
  not?: ModelDailyServiceReportFilterInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelDailyServiceReportFilterInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  umCounterAtService?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type ModelDailyServiceReportConnection = {
  __typename: "ModelDailyServiceReportConnection",
  items:  Array<DailyServiceReport | null >,
  nextToken?: string | null,
};

export type ModelDiscrepancyFilterInput = {
  and?: Array< ModelDiscrepancyFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  initialStatus?: ModelStringInput | null,
  log?: ModelStringInput | null,
  not?: ModelDiscrepancyFilterInput | null,
  or?: Array< ModelDiscrepancyFilterInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  questionIndex?: ModelIntInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDiscrepancyConnection = {
  __typename: "ModelDiscrepancyConnection",
  items:  Array<Discrepancy | null >,
  nextToken?: string | null,
};

export type ModelDocumentFilterInput = {
  and?: Array< ModelDocumentFilterInput | null > | null,
  assignedSafetyLesson?: ModelStringInput | null,
  contentPath?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelDocumentFilterInput | null,
  or?: Array< ModelDocumentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  safetyLesson?: ModelBooleanInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDocumentConnection = {
  __typename: "ModelDocumentConnection",
  items:  Array<Document | null >,
  nextToken?: string | null,
};

export type ModelEquipmentFilterInput = {
  and?: Array< ModelEquipmentFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelEquipmentFilterInput | null,
  or?: Array< ModelEquipmentFilterInput | null > | null,
  units?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEquipmentConnection = {
  __typename: "ModelEquipmentConnection",
  items:  Array<Equipment | null >,
  nextToken?: string | null,
};

export type ModelEquipmentCategoryFilterInput = {
  and?: Array< ModelEquipmentCategoryFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelEquipmentCategoryFilterInput | null,
  or?: Array< ModelEquipmentCategoryFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEquipmentCategoryConnection = {
  __typename: "ModelEquipmentCategoryConnection",
  items:  Array<EquipmentCategory | null >,
  nextToken?: string | null,
};

export type ModelErrorsFilterInput = {
  and?: Array< ModelErrorsFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  errors?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelErrorsFilterInput | null,
  or?: Array< ModelErrorsFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelErrorsConnection = {
  __typename: "ModelErrorsConnection",
  items:  Array<Errors | null >,
  nextToken?: string | null,
};

export type ModelExpenseCategoryFilterInput = {
  and?: Array< ModelExpenseCategoryFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelExpenseCategoryFilterInput | null,
  or?: Array< ModelExpenseCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelExpenseCategoryConnection = {
  __typename: "ModelExpenseCategoryConnection",
  items:  Array<ExpenseCategory | null >,
  nextToken?: string | null,
};

export type ModelExpenseRecordFilterInput = {
  and?: Array< ModelExpenseRecordFilterInput | null > | null,
  attachments?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateOfInput?: ModelStringInput | null,
  dateOfService?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  expenseCategories?: ModelStringInput | null,
  id?: ModelIDInput | null,
  invoiceNumber?: ModelStringInput | null,
  laborHoursOT?: ModelFloatInput | null,
  laborHoursST?: ModelFloatInput | null,
  laborRateOT?: ModelFloatInput | null,
  laborRateST?: ModelFloatInput | null,
  laborRateScheduleId?: ModelStringInput | null,
  laborRateScheduleName?: ModelStringInput | null,
  not?: ModelExpenseRecordFilterInput | null,
  or?: Array< ModelExpenseRecordFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmExpense?: ModelFloatInput | null,
  pmServiceLevelId?: ModelStringInput | null,
  pmServiceLevelName?: ModelStringInput | null,
  totalExpense?: ModelFloatInput | null,
  totalLaborCost?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  vendorId?: ModelStringInput | null,
  vendorName?: ModelStringInput | null,
  workDescription?: ModelStringInput | null,
};

export type ModelExpenseRecordConnection = {
  __typename: "ModelExpenseRecordConnection",
  items:  Array<ExpenseRecord | null >,
  nextToken?: string | null,
};

export type ModelFormFilterInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelFormFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogForm?: ModelBooleanInput | null,
  equipmentType?: ModelStringInput | null,
  formData?: ModelStringInput | null,
  formType?: ModelStringInput | null,
  id?: ModelIDInput | null,
  inspectionForm?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  noMachineHours?: ModelBooleanInput | null,
  noUMCounter?: ModelBooleanInput | null,
  not?: ModelFormFilterInput | null,
  or?: Array< ModelFormFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  umCounterLabel?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFormConnection = {
  __typename: "ModelFormConnection",
  items:  Array<Form | null >,
  nextToken?: string | null,
};

export type ModelFormTemplateGroupFilterInput = {
  and?: Array< ModelFormTemplateGroupFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelFormTemplateGroupFilterInput | null,
  or?: Array< ModelFormTemplateGroupFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFormTemplateGroupConnection = {
  __typename: "ModelFormTemplateGroupConnection",
  items:  Array<FormTemplateGroup | null >,
  nextToken?: string | null,
};

export type ModelFormTemplateFilterInput = {
  and?: Array< ModelFormTemplateFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  createdByCompanyOwnerId?: ModelStringInput | null,
  dailyServiceLogForm?: ModelBooleanInput | null,
  formTemplateGroupID?: ModelIDInput | null,
  id?: ModelIDInput | null,
  inspectionForm?: ModelBooleanInput | null,
  not?: ModelFormTemplateFilterInput | null,
  or?: Array< ModelFormTemplateFilterInput | null > | null,
  originalCompanyId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelBooleanInput | null,
  templateData?: ModelStringInput | null,
  templateName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFormTemplateConnection = {
  __typename: "ModelFormTemplateConnection",
  items:  Array<FormTemplate | null >,
  nextToken?: string | null,
};

export type ModelHelpSupportDocFilterInput = {
  and?: Array< ModelHelpSupportDocFilterInput | null > | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  docType?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelHelpSupportDocFilterInput | null,
  or?: Array< ModelHelpSupportDocFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  visibility?: ModelStringInput | null,
};

export type ModelHelpSupportDocConnection = {
  __typename: "ModelHelpSupportDocConnection",
  items:  Array<HelpSupportDoc | null >,
  nextToken?: string | null,
};

export type ModelInspectionReportFilterInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelInspectionReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtInspection?: ModelFloatInput | null,
  not?: ModelInspectionReportFilterInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelInspectionReportFilterInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  umCounterAtInspection?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type ModelInspectionReportConnection = {
  __typename: "ModelInspectionReportConnection",
  items:  Array<InspectionReport | null >,
  nextToken?: string | null,
};

export type ModelInvoiceFilterInput = {
  amount?: ModelFloatInput | null,
  and?: Array< ModelInvoiceFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  invoiceNumber?: ModelStringInput | null,
  lineItems?: ModelStringInput | null,
  not?: ModelInvoiceFilterInput | null,
  or?: Array< ModelInvoiceFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pdfUrl?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInvoiceConnection = {
  __typename: "ModelInvoiceConnection",
  items:  Array<Invoice | null >,
  nextToken?: string | null,
};

export type ModelLaborCategoryFilterInput = {
  and?: Array< ModelLaborCategoryFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  isActive?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  not?: ModelLaborCategoryFilterInput | null,
  or?: Array< ModelLaborCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLaborCategoryConnection = {
  __typename: "ModelLaborCategoryConnection",
  items:  Array<LaborCategory | null >,
  nextToken?: string | null,
};

export type ModelLaborRateFilterInput = {
  and?: Array< ModelLaborRateFilterInput | null > | null,
  categoryId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  effectiveDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelLaborRateFilterInput | null,
  or?: Array< ModelLaborRateFilterInput | null > | null,
  overtimeRate?: ModelFloatInput | null,
  owner?: ModelStringInput | null,
  standardRate?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLaborRateConnection = {
  __typename: "ModelLaborRateConnection",
  items:  Array<LaborRate | null >,
  nextToken?: string | null,
};

export type ModelLibraryPlanTemplateFilterInput = {
  and?: Array< ModelLibraryPlanTemplateFilterInput | null > | null,
  categories?: ModelStringInput | null,
  categoryCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  createdByAdminName?: ModelStringInput | null,
  cycleDuration?: ModelIntInput | null,
  description?: ModelStringInput | null,
  governingStandard?: ModelStringInput | null,
  id?: ModelIDInput | null,
  minimumTimeRequired?: ModelIntInput | null,
  name?: ModelStringInput | null,
  not?: ModelLibraryPlanTemplateFilterInput | null,
  or?: Array< ModelLibraryPlanTemplateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  status?: ModelStringInput | null,
  topicCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  workingDays?: ModelIntInput | null,
};

export type ModelLibraryPlanTemplateConnection = {
  __typename: "ModelLibraryPlanTemplateConnection",
  items:  Array<LibraryPlanTemplate | null >,
  nextToken?: string | null,
};

export type ModelLibraryTopicTemplateFilterInput = {
  and?: Array< ModelLibraryTopicTemplateFilterInput | null > | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelLibraryTopicTemplateFilterInput | null,
  or?: Array< ModelLibraryTopicTemplateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  style?: ModelStringInput | null,
  timeValue?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLibraryTopicTemplateConnection = {
  __typename: "ModelLibraryTopicTemplateConnection",
  items:  Array<LibraryTopicTemplate | null >,
  nextToken?: string | null,
};

export type ModelLocationFilterInput = {
  and?: Array< ModelLocationFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelLocationFilterInput | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  regionalDivisionId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items:  Array<Location | null >,
  nextToken?: string | null,
};

export type ModelModuleSubscriptionFilterInput = {
  activatedAt?: ModelStringInput | null,
  and?: Array< ModelModuleSubscriptionFilterInput | null > | null,
  cancelRequestedAt?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  effectiveEndDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  moduleKey?: ModelStringInput | null,
  monthlyRate?: ModelFloatInput | null,
  not?: ModelModuleSubscriptionFilterInput | null,
  or?: Array< ModelModuleSubscriptionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pricingModel?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelModuleSubscriptionConnection = {
  __typename: "ModelModuleSubscriptionConnection",
  items:  Array<ModuleSubscription | null >,
  nextToken?: string | null,
};

export type ModelPMConfigurationFilterInput = {
  and?: Array< ModelPMConfigurationFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dueSoonPercentage?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  laborCategoryId?: ModelStringInput | null,
  not?: ModelPMConfigurationFilterInput | null,
  or?: Array< ModelPMConfigurationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPMConfigurationConnection = {
  __typename: "ModelPMConfigurationConnection",
  items:  Array<PMConfiguration | null >,
  nextToken?: string | null,
};

export type ModelPMModuleContentFilterInput = {
  and?: Array< ModelPMModuleContentFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelPMModuleContentFilterInput | null,
  or?: Array< ModelPMModuleContentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceFormId?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPMModuleContentConnection = {
  __typename: "ModelPMModuleContentConnection",
  items:  Array<PMModuleContent | null >,
  nextToken?: string | null,
};

export type ModelPMNotificationSettingFilterInput = {
  and?: Array< ModelPMNotificationSettingFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  emailThresholdUM?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  lastNotificationSent?: ModelStringInput | null,
  not?: ModelPMNotificationSettingFilterInput | null,
  notificationFrequency?: ModelStringInput | null,
  or?: Array< ModelPMNotificationSettingFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  recipients?: ModelStringInput | null,
  serviceLevelId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPMNotificationSettingConnection = {
  __typename: "ModelPMNotificationSettingConnection",
  items:  Array<PMNotificationSetting | null >,
  nextToken?: string | null,
};

export type ModelPMPartsAndProcedureFilterInput = {
  and?: Array< ModelPMPartsAndProcedureFilterInput | null > | null,
  category?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByUserId?: ModelStringInput | null,
  createdByUserName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  itemName?: ModelStringInput | null,
  itemType?: ModelStringInput | null,
  manufacturer?: ModelStringInput | null,
  not?: ModelPMPartsAndProcedureFilterInput | null,
  or?: Array< ModelPMPartsAndProcedureFilterInput | null > | null,
  owner?: ModelStringInput | null,
  partNumber?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  pmConfigurationIds?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  quantity?: ModelFloatInput | null,
  sortOrder?: ModelIntInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  vendorId?: ModelStringInput | null,
  vendorName?: ModelStringInput | null,
};

export type ModelPMPartsAndProcedureConnection = {
  __typename: "ModelPMPartsAndProcedureConnection",
  items:  Array<PMPartsAndProcedure | null >,
  nextToken?: string | null,
};

export type ModelPMReportFilterInput = {
  actualUM?: ModelFloatInput | null,
  and?: Array< ModelPMReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  issueDescription?: ModelStringInput | null,
  issueTicketCreated?: ModelBooleanInput | null,
  issueTicketId?: ModelStringInput | null,
  laborHoursOT?: ModelFloatInput | null,
  laborHoursST?: ModelFloatInput | null,
  laborRateOT?: ModelFloatInput | null,
  laborRateST?: ModelFloatInput | null,
  laborRateScheduleId?: ModelStringInput | null,
  laborRateScheduleName?: ModelStringInput | null,
  not?: ModelPMReportFilterInput | null,
  or?: Array< ModelPMReportFilterInput | null > | null,
  owner?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  reportData?: ModelStringInput | null,
  serviceDate?: ModelStringInput | null,
  serviceLevelId?: ModelStringInput | null,
  serviceLevelName?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  status?: ModelStringInput | null,
  technicianId?: ModelStringInput | null,
  technicianName?: ModelStringInput | null,
  totalLaborCost?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPMReportConnection = {
  __typename: "ModelPMReportConnection",
  items:  Array<PMReport | null >,
  nextToken?: string | null,
};

export type ModelPMServiceLevelFilterInput = {
  and?: Array< ModelPMServiceLevelFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  intervalValue?: ModelFloatInput | null,
  lastServiceDate?: ModelStringInput | null,
  lastServiceUM?: ModelFloatInput | null,
  levelIdentifier?: ModelStringInput | null,
  not?: ModelPMServiceLevelFilterInput | null,
  or?: Array< ModelPMServiceLevelFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  pmServiceFormId?: ModelStringInput | null,
  serviceLevelAssignments?: ModelStringInput | null,
  targetUM?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPMServiceLevelConnection = {
  __typename: "ModelPMServiceLevelConnection",
  items:  Array<PMServiceLevel | null >,
  nextToken?: string | null,
};

export type ModelRegionalDivisionFilterInput = {
  and?: Array< ModelRegionalDivisionFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelRegionalDivisionFilterInput | null,
  or?: Array< ModelRegionalDivisionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRegionalDivisionConnection = {
  __typename: "ModelRegionalDivisionConnection",
  items:  Array<RegionalDivision | null >,
  nextToken?: string | null,
};

export type ModelReportAnswerFilterInput = {
  and?: Array< ModelReportAnswerFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelReportAnswerFilterInput | null,
  notes?: ModelStringInput | null,
  or?: Array< ModelReportAnswerFilterInput | null > | null,
  parentReportId?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptKey?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  promptType?: ModelStringInput | null,
  reportType?: ModelStringInput | null,
  sortOrder?: ModelIntInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  value?: ModelStringInput | null,
};

export type ModelReportAnswerConnection = {
  __typename: "ModelReportAnswerConnection",
  items:  Array<ReportAnswer | null >,
  nextToken?: string | null,
};

export type ModelReportFilterInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogReport?: ModelBooleanInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentLocationId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionStarted?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelReportFilterInput | null,
  or?: Array< ModelReportFilterInput | null > | null,
  signature?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userData?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userLocation?: ModelStringInput | null,
};

export type ModelReportConnection = {
  __typename: "ModelReportConnection",
  items:  Array<Report | null >,
  nextToken?: string | null,
};

export type ModelResourceLibraryFilterInput = {
  and?: Array< ModelResourceLibraryFilterInput | null > | null,
  companyOwnerId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelResourceLibraryFilterInput | null,
  or?: Array< ModelResourceLibraryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelResourceLibraryConnection = {
  __typename: "ModelResourceLibraryConnection",
  items:  Array<ResourceLibrary | null >,
  nextToken?: string | null,
};

export type ModelSavedReportConfigurationFilterInput = {
  and?: Array< ModelSavedReportConfigurationFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  compareDateRangeEnd?: ModelStringInput | null,
  compareDateRangeStart?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateRangeEnd?: ModelStringInput | null,
  dateRangeStart?: ModelStringInput | null,
  dateRangeType?: ModelStringInput | null,
  filtersJson?: ModelStringInput | null,
  groupByField?: ModelStringInput | null,
  id?: ModelIDInput | null,
  lastRunAt?: ModelStringInput | null,
  metricCategory?: ModelStringInput | null,
  metricKey?: ModelStringInput | null,
  not?: ModelSavedReportConfigurationFilterInput | null,
  or?: Array< ModelSavedReportConfigurationFilterInput | null > | null,
  reportName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  visualizationType?: ModelStringInput | null,
};

export type ModelSavedReportConfigurationConnection = {
  __typename: "ModelSavedReportConfigurationConnection",
  items:  Array<SavedReportConfiguration | null >,
  nextToken?: string | null,
};

export type ModelSensitiveUserInfoFilterInput = {
  and?: Array< ModelSensitiveUserInfoFilterInput | null > | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  driversLicenseClass?: ModelStringInput | null,
  driversLicenseExpirationDate?: ModelStringInput | null,
  driversLicenseNumber?: ModelStringInput | null,
  driversLicenseState?: ModelStringInput | null,
  emergencyContactName?: ModelStringInput | null,
  emergencyContactPhoneNumber?: ModelStringInput | null,
  emergencyContactRelationship?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelSensitiveUserInfoFilterInput | null,
  or?: Array< ModelSensitiveUserInfoFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSensitiveUserInfoConnection = {
  __typename: "ModelSensitiveUserInfoConnection",
  items:  Array<SensitiveUserInfo | null >,
  nextToken?: string | null,
};

export type ModelShiftReportFilterInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelShiftReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  not?: ModelShiftReportFilterInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelShiftReportFilterInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  shiftType?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type ModelShiftReportConnection = {
  __typename: "ModelShiftReportConnection",
  items:  Array<ShiftReport | null >,
  nextToken?: string | null,
};

export type ModelSingleUnitFilterInput = {
  and?: Array< ModelSingleUnitFilterInput | null > | null,
  annualProjectedUsage?: ModelFloatInput | null,
  aquisitionCost?: ModelFloatInput | null,
  aquisitionDate?: ModelStringInput | null,
  assignedTo?: ModelStringInput | null,
  axleConfiguration?: ModelStringInput | null,
  categoryId?: ModelIDInput | null,
  costTrackingModuleEnrollment?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  currentMachineHours?: ModelFloatInput | null,
  currentUMCounterValue?: ModelFloatInput | null,
  dailyServiceLogFormId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  dispositionDate?: ModelStringInput | null,
  dispositionReason?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  engineManufacturer?: ModelStringInput | null,
  engineModelNumber?: ModelStringInput | null,
  equipmentStatus?: ModelBooleanInput | null,
  extraUnitInfo?: ModelStringInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  inputByPerson?: ModelStringInput | null,
  inputDate?: ModelStringInput | null,
  lastDailyServiceDate?: ModelStringInput | null,
  lastInspectionDate?: ModelStringInput | null,
  lastServiceHours?: ModelFloatInput | null,
  licenseNumber?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtAquisition?: ModelFloatInput | null,
  machineUMCounterAtAquisition?: ModelFloatInput | null,
  manufactureDate?: ModelStringInput | null,
  manufacturerName?: ModelStringInput | null,
  modelNumber?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSingleUnitFilterInput | null,
  or?: Array< ModelSingleUnitFilterInput | null > | null,
  pmModuleEnrollment?: ModelBooleanInput | null,
  putInServiceDate?: ModelStringInput | null,
  removedFromServiceDate?: ModelStringInput | null,
  removedFromServiceReason?: ModelStringInput | null,
  replacedUMCounterHistory?: ModelStringInput | null,
  replacedUMCounterStatus?: ModelBooleanInput | null,
  replacedUMCounterValue?: ModelFloatInput | null,
  serialNumber?: ModelStringInput | null,
  tiresModuleEnrollment?: ModelBooleanInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  utilizationAdjustmentDays?: ModelFloatInput | null,
};

export type ModelSingleUnitConnection = {
  __typename: "ModelSingleUnitConnection",
  items:  Array<SingleUnit | null >,
  nextToken?: string | null,
};

export type ModelSkillAssignmentFilterInput = {
  and?: Array< ModelSkillAssignmentFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  evaluatedBy?: ModelStringInput | null,
  evaluatedByName?: ModelStringInput | null,
  evaluationDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelSkillAssignmentFilterInput | null,
  or?: Array< ModelSkillAssignmentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  skillLevel?: ModelStringInput | null,
  subCategoryId?: ModelStringInput | null,
  taskId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSkillAssignmentConnection = {
  __typename: "ModelSkillAssignmentConnection",
  items:  Array<SkillAssignment | null >,
  nextToken?: string | null,
};

export type ModelSkillCategoryFilterInput = {
  allowMachineNumber?: ModelBooleanInput | null,
  and?: Array< ModelSkillCategoryFilterInput | null > | null,
  classificationId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillCategoryFilterInput | null,
  or?: Array< ModelSkillCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSkillCategoryConnection = {
  __typename: "ModelSkillCategoryConnection",
  items:  Array<SkillCategory | null >,
  nextToken?: string | null,
};

export type ModelSkillLevelFilterInput = {
  and?: Array< ModelSkillLevelFilterInput | null > | null,
  color?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillLevelFilterInput | null,
  or?: Array< ModelSkillLevelFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sortOrder?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSkillLevelConnection = {
  __typename: "ModelSkillLevelConnection",
  items:  Array<SkillLevel | null >,
  nextToken?: string | null,
};

export type ModelSkillTaskFilterInput = {
  and?: Array< ModelSkillTaskFilterInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillTaskFilterInput | null,
  or?: Array< ModelSkillTaskFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSkillTaskConnection = {
  __typename: "ModelSkillTaskConnection",
  items:  Array<SkillTask | null >,
  nextToken?: string | null,
};

export type ModelSubCategoryFilterInput = {
  and?: Array< ModelSubCategoryFilterInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelSubCategoryFilterInput | null,
  or?: Array< ModelSubCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSubCategoryConnection = {
  __typename: "ModelSubCategoryConnection",
  items:  Array<SubCategory | null >,
  nextToken?: string | null,
};

export type ModelTireFilterInput = {
  and?: Array< ModelTireFilterInput | null > | null,
  assignedAxle?: ModelStringInput | null,
  assignedPosition?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentTirePressure?: ModelFloatInput | null,
  currentTreadDepth?: ModelFloatInput | null,
  dateInstalled?: ModelStringInput | null,
  dateUninstalled?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  id?: ModelIDInput | null,
  inflationMedium?: ModelStringInput | null,
  loadRating?: ModelFloatInput | null,
  loadRatingUnit?: ModelStringInput | null,
  minimumTreadDepth?: ModelFloatInput | null,
  name?: ModelStringInput | null,
  not?: ModelTireFilterInput | null,
  or?: Array< ModelTireFilterInput | null > | null,
  owner?: ModelStringInput | null,
  recommendedTirePressure?: ModelFloatInput | null,
  removedFromService?: ModelBooleanInput | null,
  removedFromServiceDate?: ModelStringInput | null,
  tireCategory?: ModelStringInput | null,
  tireManufacturer?: ModelStringInput | null,
  tireModel?: ModelStringInput | null,
  tireSize?: ModelStringInput | null,
  tireStatus?: ModelStringInput | null,
  treadDepthAtInstall?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTireConnection = {
  __typename: "ModelTireConnection",
  items:  Array<Tire | null >,
  nextToken?: string | null,
};

export type ModelTireReportFilterInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelTireReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  equipmentLocationId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionStarted?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelTireReportFilterInput | null,
  or?: Array< ModelTireReportFilterInput | null > | null,
  signature?: ModelStringInput | null,
  tireId?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userData?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userLocation?: ModelStringInput | null,
};

export type ModelTireReportConnection = {
  __typename: "ModelTireReportConnection",
  items:  Array<TireReport | null >,
  nextToken?: string | null,
};

export type ModelTrainingAffidavitFilterInput = {
  adminId?: ModelStringInput | null,
  affidavitDate?: ModelStringInput | null,
  and?: Array< ModelTrainingAffidavitFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  legalText?: ModelStringInput | null,
  nextDueDate?: ModelStringInput | null,
  not?: ModelTrainingAffidavitFilterInput | null,
  or?: Array< ModelTrainingAffidavitFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  signaturePath?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelTrainingAffidavitConnection = {
  __typename: "ModelTrainingAffidavitConnection",
  items:  Array<TrainingAffidavit | null >,
  nextToken?: string | null,
};

export type ModelTrainingCompletionFilterInput = {
  and?: Array< ModelTrainingCompletionFilterInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  completionDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  launched?: ModelBooleanInput | null,
  markedAsViewed?: ModelBooleanInput | null,
  not?: ModelTrainingCompletionFilterInput | null,
  or?: Array< ModelTrainingCompletionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  scheduleDate?: ModelStringInput | null,
  signaturePath?: ModelStringInput | null,
  timeValueMinutes?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelTrainingCompletionConnection = {
  __typename: "ModelTrainingCompletionConnection",
  items:  Array<TrainingCompletion | null >,
  nextToken?: string | null,
};

export type ModelTrainingEnrollmentFilterInput = {
  and?: Array< ModelTrainingEnrollmentFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enrolledDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  lastCompletionDate?: ModelStringInput | null,
  nextDueDate?: ModelStringInput | null,
  not?: ModelTrainingEnrollmentFilterInput | null,
  or?: Array< ModelTrainingEnrollmentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelTrainingEnrollmentConnection = {
  __typename: "ModelTrainingEnrollmentConnection",
  items:  Array<TrainingEnrollment | null >,
  nextToken?: string | null,
};

export type ModelTrainingPlanFilterInput = {
  and?: Array< ModelTrainingPlanFilterInput | null > | null,
  categories?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  cycleDuration?: ModelIntInput | null,
  governingStandard?: ModelStringInput | null,
  holidays?: ModelStringInput | null,
  id?: ModelIDInput | null,
  minimumTimeRequired?: ModelIntInput | null,
  name?: ModelStringInput | null,
  not?: ModelTrainingPlanFilterInput | null,
  or?: Array< ModelTrainingPlanFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  workingDays?: ModelIntInput | null,
};

export type ModelTrainingPlanConnection = {
  __typename: "ModelTrainingPlanConnection",
  items:  Array<TrainingPlan | null >,
  nextToken?: string | null,
};

export type ModelTrainingQuizResponseFilterInput = {
  and?: Array< ModelTrainingQuizResponseFilterInput | null > | null,
  attemptNumber?: ModelIntInput | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  cycleStartDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelTrainingQuizResponseFilterInput | null,
  or?: Array< ModelTrainingQuizResponseFilterInput | null > | null,
  owner?: ModelStringInput | null,
  passed?: ModelBooleanInput | null,
  planId?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  score?: ModelIntInput | null,
  signaturePath?: ModelStringInput | null,
  totalQuestions?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelTrainingQuizResponseConnection = {
  __typename: "ModelTrainingQuizResponseConnection",
  items:  Array<TrainingQuizResponse | null >,
  nextToken?: string | null,
};

export type ModelTrainingScheduleFilterInput = {
  and?: Array< ModelTrainingScheduleFilterInput | null > | null,
  assignedUserId?: ModelStringInput | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dayNumber?: ModelIntInput | null,
  id?: ModelIDInput | null,
  locked?: ModelBooleanInput | null,
  not?: ModelTrainingScheduleFilterInput | null,
  or?: Array< ModelTrainingScheduleFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  scheduledDate?: ModelStringInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTrainingScheduleConnection = {
  __typename: "ModelTrainingScheduleConnection",
  items:  Array<TrainingSchedule | null >,
  nextToken?: string | null,
};

export type ModelTrainingTopicFilterInput = {
  and?: Array< ModelTrainingTopicFilterInput | null > | null,
  categoryIds?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  companyResourceId?: ModelStringInput | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelTrainingTopicFilterInput | null,
  or?: Array< ModelTrainingTopicFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planIds?: ModelStringInput | null,
  style?: ModelStringInput | null,
  timeValue?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTrainingTopicConnection = {
  __typename: "ModelTrainingTopicConnection",
  items:  Array<TrainingTopic | null >,
  nextToken?: string | null,
};

export type ModelUnitExpenseBudgetFilterInput = {
  and?: Array< ModelUnitExpenseBudgetFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expenseCategoryId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelUnitExpenseBudgetFilterInput | null,
  or?: Array< ModelUnitExpenseBudgetFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelUnitExpenseBudgetConnection = {
  __typename: "ModelUnitExpenseBudgetConnection",
  items:  Array<UnitExpenseBudget | null >,
  nextToken?: string | null,
};

export type ModelUserFileFilterInput = {
  and?: Array< ModelUserFileFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  id?: ModelIDInput | null,
  not?: ModelUserFileFilterInput | null,
  or?: Array< ModelUserFileFilterInput | null > | null,
  owner?: ModelStringInput | null,
  s3Path?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  uploadedBy?: ModelStringInput | null,
  uploadedByName?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelUserFileConnection = {
  __typename: "ModelUserFileConnection",
  items:  Array<UserFile | null >,
  nextToken?: string | null,
};

export type ModelUserReportFavoriteFilterInput = {
  and?: Array< ModelUserReportFavoriteFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelUserReportFavoriteFilterInput | null,
  or?: Array< ModelUserReportFavoriteFilterInput | null > | null,
  reportTypeKey?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelUserReportFavoriteConnection = {
  __typename: "ModelUserReportFavoriteConnection",
  items:  Array<UserReportFavorite | null >,
  nextToken?: string | null,
};

export type ModelUserSkillReportFilterInput = {
  and?: Array< ModelUserSkillReportFilterInput | null > | null,
  assessorId?: ModelStringInput | null,
  assessorName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  not?: ModelUserSkillReportFilterInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelUserSkillReportFilterInput | null > | null,
  passFailStatus?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  qualificationLevel?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  skillCategory?: ModelStringInput | null,
  skillName?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type ModelUserSkillReportConnection = {
  __typename: "ModelUserSkillReportConnection",
  items:  Array<UserSkillReport | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  and?: Array< ModelUserFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contactPhoneNumber?: ModelStringInput | null,
  contactPhoneType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentJobClassification?: ModelStringInput | null,
  dateOfHire?: ModelStringInput | null,
  discrepancyNotification?: ModelBooleanInput | null,
  discrepancyNotificationTypes?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  driversLicenseStatus?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  globalLocationPermission?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  inputByPerson?: ModelStringInput | null,
  inputDate?: ModelStringInput | null,
  locationAssignment?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelUserFilterInput | null,
  notesAboutUser?: ModelStringInput | null,
  onHighwayEligibility?: ModelBooleanInput | null,
  or?: Array< ModelUserFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  personalIdentification?: ModelStringInput | null,
  pmNotification?: ModelBooleanInput | null,
  pmNotificationTypes?: ModelStringInput | null,
  position?: ModelStringInput | null,
  regionalAssignment?: ModelStringInput | null,
  role?: ModelStringInput | null,
  safetyLessons?: ModelStringInput | null,
  skillTrackingModuleEnrollment?: ModelBooleanInput | null,
  trainingModuleEnrollment?: ModelBooleanInput | null,
  trainingNotification?: ModelBooleanInput | null,
  trainingNotificationTypes?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userPhoto?: ModelStringInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelVendorListFilterInput = {
  address?: ModelStringInput | null,
  and?: Array< ModelVendorListFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  faxNumber?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelVendorListFilterInput | null,
  or?: Array< ModelVendorListFilterInput | null > | null,
  owner?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  repName?: ModelStringInput | null,
  repPhoneNumber?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelVendorListConnection = {
  __typename: "ModelVendorListConnection",
  items:  Array<VendorList | null >,
  nextToken?: string | null,
};

export type ModelVideoFilterInput = {
  and?: Array< ModelVideoFilterInput | null > | null,
  assignedSafetyLesson?: ModelStringInput | null,
  contentPath?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelVideoFilterInput | null,
  or?: Array< ModelVideoFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  safetyLesson?: ModelBooleanInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelVideoConnection = {
  __typename: "ModelVideoConnection",
  items:  Array<Video | null >,
  nextToken?: string | null,
};

export type ModelArchivedDiscrepancyConditionInput = {
  and?: Array< ModelArchivedDiscrepancyConditionInput | null > | null,
  archivedDate?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  initialStatus?: ModelStringInput | null,
  log?: ModelStringInput | null,
  not?: ModelArchivedDiscrepancyConditionInput | null,
  or?: Array< ModelArchivedDiscrepancyConditionInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  questionIndex?: ModelIntInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateArchivedDiscrepancyInput = {
  archivedDate?: string | null,
  companyId: string,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId: string,
  equipmentName: string,
  id?: string | null,
  initialStatus?: string | null,
  log?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status: string,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type ModelAuditLogConditionInput = {
  action?: ModelStringInput | null,
  and?: Array< ModelAuditLogConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  details?: ModelStringInput | null,
  not?: ModelAuditLogConditionInput | null,
  or?: Array< ModelAuditLogConditionInput | null > | null,
  resourceId?: ModelStringInput | null,
  resourceName?: ModelStringInput | null,
  resourceType?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
};

export type CreateAuditLogInput = {
  action: string,
  companyId: string,
  createdAt?: string | null,
  details?: string | null,
  id?: string | null,
  resourceId: string,
  resourceName?: string | null,
  resourceType: string,
  ttl?: number | null,
  userId: string,
  userName?: string | null,
};

export type ModelAxleBlueprintConditionInput = {
  and?: Array< ModelAxleBlueprintConditionInput | null > | null,
  axles?: ModelStringInput | null,
  centerlineLength?: ModelIntInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelAxleBlueprintConditionInput | null,
  or?: Array< ModelAxleBlueprintConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAxleBlueprintInput = {
  axles: string,
  centerlineLength: number,
  companyId: string,
  description?: string | null,
  id?: string | null,
  name: string,
};

export type ModelBillingRateConditionInput = {
  and?: Array< ModelBillingRateConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelBillingRateConditionInput | null,
  or?: Array< ModelBillingRateConditionInput | null > | null,
  owner?: ModelStringInput | null,
  ratePerCostTracking?: ModelFloatInput | null,
  ratePerEquipment?: ModelFloatInput | null,
  ratePerPM?: ModelFloatInput | null,
  ratePerSafetyEnrollment?: ModelFloatInput | null,
  ratePerSkillQualification?: ModelFloatInput | null,
  ratePerTireMaint?: ModelFloatInput | null,
  ratePerUser?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBillingRateInput = {
  companyId: string,
  id?: string | null,
  ratePerCostTracking?: number | null,
  ratePerEquipment?: number | null,
  ratePerPM?: number | null,
  ratePerSafetyEnrollment?: number | null,
  ratePerSkillQualification?: number | null,
  ratePerTireMaint?: number | null,
  ratePerUser?: number | null,
};

export type ModelBusinessAdminConditionInput = {
  and?: Array< ModelBusinessAdminConditionInput | null > | null,
  cognitoId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelBusinessAdminConditionInput | null,
  or?: Array< ModelBusinessAdminConditionInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  role?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBusinessAdminInput = {
  cognitoId: string,
  domain?: string | null,
  email: string,
  id?: string | null,
  name: string,
  permissions?: string | null,
  role: string,
};

export type ModelChangeLogEntryConditionInput = {
  and?: Array< ModelChangeLogEntryConditionInput | null > | null,
  changedBy?: ModelStringInput | null,
  changedByName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  newValue?: ModelStringInput | null,
  not?: ModelChangeLogEntryConditionInput | null,
  oldValue?: ModelStringInput | null,
  or?: Array< ModelChangeLogEntryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateChangeLogEntryInput = {
  changedBy: string,
  changedByName: string,
  companyId: string,
  createdAt?: string | null,
  description: string,
  fieldName: string,
  id?: string | null,
  newValue?: string | null,
  oldValue?: string | null,
  userId: string,
};

export type ModelClassificationConditionInput = {
  and?: Array< ModelClassificationConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelClassificationConditionInput | null,
  or?: Array< ModelClassificationConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateClassificationInput = {
  companyId: string,
  id?: string | null,
  name: string,
};

export type ModelCompanyConditionInput = {
  accountNumber?: ModelStringInput | null,
  accountOrigin?: ModelStringInput | null,
  accountStatus?: ModelStringInput | null,
  addOnGracePeriodEndDate?: ModelStringInput | null,
  and?: Array< ModelCompanyConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  assignedRep?: ModelStringInput | null,
  billingAnchorDay?: ModelIntInput | null,
  billingContactAddress?: ModelStringInput | null,
  billingContactEmail?: ModelStringInput | null,
  billingContactName?: ModelStringInput | null,
  billingContactPhone?: ModelStringInput | null,
  billingCycle?: ModelStringInput | null,
  businessType?: ModelStringInput | null,
  cancelEffectiveDate?: ModelStringInput | null,
  cancelReason?: ModelStringInput | null,
  cancelReasonNote?: ModelStringInput | null,
  cancelRequestedAt?: ModelStringInput | null,
  companyOwnerId?: ModelStringInput | null,
  coreMonthlyRate?: ModelFloatInput | null,
  costTrackingModuleEnrollment?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  dataRetentionEndDate?: ModelStringInput | null,
  description?: ModelStringInput | null,
  gracePeriodEndDate?: ModelStringInput | null,
  industryNAICS?: ModelStringInput | null,
  industrySIC?: ModelStringInput | null,
  initialContactDate?: ModelStringInput | null,
  initialStarterPackageEnrollment?: ModelBooleanInput | null,
  logo?: ModelStringInput | null,
  maxNumberEquipment?: ModelIntInput | null,
  maxNumberUsers?: ModelIntInput | null,
  name?: ModelStringInput | null,
  nextBillingDate?: ModelStringInput | null,
  not?: ModelCompanyConditionInput | null,
  notes?: ModelStringInput | null,
  numberOfUsers?: ModelIntInput | null,
  or?: Array< ModelCompanyConditionInput | null > | null,
  paidStartDate?: ModelStringInput | null,
  paymentFailedAt?: ModelStringInput | null,
  paymentMethod?: ModelStringInput | null,
  pmModuleEnrollment?: ModelBooleanInput | null,
  primaryContactEmail?: ModelStringInput | null,
  primaryContactName?: ModelStringInput | null,
  primaryContactPhone?: ModelStringInput | null,
  primaryContactPosition?: ModelStringInput | null,
  primaryLocation?: ModelStringInput | null,
  referredBy?: ModelStringInput | null,
  retryAttempts?: ModelIntInput | null,
  safetyComplianceStandard?: ModelStringInput | null,
  secondaryContactEmail?: ModelStringInput | null,
  secondaryContactName?: ModelStringInput | null,
  secondaryContactPhone?: ModelStringInput | null,
  secondaryContactPosition?: ModelStringInput | null,
  skillTrackingModuleEnrollment?: ModelBooleanInput | null,
  starterPackage?: ModelStringInput | null,
  status?: ModelStringInput | null,
  subscriptionExpiration?: ModelStringInput | null,
  subscriptionType?: ModelStringInput | null,
  tiresModuleEnrollment?: ModelBooleanInput | null,
  trainingModuleEnrollment?: ModelBooleanInput | null,
  trialEndDate?: ModelStringInput | null,
  trialStartDate?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateCompanyInput = {
  accountNumber?: string | null,
  accountOrigin?: string | null,
  accountStatus?: string | null,
  addOnGracePeriodEndDate?: string | null,
  archived?: boolean | null,
  assignedRep?: string | null,
  billingAnchorDay?: number | null,
  billingContactAddress?: string | null,
  billingContactEmail?: string | null,
  billingContactName?: string | null,
  billingContactPhone?: string | null,
  billingCycle?: string | null,
  businessType?: string | null,
  cancelEffectiveDate?: string | null,
  cancelReason?: string | null,
  cancelReasonNote?: string | null,
  cancelRequestedAt?: string | null,
  companyOwnerId?: string | null,
  coreMonthlyRate?: number | null,
  costTrackingModuleEnrollment?: boolean | null,
  dataRetentionEndDate?: string | null,
  description?: string | null,
  gracePeriodEndDate?: string | null,
  id?: string | null,
  industryNAICS?: string | null,
  industrySIC?: string | null,
  initialContactDate?: string | null,
  initialStarterPackageEnrollment?: boolean | null,
  logo?: string | null,
  maxNumberEquipment: number,
  maxNumberUsers: number,
  name: string,
  nextBillingDate?: string | null,
  notes?: string | null,
  numberOfUsers?: number | null,
  paidStartDate?: string | null,
  paymentFailedAt?: string | null,
  paymentMethod?: string | null,
  pmModuleEnrollment?: boolean | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  primaryContactPhone?: string | null,
  primaryContactPosition?: string | null,
  primaryLocation?: string | null,
  referredBy?: string | null,
  retryAttempts?: number | null,
  safetyComplianceStandard?: string | null,
  secondaryContactEmail?: string | null,
  secondaryContactName?: string | null,
  secondaryContactPhone?: string | null,
  secondaryContactPosition?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  starterPackage?: string | null,
  status?: string | null,
  subscriptionExpiration: string,
  subscriptionType: string,
  tiresModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trialEndDate?: string | null,
  trialStartDate?: string | null,
  type?: string | null,
};

export type ModelCompanyNoteConditionInput = {
  and?: Array< ModelCompanyNoteConditionInput | null > | null,
  authorName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelCompanyNoteConditionInput | null,
  or?: Array< ModelCompanyNoteConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateCompanyNoteInput = {
  authorName: string,
  companyId: string,
  content: string,
  createdAt?: string | null,
  id?: string | null,
};

export type ModelCompanyOwnerConditionInput = {
  and?: Array< ModelCompanyOwnerConditionInput | null > | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contactPhoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  discrepancyNotification?: ModelBooleanInput | null,
  discrepancyNotificationTypes?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelCompanyOwnerConditionInput | null,
  or?: Array< ModelCompanyOwnerConditionInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  pmNotification?: ModelBooleanInput | null,
  pmNotificationTypes?: ModelStringInput | null,
  role?: ModelStringInput | null,
  siteAdmin?: ModelBooleanInput | null,
  subscriptionType?: ModelStringInput | null,
  trainingNotification?: ModelBooleanInput | null,
  trainingNotificationTypes?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateCompanyOwnerInput = {
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  email: string,
  id?: string | null,
  name: string,
  permissions?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  role?: string | null,
  siteAdmin: boolean,
  subscriptionType: string,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
};

export type ModelCompanyResourceConditionInput = {
  and?: Array< ModelCompanyResourceConditionInput | null > | null,
  category?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  not?: ModelCompanyResourceConditionInput | null,
  or?: Array< ModelCompanyResourceConditionInput | null > | null,
  owner?: ModelStringInput | null,
  title?: ModelStringInput | null,
  trainingTopicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  uploadedByUserId?: ModelStringInput | null,
  uploadedByUserName?: ModelStringInput | null,
};

export type CreateCompanyResourceInput = {
  category: string,
  companyId: string,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  description?: string | null,
  fileType: string,
  folderName?: string | null,
  id?: string | null,
  title: string,
  trainingTopicId?: string | null,
  uploadedByUserId?: string | null,
  uploadedByUserName?: string | null,
};

export type ModelDOTInspectionReportConditionInput = {
  and?: Array< ModelDOTInspectionReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  complianceStatus?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dotInspectionType?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  inspectorCertificationId?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  not?: ModelDOTInspectionReportConditionInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelDOTInspectionReportConditionInput | null > | null,
  photos?: ModelStringInput | null,
  regulatoryStandard?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  vehicleLicensePlate?: ModelStringInput | null,
  vehicleVIN?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type CreateDOTInspectionReportInput = {
  companyId: string,
  complianceStatus?: string | null,
  createdAt?: string | null,
  dotInspectionType?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id?: string | null,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  inspectorCertificationId?: string | null,
  locationId?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  regulatoryStandard?: string | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId: string,
  userName?: string | null,
  vehicleLicensePlate?: string | null,
  vehicleVIN?: string | null,
  warnCount?: number | null,
};

export type ModelDailyServiceReportConditionInput = {
  and?: Array< ModelDailyServiceReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogFormId?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtService?: ModelFloatInput | null,
  not?: ModelDailyServiceReportConditionInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelDailyServiceReportConditionInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  umCounterAtService?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type CreateDailyServiceReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  dailyServiceLogFormId?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id?: string | null,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtService?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtService?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type ModelDiscrepancyConditionInput = {
  and?: Array< ModelDiscrepancyConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  initialStatus?: ModelStringInput | null,
  log?: ModelStringInput | null,
  not?: ModelDiscrepancyConditionInput | null,
  or?: Array< ModelDiscrepancyConditionInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  questionIndex?: ModelIntInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDiscrepancyInput = {
  companyId: string,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId: string,
  equipmentName: string,
  id?: string | null,
  initialStatus?: string | null,
  log?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status: string,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type ModelDocumentConditionInput = {
  and?: Array< ModelDocumentConditionInput | null > | null,
  assignedSafetyLesson?: ModelStringInput | null,
  contentPath?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  not?: ModelDocumentConditionInput | null,
  or?: Array< ModelDocumentConditionInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  safetyLesson?: ModelBooleanInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDocumentInput = {
  assignedSafetyLesson?: string | null,
  contentPath: string,
  folderName?: string | null,
  id?: string | null,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title: string,
};

export type ModelEquipmentConditionInput = {
  and?: Array< ModelEquipmentConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelEquipmentConditionInput | null,
  or?: Array< ModelEquipmentConditionInput | null > | null,
  units?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateEquipmentInput = {
  companyId: string,
  formId: string,
  id?: string | null,
  image?: string | null,
  name: string,
  units?: string | null,
};

export type ModelEquipmentCategoryConditionInput = {
  and?: Array< ModelEquipmentCategoryConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelEquipmentCategoryConditionInput | null,
  or?: Array< ModelEquipmentCategoryConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateEquipmentCategoryInput = {
  companyId: string,
  formId: string,
  id?: string | null,
  image?: string | null,
  name: string,
};

export type ModelErrorsConditionInput = {
  and?: Array< ModelErrorsConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  errors?: ModelStringInput | null,
  not?: ModelErrorsConditionInput | null,
  or?: Array< ModelErrorsConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateErrorsInput = {
  errors: string,
  id?: string | null,
};

export type ModelExpenseCategoryConditionInput = {
  and?: Array< ModelExpenseCategoryConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelExpenseCategoryConditionInput | null,
  or?: Array< ModelExpenseCategoryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateExpenseCategoryInput = {
  companyId: string,
  id?: string | null,
  name: string,
  startingBalance?: number | null,
};

export type ModelExpenseRecordConditionInput = {
  and?: Array< ModelExpenseRecordConditionInput | null > | null,
  attachments?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateOfInput?: ModelStringInput | null,
  dateOfService?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  expenseCategories?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  laborHoursOT?: ModelFloatInput | null,
  laborHoursST?: ModelFloatInput | null,
  laborRateOT?: ModelFloatInput | null,
  laborRateST?: ModelFloatInput | null,
  laborRateScheduleId?: ModelStringInput | null,
  laborRateScheduleName?: ModelStringInput | null,
  not?: ModelExpenseRecordConditionInput | null,
  or?: Array< ModelExpenseRecordConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pmExpense?: ModelFloatInput | null,
  pmServiceLevelId?: ModelStringInput | null,
  pmServiceLevelName?: ModelStringInput | null,
  totalExpense?: ModelFloatInput | null,
  totalLaborCost?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  vendorId?: ModelStringInput | null,
  vendorName?: ModelStringInput | null,
  workDescription?: ModelStringInput | null,
};

export type CreateExpenseRecordInput = {
  attachments?: Array< string | null > | null,
  companyId: string,
  dateOfInput: string,
  dateOfService: string,
  equipmentCategoryId?: string | null,
  expenseCategories?: string | null,
  id?: string | null,
  invoiceNumber?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  pmExpense?: number | null,
  pmServiceLevelId?: string | null,
  pmServiceLevelName?: string | null,
  totalExpense: number,
  totalLaborCost?: number | null,
  unitId: string,
  vendorId?: string | null,
  vendorName?: string | null,
  workDescription?: string | null,
};

export type ModelFormConditionInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelFormConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogForm?: ModelBooleanInput | null,
  equipmentType?: ModelStringInput | null,
  formData?: ModelStringInput | null,
  formType?: ModelStringInput | null,
  inspectionForm?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  noMachineHours?: ModelBooleanInput | null,
  noUMCounter?: ModelBooleanInput | null,
  not?: ModelFormConditionInput | null,
  or?: Array< ModelFormConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  umCounterLabel?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateFormInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  dailyServiceLogForm?: boolean | null,
  equipmentType?: string | null,
  formData: string,
  formType?: string | null,
  id?: string | null,
  inspectionForm?: boolean | null,
  name: string,
  noMachineHours?: boolean | null,
  noUMCounter?: boolean | null,
  pmServiceScheduleForm?: boolean | null,
  status?: string | null,
  umCounterLabel?: string | null,
};

export type ModelFormTemplateConditionInput = {
  and?: Array< ModelFormTemplateConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  createdByCompanyOwnerId?: ModelStringInput | null,
  dailyServiceLogForm?: ModelBooleanInput | null,
  formTemplateGroupID?: ModelIDInput | null,
  inspectionForm?: ModelBooleanInput | null,
  not?: ModelFormTemplateConditionInput | null,
  or?: Array< ModelFormTemplateConditionInput | null > | null,
  originalCompanyId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelBooleanInput | null,
  templateData?: ModelStringInput | null,
  templateName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateFormTemplateInput = {
  createdByCompanyOwnerId?: string | null,
  dailyServiceLogForm?: boolean | null,
  formTemplateGroupID?: string | null,
  id?: string | null,
  inspectionForm?: boolean | null,
  originalCompanyId?: string | null,
  pmServiceScheduleForm?: boolean | null,
  templateData: string,
  templateName: string,
};

export type ModelFormTemplateGroupConditionInput = {
  and?: Array< ModelFormTemplateGroupConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelFormTemplateGroupConditionInput | null,
  or?: Array< ModelFormTemplateGroupConditionInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateFormTemplateGroupInput = {
  description?: string | null,
  id?: string | null,
  name: string,
  resourceLibraryID?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
};

export type ModelHelpSupportDocConditionInput = {
  and?: Array< ModelHelpSupportDocConditionInput | null > | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  docType?: ModelStringInput | null,
  not?: ModelHelpSupportDocConditionInput | null,
  or?: Array< ModelHelpSupportDocConditionInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  visibility?: ModelStringInput | null,
};

export type CreateHelpSupportDocInput = {
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdByAdminId: string,
  description?: string | null,
  docType: string,
  id?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  status: string,
  title: string,
  visibility: string,
};

export type ModelInspectionReportConditionInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelInspectionReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtInspection?: ModelFloatInput | null,
  not?: ModelInspectionReportConditionInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelInspectionReportConditionInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  umCounterAtInspection?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type CreateInspectionReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id?: string | null,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtInspection?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtInspection?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type ModelInvoiceConditionInput = {
  amount?: ModelFloatInput | null,
  and?: Array< ModelInvoiceConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  lineItems?: ModelStringInput | null,
  not?: ModelInvoiceConditionInput | null,
  or?: Array< ModelInvoiceConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pdfUrl?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateInvoiceInput = {
  amount: number,
  companyId: string,
  date: string,
  description: string,
  id?: string | null,
  invoiceNumber: string,
  lineItems?: string | null,
  pdfUrl?: string | null,
  status: string,
};

export type ModelLaborCategoryConditionInput = {
  and?: Array< ModelLaborCategoryConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  not?: ModelLaborCategoryConditionInput | null,
  or?: Array< ModelLaborCategoryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateLaborCategoryInput = {
  companyId: string,
  id?: string | null,
  isActive: boolean,
  name: string,
};

export type ModelLaborRateConditionInput = {
  and?: Array< ModelLaborRateConditionInput | null > | null,
  categoryId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  effectiveDate?: ModelStringInput | null,
  not?: ModelLaborRateConditionInput | null,
  or?: Array< ModelLaborRateConditionInput | null > | null,
  overtimeRate?: ModelFloatInput | null,
  owner?: ModelStringInput | null,
  standardRate?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateLaborRateInput = {
  categoryId: string,
  effectiveDate: string,
  id?: string | null,
  overtimeRate: number,
  standardRate: number,
};

export type ModelLibraryPlanTemplateConditionInput = {
  and?: Array< ModelLibraryPlanTemplateConditionInput | null > | null,
  categories?: ModelStringInput | null,
  categoryCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  createdByAdminName?: ModelStringInput | null,
  cycleDuration?: ModelIntInput | null,
  description?: ModelStringInput | null,
  governingStandard?: ModelStringInput | null,
  minimumTimeRequired?: ModelIntInput | null,
  name?: ModelStringInput | null,
  not?: ModelLibraryPlanTemplateConditionInput | null,
  or?: Array< ModelLibraryPlanTemplateConditionInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  status?: ModelStringInput | null,
  topicCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  workingDays?: ModelIntInput | null,
};

export type CreateLibraryPlanTemplateInput = {
  categories: string,
  categoryCount?: number | null,
  createdByAdminId: string,
  createdByAdminName?: string | null,
  cycleDuration: number,
  description?: string | null,
  governingStandard: string,
  id?: string | null,
  minimumTimeRequired: number,
  name: string,
  sharedWithCompanyIds?: Array< string | null > | null,
  status: string,
  topicCount?: number | null,
  workingDays: Array< number | null >,
};

export type ModelLibraryTopicTemplateConditionInput = {
  and?: Array< ModelLibraryTopicTemplateConditionInput | null > | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByAdminId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelLibraryTopicTemplateConditionInput | null,
  or?: Array< ModelLibraryTopicTemplateConditionInput | null > | null,
  owner?: ModelStringInput | null,
  style?: ModelStringInput | null,
  timeValue?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateLibraryTopicTemplateInput = {
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdByAdminId: string,
  description: string,
  id?: string | null,
  style: string,
  timeValue: number,
  topicId: string,
};

export type ModelLocationConditionInput = {
  and?: Array< ModelLocationConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelLocationConditionInput | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  owner?: ModelStringInput | null,
  regionalDivisionId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateLocationInput = {
  companyId: string,
  description?: string | null,
  id?: string | null,
  name: string,
  regionalDivisionId: string,
};

export type ModelModuleSubscriptionConditionInput = {
  activatedAt?: ModelStringInput | null,
  and?: Array< ModelModuleSubscriptionConditionInput | null > | null,
  cancelRequestedAt?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  effectiveEndDate?: ModelStringInput | null,
  moduleKey?: ModelStringInput | null,
  monthlyRate?: ModelFloatInput | null,
  not?: ModelModuleSubscriptionConditionInput | null,
  or?: Array< ModelModuleSubscriptionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pricingModel?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateModuleSubscriptionInput = {
  activatedAt: string,
  cancelRequestedAt?: string | null,
  companyId: string,
  effectiveEndDate?: string | null,
  id?: string | null,
  moduleKey: string,
  monthlyRate: number,
  pricingModel: string,
  status: string,
};

export type ModelPMConfigurationConditionInput = {
  and?: Array< ModelPMConfigurationConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dueSoonPercentage?: ModelFloatInput | null,
  laborCategoryId?: ModelStringInput | null,
  not?: ModelPMConfigurationConditionInput | null,
  or?: Array< ModelPMConfigurationConditionInput | null > | null,
  owner?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreatePMConfigurationInput = {
  companyId: string,
  dueSoonPercentage?: number | null,
  id?: string | null,
  laborCategoryId?: string | null,
  unitId: string,
  unitOfMeasure: string,
};

export type ModelPMModuleContentConditionInput = {
  and?: Array< ModelPMModuleContentConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelPMModuleContentConditionInput | null,
  or?: Array< ModelPMModuleContentConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceFormId?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreatePMModuleContentInput = {
  id?: string | null,
  pmServiceFormId: string,
  unitId: string,
};

export type ModelPMNotificationSettingConditionInput = {
  and?: Array< ModelPMNotificationSettingConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  emailThresholdUM?: ModelFloatInput | null,
  lastNotificationSent?: ModelStringInput | null,
  not?: ModelPMNotificationSettingConditionInput | null,
  notificationFrequency?: ModelStringInput | null,
  or?: Array< ModelPMNotificationSettingConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  recipients?: ModelStringInput | null,
  serviceLevelId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreatePMNotificationSettingInput = {
  emailThresholdUM: number,
  id?: string | null,
  lastNotificationSent?: string | null,
  notificationFrequency: string,
  pmConfigurationId: string,
  recipients?: Array< string | null > | null,
  serviceLevelId?: string | null,
};

export type ModelPMPartsAndProcedureConditionInput = {
  and?: Array< ModelPMPartsAndProcedureConditionInput | null > | null,
  category?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByUserId?: ModelStringInput | null,
  createdByUserName?: ModelStringInput | null,
  itemName?: ModelStringInput | null,
  itemType?: ModelStringInput | null,
  manufacturer?: ModelStringInput | null,
  not?: ModelPMPartsAndProcedureConditionInput | null,
  or?: Array< ModelPMPartsAndProcedureConditionInput | null > | null,
  owner?: ModelStringInput | null,
  partNumber?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  pmConfigurationIds?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  quantity?: ModelFloatInput | null,
  sortOrder?: ModelIntInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  vendorId?: ModelStringInput | null,
  vendorName?: ModelStringInput | null,
};

export type CreatePMPartsAndProcedureInput = {
  category?: string | null,
  companyId?: string | null,
  createdByUserId?: string | null,
  createdByUserName?: string | null,
  id?: string | null,
  itemName: string,
  itemType?: string | null,
  manufacturer?: string | null,
  partNumber?: string | null,
  pmConfigurationId?: string | null,
  pmConfigurationIds?: Array< string | null > | null,
  price?: number | null,
  quantity?: number | null,
  sortOrder?: number | null,
  unitOfMeasure?: string | null,
  vendorId?: string | null,
  vendorName?: string | null,
};

export type ModelPMReportConditionInput = {
  actualUM?: ModelFloatInput | null,
  and?: Array< ModelPMReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  issueDescription?: ModelStringInput | null,
  issueTicketCreated?: ModelBooleanInput | null,
  issueTicketId?: ModelStringInput | null,
  laborHoursOT?: ModelFloatInput | null,
  laborHoursST?: ModelFloatInput | null,
  laborRateOT?: ModelFloatInput | null,
  laborRateST?: ModelFloatInput | null,
  laborRateScheduleId?: ModelStringInput | null,
  laborRateScheduleName?: ModelStringInput | null,
  not?: ModelPMReportConditionInput | null,
  or?: Array< ModelPMReportConditionInput | null > | null,
  owner?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  reportData?: ModelStringInput | null,
  serviceDate?: ModelStringInput | null,
  serviceLevelId?: ModelStringInput | null,
  serviceLevelName?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  status?: ModelStringInput | null,
  technicianId?: ModelStringInput | null,
  technicianName?: ModelStringInput | null,
  totalLaborCost?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreatePMReportInput = {
  actualUM: number,
  companyId: string,
  createdAt?: string | null,
  id?: string | null,
  issueDescription?: string | null,
  issueTicketCreated?: boolean | null,
  issueTicketId?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  photos?: Array< string | null > | null,
  pmConfigurationId: string,
  reportData?: string | null,
  serviceDate: string,
  serviceLevelId: string,
  serviceLevelName?: string | null,
  signature?: string | null,
  status?: string | null,
  technicianId: string,
  technicianName?: string | null,
  totalLaborCost?: number | null,
  unitId: string,
};

export type ModelPMServiceLevelConditionInput = {
  and?: Array< ModelPMServiceLevelConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  intervalValue?: ModelFloatInput | null,
  lastServiceDate?: ModelStringInput | null,
  lastServiceUM?: ModelFloatInput | null,
  levelIdentifier?: ModelStringInput | null,
  not?: ModelPMServiceLevelConditionInput | null,
  or?: Array< ModelPMServiceLevelConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelStringInput | null,
  pmServiceFormId?: ModelStringInput | null,
  serviceLevelAssignments?: ModelStringInput | null,
  targetUM?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreatePMServiceLevelInput = {
  description?: string | null,
  id?: string | null,
  intervalValue: number,
  lastServiceDate?: string | null,
  lastServiceUM?: number | null,
  levelIdentifier: string,
  pmConfigurationId: string,
  pmServiceFormId?: string | null,
  serviceLevelAssignments?: string | null,
  targetUM: number,
};

export type ModelRegionalDivisionConditionInput = {
  and?: Array< ModelRegionalDivisionConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelRegionalDivisionConditionInput | null,
  or?: Array< ModelRegionalDivisionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateRegionalDivisionInput = {
  companyId: string,
  description?: string | null,
  id?: string | null,
  name: string,
};

export type ModelReportConditionInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dailyServiceLogReport?: ModelBooleanInput | null,
  equipmentId?: ModelStringInput | null,
  equipmentLocationId?: ModelStringInput | null,
  equipmentName?: ModelStringInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionStarted?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelReportConditionInput | null,
  or?: Array< ModelReportConditionInput | null > | null,
  signature?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userData?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userLocation?: ModelStringInput | null,
};

export type CreateReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  dailyServiceLogReport?: boolean | null,
  equipmentId: string,
  equipmentLocationId?: string | null,
  equipmentName?: string | null,
  id?: string | null,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name: string,
  signature?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  userData: string,
  userId: string,
  userLocation: string,
};

export type ModelReportAnswerConditionInput = {
  and?: Array< ModelReportAnswerConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelReportAnswerConditionInput | null,
  notes?: ModelStringInput | null,
  or?: Array< ModelReportAnswerConditionInput | null > | null,
  parentReportId?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  promptDescription?: ModelStringInput | null,
  promptKey?: ModelStringInput | null,
  promptLabel?: ModelStringInput | null,
  promptTitle?: ModelStringInput | null,
  promptType?: ModelStringInput | null,
  reportType?: ModelStringInput | null,
  sortOrder?: ModelIntInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  value?: ModelStringInput | null,
};

export type CreateReportAnswerInput = {
  companyId: string,
  createdAt?: string | null,
  id?: string | null,
  notes?: string | null,
  parentReportId: string,
  photos?: Array< string | null > | null,
  promptDescription?: string | null,
  promptKey: string,
  promptLabel?: string | null,
  promptTitle?: string | null,
  promptType?: string | null,
  reportType: string,
  sortOrder?: number | null,
  unitId?: string | null,
  value?: string | null,
};

export type ModelResourceLibraryConditionInput = {
  and?: Array< ModelResourceLibraryConditionInput | null > | null,
  companyOwnerId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelResourceLibraryConditionInput | null,
  or?: Array< ModelResourceLibraryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateResourceLibraryInput = {
  companyOwnerId: string,
  id?: string | null,
};

export type ModelSavedReportConfigurationConditionInput = {
  and?: Array< ModelSavedReportConfigurationConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  compareDateRangeEnd?: ModelStringInput | null,
  compareDateRangeStart?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateRangeEnd?: ModelStringInput | null,
  dateRangeStart?: ModelStringInput | null,
  dateRangeType?: ModelStringInput | null,
  filtersJson?: ModelStringInput | null,
  groupByField?: ModelStringInput | null,
  lastRunAt?: ModelStringInput | null,
  metricCategory?: ModelStringInput | null,
  metricKey?: ModelStringInput | null,
  not?: ModelSavedReportConfigurationConditionInput | null,
  or?: Array< ModelSavedReportConfigurationConditionInput | null > | null,
  reportName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  visualizationType?: ModelStringInput | null,
};

export type CreateSavedReportConfigurationInput = {
  companyId: string,
  compareDateRangeEnd?: string | null,
  compareDateRangeStart?: string | null,
  createdAt?: string | null,
  dateRangeEnd?: string | null,
  dateRangeStart?: string | null,
  dateRangeType?: string | null,
  filtersJson?: string | null,
  groupByField?: string | null,
  id?: string | null,
  lastRunAt?: string | null,
  metricCategory?: string | null,
  metricKey: string,
  reportName: string,
  userId: string,
  visualizationType?: string | null,
};

export type ModelSensitiveUserInfoConditionInput = {
  and?: Array< ModelSensitiveUserInfoConditionInput | null > | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  driversLicenseClass?: ModelStringInput | null,
  driversLicenseExpirationDate?: ModelStringInput | null,
  driversLicenseNumber?: ModelStringInput | null,
  driversLicenseState?: ModelStringInput | null,
  emergencyContactName?: ModelStringInput | null,
  emergencyContactPhoneNumber?: ModelStringInput | null,
  emergencyContactRelationship?: ModelStringInput | null,
  not?: ModelSensitiveUserInfoConditionInput | null,
  or?: Array< ModelSensitiveUserInfoConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateSensitiveUserInfoInput = {
  cognitoId?: string | null,
  companyId?: string | null,
  dateOfBirth?: string | null,
  driversLicenseClass?: string | null,
  driversLicenseExpirationDate?: string | null,
  driversLicenseNumber?: string | null,
  driversLicenseState?: string | null,
  emergencyContactName?: string | null,
  emergencyContactPhoneNumber?: string | null,
  emergencyContactRelationship?: string | null,
  id?: string | null,
};

export type ModelShiftReportConditionInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelShiftReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  not?: ModelShiftReportConditionInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelShiftReportConditionInput | null > | null,
  photos?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  shiftType?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type CreateShiftReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id?: string | null,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  locationName?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  shiftType?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type ModelSingleUnitConditionInput = {
  and?: Array< ModelSingleUnitConditionInput | null > | null,
  annualProjectedUsage?: ModelFloatInput | null,
  aquisitionCost?: ModelFloatInput | null,
  aquisitionDate?: ModelStringInput | null,
  assignedTo?: ModelStringInput | null,
  axleConfiguration?: ModelStringInput | null,
  categoryId?: ModelIDInput | null,
  costTrackingModuleEnrollment?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  currentMachineHours?: ModelFloatInput | null,
  currentUMCounterValue?: ModelFloatInput | null,
  dailyServiceLogFormId?: ModelStringInput | null,
  description?: ModelStringInput | null,
  dispositionDate?: ModelStringInput | null,
  dispositionReason?: ModelStringInput | null,
  downReason?: ModelStringInput | null,
  engineManufacturer?: ModelStringInput | null,
  engineModelNumber?: ModelStringInput | null,
  equipmentStatus?: ModelBooleanInput | null,
  extraUnitInfo?: ModelStringInput | null,
  image?: ModelStringInput | null,
  inputByPerson?: ModelStringInput | null,
  inputDate?: ModelStringInput | null,
  lastDailyServiceDate?: ModelStringInput | null,
  lastInspectionDate?: ModelStringInput | null,
  lastServiceHours?: ModelFloatInput | null,
  licenseNumber?: ModelStringInput | null,
  locationId?: ModelStringInput | null,
  machineHoursAtAquisition?: ModelFloatInput | null,
  machineUMCounterAtAquisition?: ModelFloatInput | null,
  manufactureDate?: ModelStringInput | null,
  manufacturerName?: ModelStringInput | null,
  modelNumber?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSingleUnitConditionInput | null,
  or?: Array< ModelSingleUnitConditionInput | null > | null,
  pmModuleEnrollment?: ModelBooleanInput | null,
  putInServiceDate?: ModelStringInput | null,
  removedFromServiceDate?: ModelStringInput | null,
  removedFromServiceReason?: ModelStringInput | null,
  replacedUMCounterHistory?: ModelStringInput | null,
  replacedUMCounterStatus?: ModelBooleanInput | null,
  replacedUMCounterValue?: ModelFloatInput | null,
  serialNumber?: ModelStringInput | null,
  tiresModuleEnrollment?: ModelBooleanInput | null,
  unitOfMeasure?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  utilizationAdjustmentDays?: ModelFloatInput | null,
};

export type CreateSingleUnitInput = {
  annualProjectedUsage?: number | null,
  aquisitionCost?: number | null,
  aquisitionDate?: string | null,
  assignedTo?: string | null,
  axleConfiguration?: string | null,
  categoryId?: string | null,
  costTrackingModuleEnrollment?: boolean | null,
  currentMachineHours?: number | null,
  currentUMCounterValue?: number | null,
  dailyServiceLogFormId?: string | null,
  description?: string | null,
  dispositionDate?: string | null,
  dispositionReason?: string | null,
  downReason?: string | null,
  engineManufacturer?: string | null,
  engineModelNumber?: string | null,
  equipmentStatus?: boolean | null,
  extraUnitInfo?: string | null,
  id?: string | null,
  image?: string | null,
  inputByPerson?: string | null,
  inputDate?: string | null,
  lastDailyServiceDate?: string | null,
  lastInspectionDate?: string | null,
  lastServiceHours?: number | null,
  licenseNumber?: string | null,
  locationId?: string | null,
  machineHoursAtAquisition?: number | null,
  machineUMCounterAtAquisition?: number | null,
  manufactureDate?: string | null,
  manufacturerName?: string | null,
  modelNumber?: string | null,
  name: string,
  pmModuleEnrollment?: boolean | null,
  putInServiceDate?: string | null,
  removedFromServiceDate?: string | null,
  removedFromServiceReason?: string | null,
  replacedUMCounterHistory?: string | null,
  replacedUMCounterStatus?: boolean | null,
  replacedUMCounterValue?: number | null,
  serialNumber?: string | null,
  tiresModuleEnrollment?: boolean | null,
  unitOfMeasure?: string | null,
  utilizationAdjustmentDays?: number | null,
};

export type ModelSkillAssignmentConditionInput = {
  and?: Array< ModelSkillAssignmentConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  evaluatedBy?: ModelStringInput | null,
  evaluatedByName?: ModelStringInput | null,
  evaluationDate?: ModelStringInput | null,
  not?: ModelSkillAssignmentConditionInput | null,
  or?: Array< ModelSkillAssignmentConditionInput | null > | null,
  owner?: ModelStringInput | null,
  skillLevel?: ModelStringInput | null,
  subCategoryId?: ModelStringInput | null,
  taskId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateSkillAssignmentInput = {
  companyId: string,
  evaluatedBy?: string | null,
  evaluatedByName?: string | null,
  evaluationDate?: string | null,
  id?: string | null,
  skillLevel: string,
  subCategoryId?: string | null,
  taskId: string,
  userId: string,
};

export type ModelSkillCategoryConditionInput = {
  allowMachineNumber?: ModelBooleanInput | null,
  and?: Array< ModelSkillCategoryConditionInput | null > | null,
  classificationId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillCategoryConditionInput | null,
  or?: Array< ModelSkillCategoryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateSkillCategoryInput = {
  allowMachineNumber?: boolean | null,
  classificationId: string,
  companyId: string,
  equipmentCategoryId?: string | null,
  id?: string | null,
  name: string,
};

export type ModelSkillLevelConditionInput = {
  and?: Array< ModelSkillLevelConditionInput | null > | null,
  color?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillLevelConditionInput | null,
  or?: Array< ModelSkillLevelConditionInput | null > | null,
  owner?: ModelStringInput | null,
  sortOrder?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateSkillLevelInput = {
  color?: string | null,
  companyId: string,
  description?: string | null,
  id?: string | null,
  name: string,
  sortOrder: number,
};

export type ModelSkillTaskConditionInput = {
  and?: Array< ModelSkillTaskConditionInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSkillTaskConditionInput | null,
  or?: Array< ModelSkillTaskConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateSkillTaskInput = {
  categoryId: string,
  companyId: string,
  id?: string | null,
  name: string,
};

export type ModelSubCategoryConditionInput = {
  and?: Array< ModelSubCategoryConditionInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelSubCategoryConditionInput | null,
  or?: Array< ModelSubCategoryConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateSubCategoryInput = {
  categoryId: string,
  companyId: string,
  id?: string | null,
  name: string,
};

export type ModelTireConditionInput = {
  and?: Array< ModelTireConditionInput | null > | null,
  assignedAxle?: ModelStringInput | null,
  assignedPosition?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentTirePressure?: ModelFloatInput | null,
  currentTreadDepth?: ModelFloatInput | null,
  dateInstalled?: ModelStringInput | null,
  dateUninstalled?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  inflationMedium?: ModelStringInput | null,
  loadRating?: ModelFloatInput | null,
  loadRatingUnit?: ModelStringInput | null,
  minimumTreadDepth?: ModelFloatInput | null,
  name?: ModelStringInput | null,
  not?: ModelTireConditionInput | null,
  or?: Array< ModelTireConditionInput | null > | null,
  owner?: ModelStringInput | null,
  recommendedTirePressure?: ModelFloatInput | null,
  removedFromService?: ModelBooleanInput | null,
  removedFromServiceDate?: ModelStringInput | null,
  tireCategory?: ModelStringInput | null,
  tireManufacturer?: ModelStringInput | null,
  tireModel?: ModelStringInput | null,
  tireSize?: ModelStringInput | null,
  tireStatus?: ModelStringInput | null,
  treadDepthAtInstall?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateTireInput = {
  assignedAxle?: string | null,
  assignedPosition?: string | null,
  companyId: string,
  currentTirePressure?: number | null,
  currentTreadDepth?: number | null,
  dateInstalled?: string | null,
  dateUninstalled?: string | null,
  failureReason?: string | null,
  id?: string | null,
  inflationMedium?: string | null,
  loadRating?: number | null,
  loadRatingUnit?: string | null,
  minimumTreadDepth?: number | null,
  name?: string | null,
  recommendedTirePressure?: number | null,
  removedFromService?: boolean | null,
  removedFromServiceDate?: string | null,
  tireCategory?: string | null,
  tireManufacturer?: string | null,
  tireModel?: string | null,
  tireSize?: string | null,
  tireStatus?: string | null,
  treadDepthAtInstall?: number | null,
  unitId?: string | null,
};

export type ModelTireReportConditionInput = {
  alwaysTriggerEmail?: ModelBooleanInput | null,
  and?: Array< ModelTireReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  equipmentCategoryId?: ModelStringInput | null,
  equipmentCategoryName?: ModelStringInput | null,
  equipmentLocationId?: ModelStringInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionStarted?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelTireReportConditionInput | null,
  or?: Array< ModelTireReportConditionInput | null > | null,
  signature?: ModelStringInput | null,
  tireId?: ModelStringInput | null,
  unitId?: ModelStringInput | null,
  unitName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userData?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userLocation?: ModelStringInput | null,
};

export type CreateTireReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId: string,
  createdAt?: string | null,
  equipmentCategoryId: string,
  equipmentCategoryName?: string | null,
  equipmentLocationId?: string | null,
  id?: string | null,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name: string,
  signature?: string | null,
  tireId?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  userData: string,
  userId: string,
  userLocation: string,
};

export type ModelTrainingAffidavitConditionInput = {
  adminId?: ModelStringInput | null,
  affidavitDate?: ModelStringInput | null,
  and?: Array< ModelTrainingAffidavitConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  legalText?: ModelStringInput | null,
  nextDueDate?: ModelStringInput | null,
  not?: ModelTrainingAffidavitConditionInput | null,
  or?: Array< ModelTrainingAffidavitConditionInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  signaturePath?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateTrainingAffidavitInput = {
  adminId: string,
  affidavitDate: string,
  companyId: string,
  id?: string | null,
  legalText: string,
  nextDueDate: string,
  planId: string,
  signaturePath: string,
  userId: string,
};

export type ModelTrainingCompletionConditionInput = {
  and?: Array< ModelTrainingCompletionConditionInput | null > | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  completionDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  launched?: ModelBooleanInput | null,
  markedAsViewed?: ModelBooleanInput | null,
  not?: ModelTrainingCompletionConditionInput | null,
  or?: Array< ModelTrainingCompletionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  scheduleDate?: ModelStringInput | null,
  signaturePath?: ModelStringInput | null,
  timeValueMinutes?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateTrainingCompletionInput = {
  categoryId?: string | null,
  companyId: string,
  completionDate: string,
  id?: string | null,
  launched: boolean,
  markedAsViewed: boolean,
  planId: string,
  scheduleDate: string,
  signaturePath?: string | null,
  timeValueMinutes: number,
  topicId: string,
  userId: string,
};

export type ModelTrainingEnrollmentConditionInput = {
  and?: Array< ModelTrainingEnrollmentConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enrolledDate?: ModelStringInput | null,
  lastCompletionDate?: ModelStringInput | null,
  nextDueDate?: ModelStringInput | null,
  not?: ModelTrainingEnrollmentConditionInput | null,
  or?: Array< ModelTrainingEnrollmentConditionInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateTrainingEnrollmentInput = {
  companyId: string,
  enrolledDate: string,
  id?: string | null,
  lastCompletionDate?: string | null,
  nextDueDate?: string | null,
  planId: string,
  status: string,
  userId: string,
};

export type ModelTrainingPlanConditionInput = {
  and?: Array< ModelTrainingPlanConditionInput | null > | null,
  categories?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  cycleDuration?: ModelIntInput | null,
  governingStandard?: ModelStringInput | null,
  holidays?: ModelStringInput | null,
  minimumTimeRequired?: ModelIntInput | null,
  name?: ModelStringInput | null,
  not?: ModelTrainingPlanConditionInput | null,
  or?: Array< ModelTrainingPlanConditionInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  workingDays?: ModelIntInput | null,
};

export type CreateTrainingPlanInput = {
  categories: string,
  companyId: string,
  cycleDuration: number,
  governingStandard: string,
  holidays?: string | null,
  id?: string | null,
  minimumTimeRequired: number,
  name: string,
  startDate?: string | null,
  status: string,
  workingDays?: Array< number | null > | null,
};

export type ModelTrainingQuizResponseConditionInput = {
  and?: Array< ModelTrainingQuizResponseConditionInput | null > | null,
  attemptNumber?: ModelIntInput | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  cycleStartDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  not?: ModelTrainingQuizResponseConditionInput | null,
  or?: Array< ModelTrainingQuizResponseConditionInput | null > | null,
  owner?: ModelStringInput | null,
  passed?: ModelBooleanInput | null,
  planId?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  score?: ModelIntInput | null,
  signaturePath?: ModelStringInput | null,
  totalQuestions?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateTrainingQuizResponseInput = {
  attemptNumber?: number | null,
  categoryId?: string | null,
  companyId: string,
  completedAt?: string | null,
  cycleStartDate?: string | null,
  formId?: string | null,
  id?: string | null,
  passed?: boolean | null,
  planId: string,
  responseData?: string | null,
  score?: number | null,
  signaturePath?: string | null,
  totalQuestions?: number | null,
  userId: string,
};

export type ModelTrainingScheduleConditionInput = {
  and?: Array< ModelTrainingScheduleConditionInput | null > | null,
  assignedUserId?: ModelStringInput | null,
  categoryId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  dayNumber?: ModelIntInput | null,
  locked?: ModelBooleanInput | null,
  not?: ModelTrainingScheduleConditionInput | null,
  or?: Array< ModelTrainingScheduleConditionInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  scheduledDate?: ModelStringInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateTrainingScheduleInput = {
  assignedUserId?: string | null,
  categoryId?: string | null,
  companyId: string,
  dayNumber: number,
  id?: string | null,
  locked?: boolean | null,
  planId: string,
  scheduledDate: string,
  topicId: string,
};

export type ModelTrainingTopicConditionInput = {
  and?: Array< ModelTrainingTopicConditionInput | null > | null,
  categoryIds?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  companyResourceId?: ModelStringInput | null,
  contentFilePath?: ModelStringInput | null,
  contentUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelTrainingTopicConditionInput | null,
  or?: Array< ModelTrainingTopicConditionInput | null > | null,
  owner?: ModelStringInput | null,
  planIds?: ModelStringInput | null,
  style?: ModelStringInput | null,
  timeValue?: ModelIntInput | null,
  topicId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateTrainingTopicInput = {
  categoryIds?: Array< string | null > | null,
  companyId: string,
  companyResourceId?: string | null,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  description: string,
  id?: string | null,
  planIds?: Array< string | null > | null,
  style: string,
  timeValue: number,
  topicId: string,
};

export type ModelUnitExpenseBudgetConditionInput = {
  and?: Array< ModelUnitExpenseBudgetConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expenseCategoryId?: ModelStringInput | null,
  not?: ModelUnitExpenseBudgetConditionInput | null,
  or?: Array< ModelUnitExpenseBudgetConditionInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelFloatInput | null,
  unitId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateUnitExpenseBudgetInput = {
  companyId: string,
  expenseCategoryId: string,
  id?: string | null,
  startingBalance: number,
  unitId: string,
};

export type ModelUserConditionInput = {
  and?: Array< ModelUserConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  cognitoId?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  contactPhoneNumber?: ModelStringInput | null,
  contactPhoneType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentJobClassification?: ModelStringInput | null,
  dateOfHire?: ModelStringInput | null,
  discrepancyNotification?: ModelBooleanInput | null,
  discrepancyNotificationTypes?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  driversLicenseStatus?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  globalLocationPermission?: ModelBooleanInput | null,
  inputByPerson?: ModelStringInput | null,
  inputDate?: ModelStringInput | null,
  locationAssignment?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelUserConditionInput | null,
  notesAboutUser?: ModelStringInput | null,
  onHighwayEligibility?: ModelBooleanInput | null,
  or?: Array< ModelUserConditionInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  personalIdentification?: ModelStringInput | null,
  pmNotification?: ModelBooleanInput | null,
  pmNotificationTypes?: ModelStringInput | null,
  position?: ModelStringInput | null,
  regionalAssignment?: ModelStringInput | null,
  role?: ModelStringInput | null,
  safetyLessons?: ModelStringInput | null,
  skillTrackingModuleEnrollment?: ModelBooleanInput | null,
  trainingModuleEnrollment?: ModelBooleanInput | null,
  trainingNotification?: ModelBooleanInput | null,
  trainingNotificationTypes?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userPhoto?: ModelStringInput | null,
};

export type CreateUserInput = {
  archived?: boolean | null,
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  contactPhoneType?: string | null,
  currentJobClassification?: string | null,
  dateOfHire?: string | null,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  driversLicenseStatus?: boolean | null,
  email: string,
  globalLocationPermission?: boolean | null,
  id?: string | null,
  inputByPerson?: string | null,
  inputDate?: string | null,
  locationAssignment?: Array< string | null > | null,
  name: string,
  notesAboutUser?: string | null,
  onHighwayEligibility?: boolean | null,
  permissions?: string | null,
  personalIdentification?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  position?: string | null,
  regionalAssignment?: Array< string | null > | null,
  role?: string | null,
  safetyLessons?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
  userPhoto?: string | null,
};

export type ModelUserFileConditionInput = {
  and?: Array< ModelUserFileConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  not?: ModelUserFileConditionInput | null,
  or?: Array< ModelUserFileConditionInput | null > | null,
  owner?: ModelStringInput | null,
  s3Path?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  uploadedBy?: ModelStringInput | null,
  uploadedByName?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateUserFileInput = {
  companyId: string,
  fileName: string,
  fileSize: number,
  id?: string | null,
  s3Path: string,
  uploadedAt: string,
  uploadedBy: string,
  uploadedByName: string,
  userId: string,
};

export type ModelUserReportFavoriteConditionInput = {
  and?: Array< ModelUserReportFavoriteConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelUserReportFavoriteConditionInput | null,
  or?: Array< ModelUserReportFavoriteConditionInput | null > | null,
  reportTypeKey?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateUserReportFavoriteInput = {
  companyId: string,
  id?: string | null,
  reportTypeKey: string,
  userId: string,
};

export type ModelUserSkillReportConditionInput = {
  and?: Array< ModelUserSkillReportConditionInput | null > | null,
  assessorId?: ModelStringInput | null,
  assessorName?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  formId?: ModelStringInput | null,
  gpsLatitude?: ModelFloatInput | null,
  gpsLocationType?: ModelStringInput | null,
  gpsLongitude?: ModelFloatInput | null,
  inopCount?: ModelIntInput | null,
  inspectionCompleted?: ModelStringInput | null,
  inspectionDurationSeconds?: ModelIntInput | null,
  inspectionStarted?: ModelStringInput | null,
  not?: ModelUserSkillReportConditionInput | null,
  okCount?: ModelIntInput | null,
  or?: Array< ModelUserSkillReportConditionInput | null > | null,
  passFailStatus?: ModelStringInput | null,
  photos?: ModelStringInput | null,
  qualificationLevel?: ModelStringInput | null,
  responseData?: ModelStringInput | null,
  signature?: ModelStringInput | null,
  skillCategory?: ModelStringInput | null,
  skillName?: ModelStringInput | null,
  totalItems?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  warnCount?: ModelIntInput | null,
};

export type CreateUserSkillReportInput = {
  assessorId?: string | null,
  assessorName?: string | null,
  companyId: string,
  createdAt?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id?: string | null,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  okCount?: number | null,
  passFailStatus?: string | null,
  photos?: Array< string | null > | null,
  qualificationLevel?: string | null,
  responseData?: string | null,
  signature?: string | null,
  skillCategory?: string | null,
  skillName?: string | null,
  totalItems?: number | null,
  userId: string,
  userName?: string | null,
  warnCount?: number | null,
};

export type ModelVendorListConditionInput = {
  address?: ModelStringInput | null,
  and?: Array< ModelVendorListConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  faxNumber?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelVendorListConditionInput | null,
  or?: Array< ModelVendorListConditionInput | null > | null,
  owner?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  repName?: ModelStringInput | null,
  repPhoneNumber?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateVendorListInput = {
  address?: string | null,
  companyId: string,
  faxNumber?: string | null,
  id?: string | null,
  name: string,
  phoneNumber?: string | null,
  repName?: string | null,
  repPhoneNumber?: string | null,
  updatedAt?: string | null,
};

export type ModelVideoConditionInput = {
  and?: Array< ModelVideoConditionInput | null > | null,
  assignedSafetyLesson?: ModelStringInput | null,
  contentPath?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  folderName?: ModelStringInput | null,
  not?: ModelVideoConditionInput | null,
  or?: Array< ModelVideoConditionInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelIDInput | null,
  safetyLesson?: ModelBooleanInput | null,
  sharedWithCompanyIds?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateVideoInput = {
  assignedSafetyLesson?: string | null,
  contentPath: string,
  folderName?: string | null,
  id?: string | null,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title: string,
};

export type DeleteArchivedDiscrepancyInput = {
  id: string,
};

export type DeleteAuditLogInput = {
  id: string,
};

export type DeleteAxleBlueprintInput = {
  id: string,
};

export type DeleteBillingRateInput = {
  id: string,
};

export type DeleteBusinessAdminInput = {
  id: string,
};

export type DeleteChangeLogEntryInput = {
  id: string,
};

export type DeleteClassificationInput = {
  id: string,
};

export type DeleteCompanyInput = {
  id: string,
};

export type DeleteCompanyNoteInput = {
  id: string,
};

export type DeleteCompanyOwnerInput = {
  id: string,
};

export type DeleteCompanyResourceInput = {
  id: string,
};

export type DeleteDOTInspectionReportInput = {
  id: string,
};

export type DeleteDailyServiceReportInput = {
  id: string,
};

export type DeleteDiscrepancyInput = {
  id: string,
};

export type DeleteDocumentInput = {
  id: string,
};

export type DeleteEquipmentInput = {
  id: string,
};

export type DeleteEquipmentCategoryInput = {
  id: string,
};

export type DeleteErrorsInput = {
  id: string,
};

export type DeleteExpenseCategoryInput = {
  id: string,
};

export type DeleteExpenseRecordInput = {
  id: string,
};

export type DeleteFormInput = {
  id: string,
};

export type DeleteFormTemplateInput = {
  id: string,
};

export type DeleteFormTemplateGroupInput = {
  id: string,
};

export type DeleteHelpSupportDocInput = {
  id: string,
};

export type DeleteInspectionReportInput = {
  id: string,
};

export type DeleteInvoiceInput = {
  id: string,
};

export type DeleteLaborCategoryInput = {
  id: string,
};

export type DeleteLaborRateInput = {
  id: string,
};

export type DeleteLibraryPlanTemplateInput = {
  id: string,
};

export type DeleteLibraryTopicTemplateInput = {
  id: string,
};

export type DeleteLocationInput = {
  id: string,
};

export type DeleteModuleSubscriptionInput = {
  id: string,
};

export type DeletePMConfigurationInput = {
  id: string,
};

export type DeletePMModuleContentInput = {
  id: string,
};

export type DeletePMNotificationSettingInput = {
  id: string,
};

export type DeletePMPartsAndProcedureInput = {
  id: string,
};

export type DeletePMReportInput = {
  id: string,
};

export type DeletePMServiceLevelInput = {
  id: string,
};

export type DeleteRegionalDivisionInput = {
  id: string,
};

export type DeleteReportInput = {
  id: string,
};

export type DeleteReportAnswerInput = {
  id: string,
};

export type DeleteResourceLibraryInput = {
  id: string,
};

export type DeleteSavedReportConfigurationInput = {
  id: string,
};

export type DeleteSensitiveUserInfoInput = {
  id: string,
};

export type DeleteShiftReportInput = {
  id: string,
};

export type DeleteSingleUnitInput = {
  id: string,
};

export type DeleteSkillAssignmentInput = {
  id: string,
};

export type DeleteSkillCategoryInput = {
  id: string,
};

export type DeleteSkillLevelInput = {
  id: string,
};

export type DeleteSkillTaskInput = {
  id: string,
};

export type DeleteSubCategoryInput = {
  id: string,
};

export type DeleteTireInput = {
  id: string,
};

export type DeleteTireReportInput = {
  id: string,
};

export type DeleteTrainingAffidavitInput = {
  id: string,
};

export type DeleteTrainingCompletionInput = {
  id: string,
};

export type DeleteTrainingEnrollmentInput = {
  id: string,
};

export type DeleteTrainingPlanInput = {
  id: string,
};

export type DeleteTrainingQuizResponseInput = {
  id: string,
};

export type DeleteTrainingScheduleInput = {
  id: string,
};

export type DeleteTrainingTopicInput = {
  id: string,
};

export type DeleteUnitExpenseBudgetInput = {
  id: string,
};

export type DeleteUserInput = {
  id: string,
};

export type DeleteUserFileInput = {
  id: string,
};

export type DeleteUserReportFavoriteInput = {
  id: string,
};

export type DeleteUserSkillReportInput = {
  id: string,
};

export type DeleteVendorListInput = {
  id: string,
};

export type DeleteVideoInput = {
  id: string,
};

export type UpdateArchivedDiscrepancyInput = {
  archivedDate?: string | null,
  companyId?: string | null,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId?: string | null,
  equipmentName?: string | null,
  id: string,
  initialStatus?: string | null,
  log?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status?: string | null,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type UpdateAuditLogInput = {
  action?: string | null,
  companyId?: string | null,
  createdAt?: string | null,
  details?: string | null,
  id: string,
  resourceId?: string | null,
  resourceName?: string | null,
  resourceType?: string | null,
  ttl?: number | null,
  userId?: string | null,
  userName?: string | null,
};

export type UpdateAxleBlueprintInput = {
  axles?: string | null,
  centerlineLength?: number | null,
  companyId?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateBillingRateInput = {
  companyId?: string | null,
  id: string,
  ratePerCostTracking?: number | null,
  ratePerEquipment?: number | null,
  ratePerPM?: number | null,
  ratePerSafetyEnrollment?: number | null,
  ratePerSkillQualification?: number | null,
  ratePerTireMaint?: number | null,
  ratePerUser?: number | null,
};

export type UpdateBusinessAdminInput = {
  cognitoId?: string | null,
  domain?: string | null,
  email?: string | null,
  id: string,
  name?: string | null,
  permissions?: string | null,
  role?: string | null,
};

export type UpdateChangeLogEntryInput = {
  changedBy?: string | null,
  changedByName?: string | null,
  companyId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  fieldName?: string | null,
  id: string,
  newValue?: string | null,
  oldValue?: string | null,
  userId?: string | null,
};

export type UpdateClassificationInput = {
  companyId?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateCompanyInput = {
  accountNumber?: string | null,
  accountOrigin?: string | null,
  accountStatus?: string | null,
  addOnGracePeriodEndDate?: string | null,
  archived?: boolean | null,
  assignedRep?: string | null,
  billingAnchorDay?: number | null,
  billingContactAddress?: string | null,
  billingContactEmail?: string | null,
  billingContactName?: string | null,
  billingContactPhone?: string | null,
  billingCycle?: string | null,
  businessType?: string | null,
  cancelEffectiveDate?: string | null,
  cancelReason?: string | null,
  cancelReasonNote?: string | null,
  cancelRequestedAt?: string | null,
  companyOwnerId?: string | null,
  coreMonthlyRate?: number | null,
  costTrackingModuleEnrollment?: boolean | null,
  dataRetentionEndDate?: string | null,
  description?: string | null,
  gracePeriodEndDate?: string | null,
  id: string,
  industryNAICS?: string | null,
  industrySIC?: string | null,
  initialContactDate?: string | null,
  initialStarterPackageEnrollment?: boolean | null,
  logo?: string | null,
  maxNumberEquipment?: number | null,
  maxNumberUsers?: number | null,
  name?: string | null,
  nextBillingDate?: string | null,
  notes?: string | null,
  numberOfUsers?: number | null,
  paidStartDate?: string | null,
  paymentFailedAt?: string | null,
  paymentMethod?: string | null,
  pmModuleEnrollment?: boolean | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  primaryContactPhone?: string | null,
  primaryContactPosition?: string | null,
  primaryLocation?: string | null,
  referredBy?: string | null,
  retryAttempts?: number | null,
  safetyComplianceStandard?: string | null,
  secondaryContactEmail?: string | null,
  secondaryContactName?: string | null,
  secondaryContactPhone?: string | null,
  secondaryContactPosition?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  starterPackage?: string | null,
  status?: string | null,
  subscriptionExpiration?: string | null,
  subscriptionType?: string | null,
  tiresModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trialEndDate?: string | null,
  trialStartDate?: string | null,
  type?: string | null,
};

export type UpdateCompanyNoteInput = {
  authorName?: string | null,
  companyId?: string | null,
  content?: string | null,
  createdAt?: string | null,
  id: string,
};

export type UpdateCompanyOwnerInput = {
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  email?: string | null,
  id: string,
  name?: string | null,
  permissions?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  role?: string | null,
  siteAdmin?: boolean | null,
  subscriptionType?: string | null,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
};

export type UpdateCompanyResourceInput = {
  category?: string | null,
  companyId?: string | null,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  description?: string | null,
  fileType?: string | null,
  folderName?: string | null,
  id: string,
  title?: string | null,
  trainingTopicId?: string | null,
  uploadedByUserId?: string | null,
  uploadedByUserName?: string | null,
};

export type UpdateDOTInspectionReportInput = {
  companyId?: string | null,
  complianceStatus?: string | null,
  createdAt?: string | null,
  dotInspectionType?: string | null,
  equipmentCategoryId?: string | null,
  equipmentCategoryName?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  inspectorCertificationId?: string | null,
  locationId?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  regulatoryStandard?: string | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId?: string | null,
  userName?: string | null,
  vehicleLicensePlate?: string | null,
  vehicleVIN?: string | null,
  warnCount?: number | null,
};

export type UpdateDailyServiceReportInput = {
  companyId?: string | null,
  createdAt?: string | null,
  dailyServiceLogFormId?: string | null,
  equipmentCategoryId?: string | null,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtService?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtService?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId?: string | null,
  userName?: string | null,
  warnCount?: number | null,
};

export type UpdateDiscrepancyInput = {
  companyId?: string | null,
  createdAt?: string | null,
  downReason?: string | null,
  equipmentId?: string | null,
  equipmentName?: string | null,
  id: string,
  initialStatus?: string | null,
  log?: string | null,
  promptDescription?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  questionIndex?: number | null,
  reportId?: string | null,
  status?: string | null,
  unitId?: string | null,
  updatedAt?: string | null,
};

export type UpdateDocumentInput = {
  assignedSafetyLesson?: string | null,
  contentPath?: string | null,
  folderName?: string | null,
  id: string,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title?: string | null,
};

export type UpdateEquipmentInput = {
  companyId?: string | null,
  formId?: string | null,
  id: string,
  image?: string | null,
  name?: string | null,
  units?: string | null,
};

export type UpdateEquipmentCategoryInput = {
  companyId?: string | null,
  formId?: string | null,
  id: string,
  image?: string | null,
  name?: string | null,
};

export type UpdateErrorsInput = {
  errors?: string | null,
  id: string,
};

export type UpdateExpenseCategoryInput = {
  companyId?: string | null,
  id: string,
  name?: string | null,
  startingBalance?: number | null,
};

export type UpdateExpenseRecordInput = {
  attachments?: Array< string | null > | null,
  companyId?: string | null,
  dateOfInput?: string | null,
  dateOfService?: string | null,
  equipmentCategoryId?: string | null,
  expenseCategories?: string | null,
  id: string,
  invoiceNumber?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  pmExpense?: number | null,
  pmServiceLevelId?: string | null,
  pmServiceLevelName?: string | null,
  totalExpense?: number | null,
  totalLaborCost?: number | null,
  unitId?: string | null,
  vendorId?: string | null,
  vendorName?: string | null,
  workDescription?: string | null,
};

export type UpdateFormInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId?: string | null,
  dailyServiceLogForm?: boolean | null,
  equipmentType?: string | null,
  formData?: string | null,
  formType?: string | null,
  id: string,
  inspectionForm?: boolean | null,
  name?: string | null,
  noMachineHours?: boolean | null,
  noUMCounter?: boolean | null,
  pmServiceScheduleForm?: boolean | null,
  status?: string | null,
  umCounterLabel?: string | null,
};

export type UpdateFormTemplateInput = {
  createdByCompanyOwnerId?: string | null,
  dailyServiceLogForm?: boolean | null,
  formTemplateGroupID?: string | null,
  id: string,
  inspectionForm?: boolean | null,
  originalCompanyId?: string | null,
  pmServiceScheduleForm?: boolean | null,
  templateData?: string | null,
  templateName?: string | null,
};

export type UpdateFormTemplateGroupInput = {
  description?: string | null,
  id: string,
  name?: string | null,
  resourceLibraryID?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
};

export type UpdateHelpSupportDocInput = {
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdByAdminId?: string | null,
  description?: string | null,
  docType?: string | null,
  id: string,
  sharedWithCompanyIds?: Array< string | null > | null,
  status?: string | null,
  title?: string | null,
  visibility?: string | null,
};

export type UpdateInspectionReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId?: string | null,
  createdAt?: string | null,
  equipmentCategoryId?: string | null,
  equipmentCategoryName?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  machineHoursAtInspection?: number | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  umCounterAtInspection?: number | null,
  unitId?: string | null,
  unitName?: string | null,
  userId?: string | null,
  userName?: string | null,
  warnCount?: number | null,
};

export type UpdateInvoiceInput = {
  amount?: number | null,
  companyId?: string | null,
  date?: string | null,
  description?: string | null,
  id: string,
  invoiceNumber?: string | null,
  lineItems?: string | null,
  pdfUrl?: string | null,
  status?: string | null,
};

export type UpdateLaborCategoryInput = {
  companyId?: string | null,
  id: string,
  isActive?: boolean | null,
  name?: string | null,
};

export type UpdateLaborRateInput = {
  categoryId?: string | null,
  effectiveDate?: string | null,
  id: string,
  overtimeRate?: number | null,
  standardRate?: number | null,
};

export type UpdateLibraryPlanTemplateInput = {
  categories?: string | null,
  categoryCount?: number | null,
  createdByAdminId?: string | null,
  createdByAdminName?: string | null,
  cycleDuration?: number | null,
  description?: string | null,
  governingStandard?: string | null,
  id: string,
  minimumTimeRequired?: number | null,
  name?: string | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  status?: string | null,
  topicCount?: number | null,
  workingDays?: Array< number | null > | null,
};

export type UpdateLibraryTopicTemplateInput = {
  contentFilePath?: string | null,
  contentUrl?: string | null,
  createdByAdminId?: string | null,
  description?: string | null,
  id: string,
  style?: string | null,
  timeValue?: number | null,
  topicId?: string | null,
};

export type UpdateLocationInput = {
  companyId?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
  regionalDivisionId?: string | null,
};

export type UpdateModuleSubscriptionInput = {
  activatedAt?: string | null,
  cancelRequestedAt?: string | null,
  companyId?: string | null,
  effectiveEndDate?: string | null,
  id: string,
  moduleKey?: string | null,
  monthlyRate?: number | null,
  pricingModel?: string | null,
  status?: string | null,
};

export type UpdatePMConfigurationInput = {
  companyId?: string | null,
  dueSoonPercentage?: number | null,
  id: string,
  laborCategoryId?: string | null,
  unitId?: string | null,
  unitOfMeasure?: string | null,
};

export type UpdatePMModuleContentInput = {
  id: string,
  pmServiceFormId?: string | null,
  unitId?: string | null,
};

export type UpdatePMNotificationSettingInput = {
  emailThresholdUM?: number | null,
  id: string,
  lastNotificationSent?: string | null,
  notificationFrequency?: string | null,
  pmConfigurationId?: string | null,
  recipients?: Array< string | null > | null,
  serviceLevelId?: string | null,
};

export type UpdatePMPartsAndProcedureInput = {
  category?: string | null,
  companyId?: string | null,
  createdByUserId?: string | null,
  createdByUserName?: string | null,
  id: string,
  itemName?: string | null,
  itemType?: string | null,
  manufacturer?: string | null,
  partNumber?: string | null,
  pmConfigurationId?: string | null,
  pmConfigurationIds?: Array< string | null > | null,
  price?: number | null,
  quantity?: number | null,
  sortOrder?: number | null,
  unitOfMeasure?: string | null,
  vendorId?: string | null,
  vendorName?: string | null,
};

export type UpdatePMReportInput = {
  actualUM?: number | null,
  companyId?: string | null,
  createdAt?: string | null,
  id: string,
  issueDescription?: string | null,
  issueTicketCreated?: boolean | null,
  issueTicketId?: string | null,
  laborHoursOT?: number | null,
  laborHoursST?: number | null,
  laborRateOT?: number | null,
  laborRateST?: number | null,
  laborRateScheduleId?: string | null,
  laborRateScheduleName?: string | null,
  photos?: Array< string | null > | null,
  pmConfigurationId?: string | null,
  reportData?: string | null,
  serviceDate?: string | null,
  serviceLevelId?: string | null,
  serviceLevelName?: string | null,
  signature?: string | null,
  status?: string | null,
  technicianId?: string | null,
  technicianName?: string | null,
  totalLaborCost?: number | null,
  unitId?: string | null,
};

export type UpdatePMServiceLevelInput = {
  description?: string | null,
  id: string,
  intervalValue?: number | null,
  lastServiceDate?: string | null,
  lastServiceUM?: number | null,
  levelIdentifier?: string | null,
  pmConfigurationId?: string | null,
  pmServiceFormId?: string | null,
  serviceLevelAssignments?: string | null,
  targetUM?: number | null,
};

export type UpdateRegionalDivisionInput = {
  companyId?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId?: string | null,
  createdAt?: string | null,
  dailyServiceLogReport?: boolean | null,
  equipmentId?: string | null,
  equipmentLocationId?: string | null,
  equipmentName?: string | null,
  id: string,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name?: string | null,
  signature?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  userData?: string | null,
  userId?: string | null,
  userLocation?: string | null,
};

export type UpdateReportAnswerInput = {
  companyId?: string | null,
  createdAt?: string | null,
  id: string,
  notes?: string | null,
  parentReportId?: string | null,
  photos?: Array< string | null > | null,
  promptDescription?: string | null,
  promptKey?: string | null,
  promptLabel?: string | null,
  promptTitle?: string | null,
  promptType?: string | null,
  reportType?: string | null,
  sortOrder?: number | null,
  unitId?: string | null,
  value?: string | null,
};

export type UpdateResourceLibraryInput = {
  companyOwnerId?: string | null,
  id: string,
};

export type UpdateSavedReportConfigurationInput = {
  companyId?: string | null,
  compareDateRangeEnd?: string | null,
  compareDateRangeStart?: string | null,
  createdAt?: string | null,
  dateRangeEnd?: string | null,
  dateRangeStart?: string | null,
  dateRangeType?: string | null,
  filtersJson?: string | null,
  groupByField?: string | null,
  id: string,
  lastRunAt?: string | null,
  metricCategory?: string | null,
  metricKey?: string | null,
  reportName?: string | null,
  userId?: string | null,
  visualizationType?: string | null,
};

export type UpdateSensitiveUserInfoInput = {
  cognitoId?: string | null,
  companyId?: string | null,
  dateOfBirth?: string | null,
  driversLicenseClass?: string | null,
  driversLicenseExpirationDate?: string | null,
  driversLicenseNumber?: string | null,
  driversLicenseState?: string | null,
  emergencyContactName?: string | null,
  emergencyContactPhoneNumber?: string | null,
  emergencyContactRelationship?: string | null,
  id: string,
};

export type UpdateShiftReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId?: string | null,
  createdAt?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  locationId?: string | null,
  locationName?: string | null,
  okCount?: number | null,
  photos?: Array< string | null > | null,
  responseData?: string | null,
  shiftType?: string | null,
  signature?: string | null,
  totalItems?: number | null,
  userId?: string | null,
  userName?: string | null,
  warnCount?: number | null,
};

export type UpdateSingleUnitInput = {
  annualProjectedUsage?: number | null,
  aquisitionCost?: number | null,
  aquisitionDate?: string | null,
  assignedTo?: string | null,
  axleConfiguration?: string | null,
  categoryId?: string | null,
  costTrackingModuleEnrollment?: boolean | null,
  currentMachineHours?: number | null,
  currentUMCounterValue?: number | null,
  dailyServiceLogFormId?: string | null,
  description?: string | null,
  dispositionDate?: string | null,
  dispositionReason?: string | null,
  downReason?: string | null,
  engineManufacturer?: string | null,
  engineModelNumber?: string | null,
  equipmentStatus?: boolean | null,
  extraUnitInfo?: string | null,
  id: string,
  image?: string | null,
  inputByPerson?: string | null,
  inputDate?: string | null,
  lastDailyServiceDate?: string | null,
  lastInspectionDate?: string | null,
  lastServiceHours?: number | null,
  licenseNumber?: string | null,
  locationId?: string | null,
  machineHoursAtAquisition?: number | null,
  machineUMCounterAtAquisition?: number | null,
  manufactureDate?: string | null,
  manufacturerName?: string | null,
  modelNumber?: string | null,
  name?: string | null,
  pmModuleEnrollment?: boolean | null,
  putInServiceDate?: string | null,
  removedFromServiceDate?: string | null,
  removedFromServiceReason?: string | null,
  replacedUMCounterHistory?: string | null,
  replacedUMCounterStatus?: boolean | null,
  replacedUMCounterValue?: number | null,
  serialNumber?: string | null,
  tiresModuleEnrollment?: boolean | null,
  unitOfMeasure?: string | null,
  utilizationAdjustmentDays?: number | null,
};

export type UpdateSkillAssignmentInput = {
  companyId?: string | null,
  evaluatedBy?: string | null,
  evaluatedByName?: string | null,
  evaluationDate?: string | null,
  id: string,
  skillLevel?: string | null,
  subCategoryId?: string | null,
  taskId?: string | null,
  userId?: string | null,
};

export type UpdateSkillCategoryInput = {
  allowMachineNumber?: boolean | null,
  classificationId?: string | null,
  companyId?: string | null,
  equipmentCategoryId?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateSkillLevelInput = {
  color?: string | null,
  companyId?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
  sortOrder?: number | null,
};

export type UpdateSkillTaskInput = {
  categoryId?: string | null,
  companyId?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateSubCategoryInput = {
  categoryId?: string | null,
  companyId?: string | null,
  id: string,
  name?: string | null,
};

export type UpdateTireInput = {
  assignedAxle?: string | null,
  assignedPosition?: string | null,
  companyId?: string | null,
  currentTirePressure?: number | null,
  currentTreadDepth?: number | null,
  dateInstalled?: string | null,
  dateUninstalled?: string | null,
  failureReason?: string | null,
  id: string,
  inflationMedium?: string | null,
  loadRating?: number | null,
  loadRatingUnit?: string | null,
  minimumTreadDepth?: number | null,
  name?: string | null,
  recommendedTirePressure?: number | null,
  removedFromService?: boolean | null,
  removedFromServiceDate?: string | null,
  tireCategory?: string | null,
  tireManufacturer?: string | null,
  tireModel?: string | null,
  tireSize?: string | null,
  tireStatus?: string | null,
  treadDepthAtInstall?: number | null,
  unitId?: string | null,
};

export type UpdateTireReportInput = {
  alwaysTriggerEmail?: boolean | null,
  companyId?: string | null,
  createdAt?: string | null,
  equipmentCategoryId?: string | null,
  equipmentCategoryName?: string | null,
  equipmentLocationId?: string | null,
  id: string,
  inspectionCompleted?: string | null,
  inspectionStarted?: string | null,
  name?: string | null,
  signature?: string | null,
  tireId?: string | null,
  unitId?: string | null,
  unitName?: string | null,
  userData?: string | null,
  userId?: string | null,
  userLocation?: string | null,
};

export type UpdateTrainingAffidavitInput = {
  adminId?: string | null,
  affidavitDate?: string | null,
  companyId?: string | null,
  id: string,
  legalText?: string | null,
  nextDueDate?: string | null,
  planId?: string | null,
  signaturePath?: string | null,
  userId?: string | null,
};

export type UpdateTrainingCompletionInput = {
  categoryId?: string | null,
  companyId?: string | null,
  completionDate?: string | null,
  id: string,
  launched?: boolean | null,
  markedAsViewed?: boolean | null,
  planId?: string | null,
  scheduleDate?: string | null,
  signaturePath?: string | null,
  timeValueMinutes?: number | null,
  topicId?: string | null,
  userId?: string | null,
};

export type UpdateTrainingEnrollmentInput = {
  companyId?: string | null,
  enrolledDate?: string | null,
  id: string,
  lastCompletionDate?: string | null,
  nextDueDate?: string | null,
  planId?: string | null,
  status?: string | null,
  userId?: string | null,
};

export type UpdateTrainingPlanInput = {
  categories?: string | null,
  companyId?: string | null,
  cycleDuration?: number | null,
  governingStandard?: string | null,
  holidays?: string | null,
  id: string,
  minimumTimeRequired?: number | null,
  name?: string | null,
  startDate?: string | null,
  status?: string | null,
  workingDays?: Array< number | null > | null,
};

export type UpdateTrainingQuizResponseInput = {
  attemptNumber?: number | null,
  categoryId?: string | null,
  companyId?: string | null,
  completedAt?: string | null,
  cycleStartDate?: string | null,
  formId?: string | null,
  id: string,
  passed?: boolean | null,
  planId?: string | null,
  responseData?: string | null,
  score?: number | null,
  signaturePath?: string | null,
  totalQuestions?: number | null,
  userId?: string | null,
};

export type UpdateTrainingScheduleInput = {
  assignedUserId?: string | null,
  categoryId?: string | null,
  companyId?: string | null,
  dayNumber?: number | null,
  id: string,
  locked?: boolean | null,
  planId?: string | null,
  scheduledDate?: string | null,
  topicId?: string | null,
};

export type UpdateTrainingTopicInput = {
  categoryIds?: Array< string | null > | null,
  companyId?: string | null,
  companyResourceId?: string | null,
  contentFilePath?: string | null,
  contentUrl?: string | null,
  description?: string | null,
  id: string,
  planIds?: Array< string | null > | null,
  style?: string | null,
  timeValue?: number | null,
  topicId?: string | null,
};

export type UpdateUnitExpenseBudgetInput = {
  companyId?: string | null,
  expenseCategoryId?: string | null,
  id: string,
  startingBalance?: number | null,
  unitId?: string | null,
};

export type UpdateUserInput = {
  archived?: boolean | null,
  cognitoId?: string | null,
  companyId?: string | null,
  contactPhoneNumber?: string | null,
  contactPhoneType?: string | null,
  currentJobClassification?: string | null,
  dateOfHire?: string | null,
  discrepancyNotification?: boolean | null,
  discrepancyNotificationTypes?: string | null,
  domain?: string | null,
  driversLicenseStatus?: boolean | null,
  email?: string | null,
  globalLocationPermission?: boolean | null,
  id: string,
  inputByPerson?: string | null,
  inputDate?: string | null,
  locationAssignment?: Array< string | null > | null,
  name?: string | null,
  notesAboutUser?: string | null,
  onHighwayEligibility?: boolean | null,
  permissions?: string | null,
  personalIdentification?: string | null,
  pmNotification?: boolean | null,
  pmNotificationTypes?: string | null,
  position?: string | null,
  regionalAssignment?: Array< string | null > | null,
  role?: string | null,
  safetyLessons?: string | null,
  skillTrackingModuleEnrollment?: boolean | null,
  trainingModuleEnrollment?: boolean | null,
  trainingNotification?: boolean | null,
  trainingNotificationTypes?: string | null,
  userPhoto?: string | null,
};

export type UpdateUserFileInput = {
  companyId?: string | null,
  fileName?: string | null,
  fileSize?: number | null,
  id: string,
  s3Path?: string | null,
  uploadedAt?: string | null,
  uploadedBy?: string | null,
  uploadedByName?: string | null,
  userId?: string | null,
};

export type UpdateUserReportFavoriteInput = {
  companyId?: string | null,
  id: string,
  reportTypeKey?: string | null,
  userId?: string | null,
};

export type UpdateUserSkillReportInput = {
  assessorId?: string | null,
  assessorName?: string | null,
  companyId?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  formId?: string | null,
  gpsLatitude?: number | null,
  gpsLocationType?: string | null,
  gpsLongitude?: number | null,
  id: string,
  inopCount?: number | null,
  inspectionCompleted?: string | null,
  inspectionDurationSeconds?: number | null,
  inspectionStarted?: string | null,
  okCount?: number | null,
  passFailStatus?: string | null,
  photos?: Array< string | null > | null,
  qualificationLevel?: string | null,
  responseData?: string | null,
  signature?: string | null,
  skillCategory?: string | null,
  skillName?: string | null,
  totalItems?: number | null,
  userId?: string | null,
  userName?: string | null,
  warnCount?: number | null,
};

export type UpdateVendorListInput = {
  address?: string | null,
  companyId?: string | null,
  faxNumber?: string | null,
  id: string,
  name?: string | null,
  phoneNumber?: string | null,
  repName?: string | null,
  repPhoneNumber?: string | null,
  updatedAt?: string | null,
};

export type UpdateVideoInput = {
  assignedSafetyLesson?: string | null,
  contentPath?: string | null,
  folderName?: string | null,
  id: string,
  resourceLibraryID?: string | null,
  safetyLesson?: boolean | null,
  sharedWithCompanyIds?: Array< string | null > | null,
  title?: string | null,
};

export type ModelSubscriptionArchivedDiscrepancyFilterInput = {
  and?: Array< ModelSubscriptionArchivedDiscrepancyFilterInput | null > | null,
  archivedDate?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  downReason?: ModelSubscriptionStringInput | null,
  equipmentId?: ModelSubscriptionStringInput | null,
  equipmentName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  initialStatus?: ModelSubscriptionStringInput | null,
  log?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionArchivedDiscrepancyFilterInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelSubscriptionStringInput | null,
  promptLabel?: ModelSubscriptionStringInput | null,
  promptTitle?: ModelSubscriptionStringInput | null,
  questionIndex?: ModelSubscriptionIntInput | null,
  reportId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionStringInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIDInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAuditLogFilterInput = {
  action?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAuditLogFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionAuditLogFilterInput | null > | null,
  resourceId?: ModelSubscriptionStringInput | null,
  resourceName?: ModelSubscriptionStringInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  ttl?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionAxleBlueprintFilterInput = {
  and?: Array< ModelSubscriptionAxleBlueprintFilterInput | null > | null,
  axles?: ModelSubscriptionStringInput | null,
  centerlineLength?: ModelSubscriptionIntInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAxleBlueprintFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionBillingRateFilterInput = {
  and?: Array< ModelSubscriptionBillingRateFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionBillingRateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  ratePerCostTracking?: ModelSubscriptionFloatInput | null,
  ratePerEquipment?: ModelSubscriptionFloatInput | null,
  ratePerPM?: ModelSubscriptionFloatInput | null,
  ratePerSafetyEnrollment?: ModelSubscriptionFloatInput | null,
  ratePerSkillQualification?: ModelSubscriptionFloatInput | null,
  ratePerTireMaint?: ModelSubscriptionFloatInput | null,
  ratePerUser?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionFloatInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBusinessAdminFilterInput = {
  and?: Array< ModelSubscriptionBusinessAdminFilterInput | null > | null,
  cognitoId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionBusinessAdminFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionChangeLogEntryFilterInput = {
  and?: Array< ModelSubscriptionChangeLogEntryFilterInput | null > | null,
  changedBy?: ModelSubscriptionStringInput | null,
  changedByName?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  fieldName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  newValue?: ModelSubscriptionStringInput | null,
  oldValue?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionChangeLogEntryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionClassificationFilterInput = {
  and?: Array< ModelSubscriptionClassificationFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionClassificationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionCompanyFilterInput = {
  accountNumber?: ModelSubscriptionStringInput | null,
  accountOrigin?: ModelSubscriptionStringInput | null,
  accountStatus?: ModelSubscriptionStringInput | null,
  addOnGracePeriodEndDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCompanyFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  assignedRep?: ModelSubscriptionStringInput | null,
  billingAnchorDay?: ModelSubscriptionIntInput | null,
  billingContactAddress?: ModelSubscriptionStringInput | null,
  billingContactEmail?: ModelSubscriptionStringInput | null,
  billingContactName?: ModelSubscriptionStringInput | null,
  billingContactPhone?: ModelSubscriptionStringInput | null,
  billingCycle?: ModelSubscriptionStringInput | null,
  businessType?: ModelSubscriptionStringInput | null,
  cancelEffectiveDate?: ModelSubscriptionStringInput | null,
  cancelReason?: ModelSubscriptionStringInput | null,
  cancelReasonNote?: ModelSubscriptionStringInput | null,
  cancelRequestedAt?: ModelSubscriptionStringInput | null,
  companyOwnerId?: ModelSubscriptionStringInput | null,
  coreMonthlyRate?: ModelSubscriptionFloatInput | null,
  costTrackingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dataRetentionEndDate?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  gracePeriodEndDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  industryNAICS?: ModelSubscriptionStringInput | null,
  industrySIC?: ModelSubscriptionStringInput | null,
  initialContactDate?: ModelSubscriptionStringInput | null,
  initialStarterPackageEnrollment?: ModelSubscriptionBooleanInput | null,
  logo?: ModelSubscriptionStringInput | null,
  maxNumberEquipment?: ModelSubscriptionIntInput | null,
  maxNumberUsers?: ModelSubscriptionIntInput | null,
  name?: ModelSubscriptionStringInput | null,
  nextBillingDate?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  numberOfUsers?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionCompanyFilterInput | null > | null,
  paidStartDate?: ModelSubscriptionStringInput | null,
  paymentFailedAt?: ModelSubscriptionStringInput | null,
  paymentMethod?: ModelSubscriptionStringInput | null,
  pmModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  primaryContactEmail?: ModelSubscriptionStringInput | null,
  primaryContactName?: ModelSubscriptionStringInput | null,
  primaryContactPhone?: ModelSubscriptionStringInput | null,
  primaryContactPosition?: ModelSubscriptionStringInput | null,
  primaryLocation?: ModelSubscriptionStringInput | null,
  referredBy?: ModelSubscriptionStringInput | null,
  retryAttempts?: ModelSubscriptionIntInput | null,
  safetyComplianceStandard?: ModelSubscriptionStringInput | null,
  secondaryContactEmail?: ModelSubscriptionStringInput | null,
  secondaryContactName?: ModelSubscriptionStringInput | null,
  secondaryContactPhone?: ModelSubscriptionStringInput | null,
  secondaryContactPosition?: ModelSubscriptionStringInput | null,
  skillTrackingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  starterPackage?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  subscriptionExpiration?: ModelSubscriptionStringInput | null,
  subscriptionType?: ModelSubscriptionStringInput | null,
  tiresModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  trainingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  trialEndDate?: ModelSubscriptionStringInput | null,
  trialStartDate?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionBooleanInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelSubscriptionCompanyNoteFilterInput = {
  and?: Array< ModelSubscriptionCompanyNoteFilterInput | null > | null,
  authorName?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  content?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionCompanyNoteFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionCompanyOwnerFilterInput = {
  and?: Array< ModelSubscriptionCompanyOwnerFilterInput | null > | null,
  cognitoId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  contactPhoneNumber?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  discrepancyNotification?: ModelSubscriptionBooleanInput | null,
  discrepancyNotificationTypes?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionCompanyOwnerFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelSubscriptionStringInput | null,
  pmNotification?: ModelSubscriptionBooleanInput | null,
  pmNotificationTypes?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  siteAdmin?: ModelSubscriptionBooleanInput | null,
  subscriptionType?: ModelSubscriptionStringInput | null,
  trainingNotification?: ModelSubscriptionBooleanInput | null,
  trainingNotificationTypes?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionCompanyResourceFilterInput = {
  and?: Array< ModelSubscriptionCompanyResourceFilterInput | null > | null,
  category?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  contentFilePath?: ModelSubscriptionStringInput | null,
  contentUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  fileType?: ModelSubscriptionStringInput | null,
  folderName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionCompanyResourceFilterInput | null > | null,
  owner?: ModelStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  trainingTopicId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  uploadedByUserId?: ModelSubscriptionStringInput | null,
  uploadedByUserName?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionDOTInspectionReportFilterInput = {
  and?: Array< ModelSubscriptionDOTInspectionReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  complianceStatus?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dotInspectionType?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  equipmentCategoryName?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  gpsLatitude?: ModelSubscriptionFloatInput | null,
  gpsLocationType?: ModelSubscriptionStringInput | null,
  gpsLongitude?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  inopCount?: ModelSubscriptionIntInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionDurationSeconds?: ModelSubscriptionIntInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  inspectorCertificationId?: ModelSubscriptionStringInput | null,
  locationId?: ModelSubscriptionStringInput | null,
  okCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionDOTInspectionReportFilterInput | null > | null,
  photos?: ModelSubscriptionStringInput | null,
  regulatoryStandard?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  totalItems?: ModelSubscriptionIntInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  vehicleLicensePlate?: ModelSubscriptionStringInput | null,
  vehicleVIN?: ModelSubscriptionStringInput | null,
  warnCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionDailyServiceReportFilterInput = {
  and?: Array< ModelSubscriptionDailyServiceReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dailyServiceLogFormId?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  equipmentCategoryName?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  gpsLatitude?: ModelSubscriptionFloatInput | null,
  gpsLocationType?: ModelSubscriptionStringInput | null,
  gpsLongitude?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  inopCount?: ModelSubscriptionIntInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionDurationSeconds?: ModelSubscriptionIntInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  locationId?: ModelSubscriptionStringInput | null,
  machineHoursAtService?: ModelSubscriptionFloatInput | null,
  okCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionDailyServiceReportFilterInput | null > | null,
  photos?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  totalItems?: ModelSubscriptionIntInput | null,
  umCounterAtService?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  warnCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionDiscrepancyFilterInput = {
  and?: Array< ModelSubscriptionDiscrepancyFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  downReason?: ModelSubscriptionStringInput | null,
  equipmentId?: ModelSubscriptionStringInput | null,
  equipmentName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  initialStatus?: ModelSubscriptionStringInput | null,
  log?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionDiscrepancyFilterInput | null > | null,
  owner?: ModelStringInput | null,
  promptDescription?: ModelSubscriptionStringInput | null,
  promptLabel?: ModelSubscriptionStringInput | null,
  promptTitle?: ModelSubscriptionStringInput | null,
  questionIndex?: ModelSubscriptionIntInput | null,
  reportId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionDocumentFilterInput = {
  and?: Array< ModelSubscriptionDocumentFilterInput | null > | null,
  assignedSafetyLesson?: ModelSubscriptionStringInput | null,
  contentPath?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  folderName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionDocumentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelSubscriptionIDInput | null,
  safetyLesson?: ModelSubscriptionBooleanInput | null,
  sharedWithCompanyIds?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionEquipmentFilterInput = {
  and?: Array< ModelSubscriptionEquipmentFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionEquipmentFilterInput | null > | null,
  units?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionEquipmentCategoryFilterInput = {
  and?: Array< ModelSubscriptionEquipmentCategoryFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionEquipmentCategoryFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionErrorsFilterInput = {
  and?: Array< ModelSubscriptionErrorsFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  errors?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionErrorsFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionExpenseCategoryFilterInput = {
  and?: Array< ModelSubscriptionExpenseCategoryFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionExpenseCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionExpenseRecordFilterInput = {
  and?: Array< ModelSubscriptionExpenseRecordFilterInput | null > | null,
  attachments?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dateOfInput?: ModelSubscriptionStringInput | null,
  dateOfService?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  expenseCategories?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  invoiceNumber?: ModelSubscriptionStringInput | null,
  laborHoursOT?: ModelSubscriptionFloatInput | null,
  laborHoursST?: ModelSubscriptionFloatInput | null,
  laborRateOT?: ModelSubscriptionFloatInput | null,
  laborRateST?: ModelSubscriptionFloatInput | null,
  laborRateScheduleId?: ModelSubscriptionStringInput | null,
  laborRateScheduleName?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionExpenseRecordFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmExpense?: ModelSubscriptionFloatInput | null,
  pmServiceLevelId?: ModelSubscriptionStringInput | null,
  pmServiceLevelName?: ModelSubscriptionStringInput | null,
  totalExpense?: ModelSubscriptionFloatInput | null,
  totalLaborCost?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  vendorId?: ModelSubscriptionStringInput | null,
  vendorName?: ModelSubscriptionStringInput | null,
  workDescription?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionFormFilterInput = {
  alwaysTriggerEmail?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionFormFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dailyServiceLogForm?: ModelSubscriptionBooleanInput | null,
  equipmentType?: ModelSubscriptionStringInput | null,
  formData?: ModelSubscriptionStringInput | null,
  formType?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  inspectionForm?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  noMachineHours?: ModelSubscriptionBooleanInput | null,
  noUMCounter?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionFormFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  umCounterLabel?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionFormTemplateFilterInput = {
  and?: Array< ModelSubscriptionFormTemplateFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByCompanyOwnerId?: ModelSubscriptionStringInput | null,
  dailyServiceLogForm?: ModelSubscriptionBooleanInput | null,
  formTemplateGroupID?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  inspectionForm?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionFormTemplateFilterInput | null > | null,
  originalCompanyId?: ModelSubscriptionStringInput | null,
  owner?: ModelStringInput | null,
  pmServiceScheduleForm?: ModelSubscriptionBooleanInput | null,
  templateData?: ModelSubscriptionStringInput | null,
  templateName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionFormTemplateGroupFilterInput = {
  and?: Array< ModelSubscriptionFormTemplateGroupFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionFormTemplateGroupFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelSubscriptionIDInput | null,
  sharedWithCompanyIds?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionHelpSupportDocFilterInput = {
  and?: Array< ModelSubscriptionHelpSupportDocFilterInput | null > | null,
  contentFilePath?: ModelSubscriptionStringInput | null,
  contentUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByAdminId?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  docType?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionHelpSupportDocFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  visibility?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionInspectionReportFilterInput = {
  alwaysTriggerEmail?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionInspectionReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  equipmentCategoryName?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  gpsLatitude?: ModelSubscriptionFloatInput | null,
  gpsLocationType?: ModelSubscriptionStringInput | null,
  gpsLongitude?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  inopCount?: ModelSubscriptionIntInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionDurationSeconds?: ModelSubscriptionIntInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  locationId?: ModelSubscriptionStringInput | null,
  machineHoursAtInspection?: ModelSubscriptionFloatInput | null,
  okCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionInspectionReportFilterInput | null > | null,
  photos?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  totalItems?: ModelSubscriptionIntInput | null,
  umCounterAtInspection?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  warnCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionInvoiceFilterInput = {
  amount?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionInvoiceFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  invoiceNumber?: ModelSubscriptionStringInput | null,
  lineItems?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionInvoiceFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pdfUrl?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionLaborCategoryFilterInput = {
  and?: Array< ModelSubscriptionLaborCategoryFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionLaborCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionLaborRateFilterInput = {
  and?: Array< ModelSubscriptionLaborRateFilterInput | null > | null,
  categoryId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  effectiveDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionLaborRateFilterInput | null > | null,
  overtimeRate?: ModelSubscriptionFloatInput | null,
  owner?: ModelStringInput | null,
  standardRate?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionLibraryPlanTemplateFilterInput = {
  and?: Array< ModelSubscriptionLibraryPlanTemplateFilterInput | null > | null,
  categories?: ModelSubscriptionStringInput | null,
  categoryCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByAdminId?: ModelSubscriptionStringInput | null,
  createdByAdminName?: ModelSubscriptionStringInput | null,
  cycleDuration?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  governingStandard?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  minimumTimeRequired?: ModelSubscriptionIntInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionLibraryPlanTemplateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sharedWithCompanyIds?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  topicCount?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  workingDays?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionLibraryTopicTemplateFilterInput = {
  and?: Array< ModelSubscriptionLibraryTopicTemplateFilterInput | null > | null,
  contentFilePath?: ModelSubscriptionStringInput | null,
  contentUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByAdminId?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionLibraryTopicTemplateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  style?: ModelSubscriptionStringInput | null,
  timeValue?: ModelSubscriptionIntInput | null,
  topicId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionLocationFilterInput = {
  and?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  regionalDivisionId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionModuleSubscriptionFilterInput = {
  activatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionModuleSubscriptionFilterInput | null > | null,
  cancelRequestedAt?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  effectiveEndDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  moduleKey?: ModelSubscriptionStringInput | null,
  monthlyRate?: ModelSubscriptionFloatInput | null,
  or?: Array< ModelSubscriptionModuleSubscriptionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pricingModel?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMConfigurationFilterInput = {
  and?: Array< ModelSubscriptionPMConfigurationFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dueSoonPercentage?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  laborCategoryId?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPMConfigurationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitOfMeasure?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMModuleContentFilterInput = {
  and?: Array< ModelSubscriptionPMModuleContentFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionPMModuleContentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmServiceFormId?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMNotificationSettingFilterInput = {
  and?: Array< ModelSubscriptionPMNotificationSettingFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  emailThresholdUM?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastNotificationSent?: ModelSubscriptionStringInput | null,
  notificationFrequency?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPMNotificationSettingFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelSubscriptionStringInput | null,
  recipients?: ModelSubscriptionStringInput | null,
  serviceLevelId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMPartsAndProcedureFilterInput = {
  and?: Array< ModelSubscriptionPMPartsAndProcedureFilterInput | null > | null,
  category?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByUserId?: ModelSubscriptionStringInput | null,
  createdByUserName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  itemName?: ModelSubscriptionStringInput | null,
  itemType?: ModelSubscriptionStringInput | null,
  manufacturer?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPMPartsAndProcedureFilterInput | null > | null,
  owner?: ModelStringInput | null,
  partNumber?: ModelSubscriptionStringInput | null,
  pmConfigurationId?: ModelSubscriptionStringInput | null,
  pmConfigurationIds?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  quantity?: ModelSubscriptionFloatInput | null,
  sortOrder?: ModelSubscriptionIntInput | null,
  unitOfMeasure?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  vendorId?: ModelSubscriptionStringInput | null,
  vendorName?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMReportFilterInput = {
  actualUM?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionPMReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  issueDescription?: ModelSubscriptionStringInput | null,
  issueTicketCreated?: ModelSubscriptionBooleanInput | null,
  issueTicketId?: ModelSubscriptionStringInput | null,
  laborHoursOT?: ModelSubscriptionFloatInput | null,
  laborHoursST?: ModelSubscriptionFloatInput | null,
  laborRateOT?: ModelSubscriptionFloatInput | null,
  laborRateST?: ModelSubscriptionFloatInput | null,
  laborRateScheduleId?: ModelSubscriptionStringInput | null,
  laborRateScheduleName?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPMReportFilterInput | null > | null,
  owner?: ModelStringInput | null,
  photos?: ModelSubscriptionStringInput | null,
  pmConfigurationId?: ModelSubscriptionStringInput | null,
  reportData?: ModelSubscriptionStringInput | null,
  serviceDate?: ModelSubscriptionStringInput | null,
  serviceLevelId?: ModelSubscriptionStringInput | null,
  serviceLevelName?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  technicianId?: ModelSubscriptionStringInput | null,
  technicianName?: ModelSubscriptionStringInput | null,
  totalLaborCost?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionPMServiceLevelFilterInput = {
  and?: Array< ModelSubscriptionPMServiceLevelFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  intervalValue?: ModelSubscriptionFloatInput | null,
  lastServiceDate?: ModelSubscriptionStringInput | null,
  lastServiceUM?: ModelSubscriptionFloatInput | null,
  levelIdentifier?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPMServiceLevelFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pmConfigurationId?: ModelSubscriptionStringInput | null,
  pmServiceFormId?: ModelSubscriptionStringInput | null,
  serviceLevelAssignments?: ModelSubscriptionStringInput | null,
  targetUM?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionRegionalDivisionFilterInput = {
  and?: Array< ModelSubscriptionRegionalDivisionFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionRegionalDivisionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionReportFilterInput = {
  alwaysTriggerEmail?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dailyServiceLogReport?: ModelSubscriptionBooleanInput | null,
  equipmentId?: ModelSubscriptionStringInput | null,
  equipmentLocationId?: ModelSubscriptionStringInput | null,
  equipmentName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionReportFilterInput | null > | null,
  signature?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userData?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userLocation?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionReportAnswerFilterInput = {
  and?: Array< ModelSubscriptionReportAnswerFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  notes?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionReportAnswerFilterInput | null > | null,
  parentReportId?: ModelSubscriptionStringInput | null,
  photos?: ModelSubscriptionStringInput | null,
  promptDescription?: ModelSubscriptionStringInput | null,
  promptKey?: ModelSubscriptionStringInput | null,
  promptLabel?: ModelSubscriptionStringInput | null,
  promptTitle?: ModelSubscriptionStringInput | null,
  promptType?: ModelSubscriptionStringInput | null,
  reportType?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionIntInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionResourceLibraryFilterInput = {
  and?: Array< ModelSubscriptionResourceLibraryFilterInput | null > | null,
  companyOwnerId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionResourceLibraryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSavedReportConfigurationFilterInput = {
  and?: Array< ModelSubscriptionSavedReportConfigurationFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  compareDateRangeEnd?: ModelSubscriptionStringInput | null,
  compareDateRangeStart?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dateRangeEnd?: ModelSubscriptionStringInput | null,
  dateRangeStart?: ModelSubscriptionStringInput | null,
  dateRangeType?: ModelSubscriptionStringInput | null,
  filtersJson?: ModelSubscriptionStringInput | null,
  groupByField?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastRunAt?: ModelSubscriptionStringInput | null,
  metricCategory?: ModelSubscriptionStringInput | null,
  metricKey?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSavedReportConfigurationFilterInput | null > | null,
  reportName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  visualizationType?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSensitiveUserInfoFilterInput = {
  and?: Array< ModelSubscriptionSensitiveUserInfoFilterInput | null > | null,
  cognitoId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dateOfBirth?: ModelSubscriptionStringInput | null,
  driversLicenseClass?: ModelSubscriptionStringInput | null,
  driversLicenseExpirationDate?: ModelSubscriptionStringInput | null,
  driversLicenseNumber?: ModelSubscriptionStringInput | null,
  driversLicenseState?: ModelSubscriptionStringInput | null,
  emergencyContactName?: ModelSubscriptionStringInput | null,
  emergencyContactPhoneNumber?: ModelSubscriptionStringInput | null,
  emergencyContactRelationship?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionSensitiveUserInfoFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionShiftReportFilterInput = {
  alwaysTriggerEmail?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionShiftReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  gpsLatitude?: ModelSubscriptionFloatInput | null,
  gpsLocationType?: ModelSubscriptionStringInput | null,
  gpsLongitude?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  inopCount?: ModelSubscriptionIntInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionDurationSeconds?: ModelSubscriptionIntInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  locationId?: ModelSubscriptionStringInput | null,
  locationName?: ModelSubscriptionStringInput | null,
  okCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionShiftReportFilterInput | null > | null,
  photos?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  shiftType?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  totalItems?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  warnCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionSingleUnitFilterInput = {
  and?: Array< ModelSubscriptionSingleUnitFilterInput | null > | null,
  annualProjectedUsage?: ModelSubscriptionFloatInput | null,
  aquisitionCost?: ModelSubscriptionFloatInput | null,
  aquisitionDate?: ModelSubscriptionStringInput | null,
  assignedTo?: ModelSubscriptionStringInput | null,
  axleConfiguration?: ModelSubscriptionStringInput | null,
  categoryId?: ModelSubscriptionIDInput | null,
  costTrackingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  currentMachineHours?: ModelSubscriptionFloatInput | null,
  currentUMCounterValue?: ModelSubscriptionFloatInput | null,
  dailyServiceLogFormId?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  dispositionDate?: ModelSubscriptionStringInput | null,
  dispositionReason?: ModelSubscriptionStringInput | null,
  downReason?: ModelSubscriptionStringInput | null,
  engineManufacturer?: ModelSubscriptionStringInput | null,
  engineModelNumber?: ModelSubscriptionStringInput | null,
  equipmentStatus?: ModelSubscriptionBooleanInput | null,
  extraUnitInfo?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  inputByPerson?: ModelSubscriptionStringInput | null,
  inputDate?: ModelSubscriptionStringInput | null,
  lastDailyServiceDate?: ModelSubscriptionStringInput | null,
  lastInspectionDate?: ModelSubscriptionStringInput | null,
  lastServiceHours?: ModelSubscriptionFloatInput | null,
  licenseNumber?: ModelSubscriptionStringInput | null,
  locationId?: ModelSubscriptionStringInput | null,
  machineHoursAtAquisition?: ModelSubscriptionFloatInput | null,
  machineUMCounterAtAquisition?: ModelSubscriptionFloatInput | null,
  manufactureDate?: ModelSubscriptionStringInput | null,
  manufacturerName?: ModelSubscriptionStringInput | null,
  modelNumber?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSingleUnitFilterInput | null > | null,
  pmModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  putInServiceDate?: ModelSubscriptionStringInput | null,
  removedFromServiceDate?: ModelSubscriptionStringInput | null,
  removedFromServiceReason?: ModelSubscriptionStringInput | null,
  replacedUMCounterHistory?: ModelSubscriptionStringInput | null,
  replacedUMCounterStatus?: ModelSubscriptionBooleanInput | null,
  replacedUMCounterValue?: ModelSubscriptionFloatInput | null,
  serialNumber?: ModelSubscriptionStringInput | null,
  tiresModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  unitOfMeasure?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  utilizationAdjustmentDays?: ModelSubscriptionFloatInput | null,
};

export type ModelSubscriptionSkillAssignmentFilterInput = {
  and?: Array< ModelSubscriptionSkillAssignmentFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  evaluatedBy?: ModelSubscriptionStringInput | null,
  evaluatedByName?: ModelSubscriptionStringInput | null,
  evaluationDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionSkillAssignmentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  skillLevel?: ModelSubscriptionStringInput | null,
  subCategoryId?: ModelSubscriptionStringInput | null,
  taskId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSkillCategoryFilterInput = {
  allowMachineNumber?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionSkillCategoryFilterInput | null > | null,
  classificationId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSkillCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSkillLevelFilterInput = {
  and?: Array< ModelSubscriptionSkillLevelFilterInput | null > | null,
  color?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSkillLevelFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sortOrder?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSkillTaskFilterInput = {
  and?: Array< ModelSubscriptionSkillTaskFilterInput | null > | null,
  categoryId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSkillTaskFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSubCategoryFilterInput = {
  and?: Array< ModelSubscriptionSubCategoryFilterInput | null > | null,
  categoryId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionSubCategoryFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTireFilterInput = {
  and?: Array< ModelSubscriptionTireFilterInput | null > | null,
  assignedAxle?: ModelSubscriptionStringInput | null,
  assignedPosition?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  currentTirePressure?: ModelSubscriptionFloatInput | null,
  currentTreadDepth?: ModelSubscriptionFloatInput | null,
  dateInstalled?: ModelSubscriptionStringInput | null,
  dateUninstalled?: ModelSubscriptionStringInput | null,
  failureReason?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  inflationMedium?: ModelSubscriptionStringInput | null,
  loadRating?: ModelSubscriptionFloatInput | null,
  loadRatingUnit?: ModelSubscriptionStringInput | null,
  minimumTreadDepth?: ModelSubscriptionFloatInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTireFilterInput | null > | null,
  owner?: ModelStringInput | null,
  recommendedTirePressure?: ModelSubscriptionFloatInput | null,
  removedFromService?: ModelSubscriptionBooleanInput | null,
  removedFromServiceDate?: ModelSubscriptionStringInput | null,
  tireCategory?: ModelSubscriptionStringInput | null,
  tireManufacturer?: ModelSubscriptionStringInput | null,
  tireModel?: ModelSubscriptionStringInput | null,
  tireSize?: ModelSubscriptionStringInput | null,
  tireStatus?: ModelSubscriptionStringInput | null,
  treadDepthAtInstall?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTireReportFilterInput = {
  alwaysTriggerEmail?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionTireReportFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  equipmentCategoryId?: ModelSubscriptionStringInput | null,
  equipmentCategoryName?: ModelSubscriptionStringInput | null,
  equipmentLocationId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTireReportFilterInput | null > | null,
  signature?: ModelSubscriptionStringInput | null,
  tireId?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  unitName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userData?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userLocation?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingAffidavitFilterInput = {
  adminId?: ModelSubscriptionStringInput | null,
  affidavitDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTrainingAffidavitFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  legalText?: ModelSubscriptionStringInput | null,
  nextDueDate?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTrainingAffidavitFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelSubscriptionStringInput | null,
  signaturePath?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingCompletionFilterInput = {
  and?: Array< ModelSubscriptionTrainingCompletionFilterInput | null > | null,
  categoryId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  completionDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  launched?: ModelSubscriptionBooleanInput | null,
  markedAsViewed?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionTrainingCompletionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelSubscriptionStringInput | null,
  scheduleDate?: ModelSubscriptionStringInput | null,
  signaturePath?: ModelSubscriptionStringInput | null,
  timeValueMinutes?: ModelSubscriptionIntInput | null,
  topicId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingEnrollmentFilterInput = {
  and?: Array< ModelSubscriptionTrainingEnrollmentFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  enrolledDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastCompletionDate?: ModelSubscriptionStringInput | null,
  nextDueDate?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTrainingEnrollmentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingPlanFilterInput = {
  and?: Array< ModelSubscriptionTrainingPlanFilterInput | null > | null,
  categories?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  cycleDuration?: ModelSubscriptionIntInput | null,
  governingStandard?: ModelSubscriptionStringInput | null,
  holidays?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  minimumTimeRequired?: ModelSubscriptionIntInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTrainingPlanFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  workingDays?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionTrainingQuizResponseFilterInput = {
  and?: Array< ModelSubscriptionTrainingQuizResponseFilterInput | null > | null,
  attemptNumber?: ModelSubscriptionIntInput | null,
  categoryId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  completedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  cycleStartDate?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionTrainingQuizResponseFilterInput | null > | null,
  owner?: ModelStringInput | null,
  passed?: ModelSubscriptionBooleanInput | null,
  planId?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  score?: ModelSubscriptionIntInput | null,
  signaturePath?: ModelSubscriptionStringInput | null,
  totalQuestions?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingScheduleFilterInput = {
  and?: Array< ModelSubscriptionTrainingScheduleFilterInput | null > | null,
  assignedUserId?: ModelSubscriptionStringInput | null,
  categoryId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dayNumber?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  locked?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionTrainingScheduleFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planId?: ModelSubscriptionStringInput | null,
  scheduledDate?: ModelSubscriptionStringInput | null,
  topicId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionTrainingTopicFilterInput = {
  and?: Array< ModelSubscriptionTrainingTopicFilterInput | null > | null,
  categoryIds?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  companyResourceId?: ModelSubscriptionStringInput | null,
  contentFilePath?: ModelSubscriptionStringInput | null,
  contentUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionTrainingTopicFilterInput | null > | null,
  owner?: ModelStringInput | null,
  planIds?: ModelSubscriptionStringInput | null,
  style?: ModelSubscriptionStringInput | null,
  timeValue?: ModelSubscriptionIntInput | null,
  topicId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUnitExpenseBudgetFilterInput = {
  and?: Array< ModelSubscriptionUnitExpenseBudgetFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expenseCategoryId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionUnitExpenseBudgetFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startingBalance?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  cognitoId?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  contactPhoneNumber?: ModelSubscriptionStringInput | null,
  contactPhoneType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  currentJobClassification?: ModelSubscriptionStringInput | null,
  dateOfHire?: ModelSubscriptionStringInput | null,
  discrepancyNotification?: ModelSubscriptionBooleanInput | null,
  discrepancyNotificationTypes?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  driversLicenseStatus?: ModelSubscriptionBooleanInput | null,
  email?: ModelSubscriptionStringInput | null,
  globalLocationPermission?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  inputByPerson?: ModelSubscriptionStringInput | null,
  inputDate?: ModelSubscriptionStringInput | null,
  locationAssignment?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  notesAboutUser?: ModelSubscriptionStringInput | null,
  onHighwayEligibility?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  owner?: ModelStringInput | null,
  permissions?: ModelSubscriptionStringInput | null,
  personalIdentification?: ModelSubscriptionStringInput | null,
  pmNotification?: ModelSubscriptionBooleanInput | null,
  pmNotificationTypes?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionStringInput | null,
  regionalAssignment?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  safetyLessons?: ModelSubscriptionStringInput | null,
  skillTrackingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  trainingModuleEnrollment?: ModelSubscriptionBooleanInput | null,
  trainingNotification?: ModelSubscriptionBooleanInput | null,
  trainingNotificationTypes?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userPhoto?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUserFileFilterInput = {
  and?: Array< ModelSubscriptionUserFileFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  fileName?: ModelSubscriptionStringInput | null,
  fileSize?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionUserFileFilterInput | null > | null,
  owner?: ModelStringInput | null,
  s3Path?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  uploadedAt?: ModelSubscriptionStringInput | null,
  uploadedBy?: ModelSubscriptionStringInput | null,
  uploadedByName?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUserReportFavoriteFilterInput = {
  and?: Array< ModelSubscriptionUserReportFavoriteFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionUserReportFavoriteFilterInput | null > | null,
  reportTypeKey?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUserSkillReportFilterInput = {
  and?: Array< ModelSubscriptionUserSkillReportFilterInput | null > | null,
  assessorId?: ModelSubscriptionStringInput | null,
  assessorName?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  formId?: ModelSubscriptionStringInput | null,
  gpsLatitude?: ModelSubscriptionFloatInput | null,
  gpsLocationType?: ModelSubscriptionStringInput | null,
  gpsLongitude?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  inopCount?: ModelSubscriptionIntInput | null,
  inspectionCompleted?: ModelSubscriptionStringInput | null,
  inspectionDurationSeconds?: ModelSubscriptionIntInput | null,
  inspectionStarted?: ModelSubscriptionStringInput | null,
  okCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionUserSkillReportFilterInput | null > | null,
  passFailStatus?: ModelSubscriptionStringInput | null,
  photos?: ModelSubscriptionStringInput | null,
  qualificationLevel?: ModelSubscriptionStringInput | null,
  responseData?: ModelSubscriptionStringInput | null,
  signature?: ModelSubscriptionStringInput | null,
  skillCategory?: ModelSubscriptionStringInput | null,
  skillName?: ModelSubscriptionStringInput | null,
  totalItems?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  warnCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionVendorListFilterInput = {
  address?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVendorListFilterInput | null > | null,
  companyId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  faxNumber?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionVendorListFilterInput | null > | null,
  owner?: ModelStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  repName?: ModelSubscriptionStringInput | null,
  repPhoneNumber?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionVideoFilterInput = {
  and?: Array< ModelSubscriptionVideoFilterInput | null > | null,
  assignedSafetyLesson?: ModelSubscriptionStringInput | null,
  contentPath?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  folderName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionVideoFilterInput | null > | null,
  owner?: ModelStringInput | null,
  resourceLibraryID?: ModelSubscriptionIDInput | null,
  safetyLesson?: ModelSubscriptionBooleanInput | null,
  sharedWithCompanyIds?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type BlueprintsByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelAxleBlueprintFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type BlueprintsByCompanyIdQuery = {
  blueprintsByCompanyId?:  {
    __typename: "ModelAxleBlueprintConnection",
    items:  Array< {
      __typename: "AxleBlueprint",
      axles: string,
      centerlineLength: number,
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BusinessAdminsByCognitoIdQueryVariables = {
  cognitoId: string,
  filter?: ModelBusinessAdminFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type BusinessAdminsByCognitoIdQuery = {
  businessAdminsByCognitoId?:  {
    __typename: "ModelBusinessAdminConnection",
    items:  Array< {
      __typename: "BusinessAdmin",
      cognitoId: string,
      createdAt: string,
      domain?: string | null,
      email: string,
      id: string,
      name: string,
      owner?: string | null,
      permissions?: string | null,
      role: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ChangeLogEntriesByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelChangeLogEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ChangeLogEntriesByUserIdAndCreatedAtQuery = {
  changeLogEntriesByUserIdAndCreatedAt?:  {
    __typename: "ModelChangeLogEntryConnection",
    items:  Array< {
      __typename: "ChangeLogEntry",
      changedBy: string,
      changedByName: string,
      companyId: string,
      createdAt?: string | null,
      description: string,
      fieldName: string,
      id: string,
      newValue?: string | null,
      oldValue?: string | null,
      owner?: string | null,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ClassificationsByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelClassificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ClassificationsByCompanyIdQuery = {
  classificationsByCompanyId?:  {
    __typename: "ModelClassificationConnection",
    items:  Array< {
      __typename: "Classification",
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CompanyOwnersByCognitoIdQueryVariables = {
  cognitoId: string,
  filter?: ModelCompanyOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type CompanyOwnersByCognitoIdQuery = {
  companyOwnersByCognitoId?:  {
    __typename: "ModelCompanyOwnerConnection",
    items:  Array< {
      __typename: "CompanyOwner",
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      createdAt: string,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      email: string,
      id: string,
      name: string,
      owner?: string | null,
      permissions?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      role?: string | null,
      siteAdmin: boolean,
      subscriptionType: string,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetArchivedDiscrepancyQueryVariables = {
  id: string,
};

export type GetArchivedDiscrepancyQuery = {
  getArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type GetAuditLogQueryVariables = {
  id: string,
};

export type GetAuditLogQuery = {
  getAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type GetAxleBlueprintQueryVariables = {
  id: string,
};

export type GetAxleBlueprintQuery = {
  getAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetBillingRateQueryVariables = {
  id: string,
};

export type GetBillingRateQuery = {
  getBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type GetBusinessAdminQueryVariables = {
  id: string,
};

export type GetBusinessAdminQuery = {
  getBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type GetChangeLogEntryQueryVariables = {
  id: string,
};

export type GetChangeLogEntryQuery = {
  getChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetClassificationQueryVariables = {
  id: string,
};

export type GetClassificationQuery = {
  getClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
};

export type GetCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type GetCompanyNoteQueryVariables = {
  id: string,
};

export type GetCompanyNoteQuery = {
  getCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetCompanyOwnerQueryVariables = {
  id: string,
};

export type GetCompanyOwnerQuery = {
  getCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type GetCompanyResourceQueryVariables = {
  id: string,
};

export type GetCompanyResourceQuery = {
  getCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type GetDOTInspectionReportQueryVariables = {
  id: string,
};

export type GetDOTInspectionReportQuery = {
  getDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type GetDailyServiceReportQueryVariables = {
  id: string,
};

export type GetDailyServiceReportQuery = {
  getDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type GetDiscrepancyQueryVariables = {
  id: string,
};

export type GetDiscrepancyQuery = {
  getDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type GetDocumentQueryVariables = {
  id: string,
};

export type GetDocumentQuery = {
  getDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type GetEquipmentQueryVariables = {
  id: string,
};

export type GetEquipmentQuery = {
  getEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type GetEquipmentCategoryQueryVariables = {
  id: string,
};

export type GetEquipmentCategoryQuery = {
  getEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type GetErrorsQueryVariables = {
  id: string,
};

export type GetErrorsQuery = {
  getErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type GetExpenseCategoryQueryVariables = {
  id: string,
};

export type GetExpenseCategoryQuery = {
  getExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type GetExpenseRecordQueryVariables = {
  id: string,
};

export type GetExpenseRecordQuery = {
  getExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type GetFormQueryVariables = {
  id: string,
};

export type GetFormQuery = {
  getForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type GetFormTemplateQueryVariables = {
  id: string,
};

export type GetFormTemplateQuery = {
  getFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type GetFormTemplateGroupQueryVariables = {
  id: string,
};

export type GetFormTemplateGroupQuery = {
  getFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type GetHelpSupportDocQueryVariables = {
  id: string,
};

export type GetHelpSupportDocQuery = {
  getHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type GetInspectionReportQueryVariables = {
  id: string,
};

export type GetInspectionReportQuery = {
  getInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type GetInvoiceQueryVariables = {
  id: string,
};

export type GetInvoiceQuery = {
  getInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type GetLaborCategoryQueryVariables = {
  id: string,
};

export type GetLaborCategoryQuery = {
  getLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetLaborRateQueryVariables = {
  id: string,
};

export type GetLaborRateQuery = {
  getLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type GetLibraryPlanTemplateQueryVariables = {
  id: string,
};

export type GetLibraryPlanTemplateQuery = {
  getLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type GetLibraryTopicTemplateQueryVariables = {
  id: string,
};

export type GetLibraryTopicTemplateQuery = {
  getLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type GetModuleSubscriptionQueryVariables = {
  id: string,
};

export type GetModuleSubscriptionQuery = {
  getModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type GetPMConfigurationQueryVariables = {
  id: string,
};

export type GetPMConfigurationQuery = {
  getPMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type GetPMModuleContentQueryVariables = {
  id: string,
};

export type GetPMModuleContentQuery = {
  getPMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type GetPMNotificationSettingQueryVariables = {
  id: string,
};

export type GetPMNotificationSettingQuery = {
  getPMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type GetPMPartsAndProcedureQueryVariables = {
  id: string,
};

export type GetPMPartsAndProcedureQuery = {
  getPMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type GetPMReportQueryVariables = {
  id: string,
};

export type GetPMReportQuery = {
  getPMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type GetPMServiceLevelQueryVariables = {
  id: string,
};

export type GetPMServiceLevelQuery = {
  getPMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type GetRegionalDivisionQueryVariables = {
  id: string,
};

export type GetRegionalDivisionQuery = {
  getRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetReportQueryVariables = {
  id: string,
};

export type GetReportQuery = {
  getReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type GetReportAnswerQueryVariables = {
  id: string,
};

export type GetReportAnswerQuery = {
  getReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type GetResourceLibraryQueryVariables = {
  id: string,
};

export type GetResourceLibraryQuery = {
  getResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetSavedReportConfigurationQueryVariables = {
  id: string,
};

export type GetSavedReportConfigurationQuery = {
  getSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type GetSensitiveUserInfoQueryVariables = {
  id: string,
};

export type GetSensitiveUserInfoQuery = {
  getSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetShiftReportQueryVariables = {
  id: string,
};

export type GetShiftReportQuery = {
  getShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type GetSingleUnitQueryVariables = {
  id: string,
};

export type GetSingleUnitQuery = {
  getSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type GetSkillAssignmentQueryVariables = {
  id: string,
};

export type GetSkillAssignmentQuery = {
  getSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetSkillCategoryQueryVariables = {
  id: string,
};

export type GetSkillCategoryQuery = {
  getSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetSkillLevelQueryVariables = {
  id: string,
};

export type GetSkillLevelQuery = {
  getSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type GetSkillTaskQueryVariables = {
  id: string,
};

export type GetSkillTaskQuery = {
  getSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetSubCategoryQueryVariables = {
  id: string,
};

export type GetSubCategoryQuery = {
  getSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type GetTireQueryVariables = {
  id: string,
};

export type GetTireQuery = {
  getTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type GetTireReportQueryVariables = {
  id: string,
};

export type GetTireReportQuery = {
  getTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type GetTrainingAffidavitQueryVariables = {
  id: string,
};

export type GetTrainingAffidavitQuery = {
  getTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetTrainingCompletionQueryVariables = {
  id: string,
};

export type GetTrainingCompletionQuery = {
  getTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetTrainingEnrollmentQueryVariables = {
  id: string,
};

export type GetTrainingEnrollmentQuery = {
  getTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetTrainingPlanQueryVariables = {
  id: string,
};

export type GetTrainingPlanQuery = {
  getTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type GetTrainingQuizResponseQueryVariables = {
  id: string,
};

export type GetTrainingQuizResponseQuery = {
  getTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetTrainingScheduleQueryVariables = {
  id: string,
};

export type GetTrainingScheduleQuery = {
  getTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type GetTrainingTopicQueryVariables = {
  id: string,
};

export type GetTrainingTopicQuery = {
  getTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type GetUnitExpenseBudgetQueryVariables = {
  id: string,
};

export type GetUnitExpenseBudgetQuery = {
  getUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type GetUserFileQueryVariables = {
  id: string,
};

export type GetUserFileQuery = {
  getUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type GetUserReportFavoriteQueryVariables = {
  id: string,
};

export type GetUserReportFavoriteQuery = {
  getUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type GetUserSkillReportQueryVariables = {
  id: string,
};

export type GetUserSkillReportQuery = {
  getUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type GetVendorListQueryVariables = {
  id: string,
};

export type GetVendorListQuery = {
  getVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type GetVideoQueryVariables = {
  id: string,
};

export type GetVideoQuery = {
  getVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type ListArchivedDiscrepanciesQueryVariables = {
  filter?: ModelArchivedDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListArchivedDiscrepanciesQuery = {
  listArchivedDiscrepancies?:  {
    __typename: "ModelArchivedDiscrepancyConnection",
    items:  Array< {
      __typename: "ArchivedDiscrepancy",
      archivedDate?: string | null,
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListArchivedDiscrepancyByCompanyIdAndUpdatedAtQueryVariables = {
  companyId: string,
  filter?: ModelArchivedDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListArchivedDiscrepancyByCompanyIdAndUpdatedAtQuery = {
  listArchivedDiscrepancyByCompanyIdAndUpdatedAt?:  {
    __typename: "ModelArchivedDiscrepancyConnection",
    items:  Array< {
      __typename: "ArchivedDiscrepancy",
      archivedDate?: string | null,
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListArchivedDiscrepancyByEquipmentIdAndUpdatedAtQueryVariables = {
  equipmentId: string,
  filter?: ModelArchivedDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListArchivedDiscrepancyByEquipmentIdAndUpdatedAtQuery = {
  listArchivedDiscrepancyByEquipmentIdAndUpdatedAt?:  {
    __typename: "ModelArchivedDiscrepancyConnection",
    items:  Array< {
      __typename: "ArchivedDiscrepancy",
      archivedDate?: string | null,
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListArchivedDiscrepancyByUnitIdAndUpdatedAtQueryVariables = {
  filter?: ModelArchivedDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListArchivedDiscrepancyByUnitIdAndUpdatedAtQuery = {
  listArchivedDiscrepancyByUnitIdAndUpdatedAt?:  {
    __typename: "ModelArchivedDiscrepancyConnection",
    items:  Array< {
      __typename: "ArchivedDiscrepancy",
      archivedDate?: string | null,
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAuditLogByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAuditLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAuditLogByCompanyIdAndCreatedAtQuery = {
  listAuditLogByCompanyIdAndCreatedAt?:  {
    __typename: "ModelAuditLogConnection",
    items:  Array< {
      __typename: "AuditLog",
      action: string,
      companyId: string,
      createdAt?: string | null,
      details?: string | null,
      id: string,
      resourceId: string,
      resourceName?: string | null,
      resourceType: string,
      ttl?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAuditLogsQueryVariables = {
  filter?: ModelAuditLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAuditLogsQuery = {
  listAuditLogs?:  {
    __typename: "ModelAuditLogConnection",
    items:  Array< {
      __typename: "AuditLog",
      action: string,
      companyId: string,
      createdAt?: string | null,
      details?: string | null,
      id: string,
      resourceId: string,
      resourceName?: string | null,
      resourceType: string,
      ttl?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAxleBlueprintsQueryVariables = {
  filter?: ModelAxleBlueprintFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAxleBlueprintsQuery = {
  listAxleBlueprints?:  {
    __typename: "ModelAxleBlueprintConnection",
    items:  Array< {
      __typename: "AxleBlueprint",
      axles: string,
      centerlineLength: number,
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBillingRateByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelBillingRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBillingRateByCompanyIdQuery = {
  listBillingRateByCompanyId?:  {
    __typename: "ModelBillingRateConnection",
    items:  Array< {
      __typename: "BillingRate",
      companyId: string,
      createdAt: string,
      id: string,
      owner?: string | null,
      ratePerCostTracking?: number | null,
      ratePerEquipment?: number | null,
      ratePerPM?: number | null,
      ratePerSafetyEnrollment?: number | null,
      ratePerSkillQualification?: number | null,
      ratePerTireMaint?: number | null,
      ratePerUser?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBillingRatesQueryVariables = {
  filter?: ModelBillingRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBillingRatesQuery = {
  listBillingRates?:  {
    __typename: "ModelBillingRateConnection",
    items:  Array< {
      __typename: "BillingRate",
      companyId: string,
      createdAt: string,
      id: string,
      owner?: string | null,
      ratePerCostTracking?: number | null,
      ratePerEquipment?: number | null,
      ratePerPM?: number | null,
      ratePerSafetyEnrollment?: number | null,
      ratePerSkillQualification?: number | null,
      ratePerTireMaint?: number | null,
      ratePerUser?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBusinessAdminsQueryVariables = {
  filter?: ModelBusinessAdminFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBusinessAdminsQuery = {
  listBusinessAdmins?:  {
    __typename: "ModelBusinessAdminConnection",
    items:  Array< {
      __typename: "BusinessAdmin",
      cognitoId: string,
      createdAt: string,
      domain?: string | null,
      email: string,
      id: string,
      name: string,
      owner?: string | null,
      permissions?: string | null,
      role: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChangeLogEntriesQueryVariables = {
  filter?: ModelChangeLogEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChangeLogEntriesQuery = {
  listChangeLogEntries?:  {
    __typename: "ModelChangeLogEntryConnection",
    items:  Array< {
      __typename: "ChangeLogEntry",
      changedBy: string,
      changedByName: string,
      companyId: string,
      createdAt?: string | null,
      description: string,
      fieldName: string,
      id: string,
      newValue?: string | null,
      oldValue?: string | null,
      owner?: string | null,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListClassificationsQueryVariables = {
  filter?: ModelClassificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClassificationsQuery = {
  listClassifications?:  {
    __typename: "ModelClassificationConnection",
    items:  Array< {
      __typename: "Classification",
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesQueryVariables = {
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompaniesQuery = {
  listCompanies?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      accountNumber?: string | null,
      accountOrigin?: string | null,
      accountStatus?: string | null,
      addOnGracePeriodEndDate?: string | null,
      archived?: boolean | null,
      assignedRep?: string | null,
      billingAnchorDay?: number | null,
      billingContactAddress?: string | null,
      billingContactEmail?: string | null,
      billingContactName?: string | null,
      billingContactPhone?: string | null,
      billingCycle?: string | null,
      businessType?: string | null,
      cancelEffectiveDate?: string | null,
      cancelReason?: string | null,
      cancelReasonNote?: string | null,
      cancelRequestedAt?: string | null,
      companyOwnerId?: string | null,
      coreMonthlyRate?: number | null,
      costTrackingModuleEnrollment?: boolean | null,
      createdAt: string,
      dataRetentionEndDate?: string | null,
      description?: string | null,
      gracePeriodEndDate?: string | null,
      id: string,
      industryNAICS?: string | null,
      industrySIC?: string | null,
      initialContactDate?: string | null,
      initialStarterPackageEnrollment?: boolean | null,
      logo?: string | null,
      maxNumberEquipment: number,
      maxNumberUsers: number,
      name: string,
      nextBillingDate?: string | null,
      notes?: string | null,
      numberOfUsers?: number | null,
      paidStartDate?: string | null,
      paymentFailedAt?: string | null,
      paymentMethod?: string | null,
      pmModuleEnrollment?: boolean | null,
      primaryContactEmail?: string | null,
      primaryContactName?: string | null,
      primaryContactPhone?: string | null,
      primaryContactPosition?: string | null,
      primaryLocation?: string | null,
      referredBy?: string | null,
      retryAttempts?: number | null,
      safetyComplianceStandard?: string | null,
      secondaryContactEmail?: string | null,
      secondaryContactName?: string | null,
      secondaryContactPhone?: string | null,
      secondaryContactPosition?: string | null,
      skillTrackingModuleEnrollment?: boolean | null,
      starterPackage?: string | null,
      status?: string | null,
      subscriptionExpiration: string,
      subscriptionType: string,
      tiresModuleEnrollment?: boolean | null,
      trainingModuleEnrollment?: boolean | null,
      trialEndDate?: string | null,
      trialStartDate?: string | null,
      type?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyByCompanyOwnerIdQueryVariables = {
  companyOwnerId: string,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanyByCompanyOwnerIdQuery = {
  listCompanyByCompanyOwnerId?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      accountNumber?: string | null,
      accountOrigin?: string | null,
      accountStatus?: string | null,
      addOnGracePeriodEndDate?: string | null,
      archived?: boolean | null,
      assignedRep?: string | null,
      billingAnchorDay?: number | null,
      billingContactAddress?: string | null,
      billingContactEmail?: string | null,
      billingContactName?: string | null,
      billingContactPhone?: string | null,
      billingCycle?: string | null,
      businessType?: string | null,
      cancelEffectiveDate?: string | null,
      cancelReason?: string | null,
      cancelReasonNote?: string | null,
      cancelRequestedAt?: string | null,
      companyOwnerId?: string | null,
      coreMonthlyRate?: number | null,
      costTrackingModuleEnrollment?: boolean | null,
      createdAt: string,
      dataRetentionEndDate?: string | null,
      description?: string | null,
      gracePeriodEndDate?: string | null,
      id: string,
      industryNAICS?: string | null,
      industrySIC?: string | null,
      initialContactDate?: string | null,
      initialStarterPackageEnrollment?: boolean | null,
      logo?: string | null,
      maxNumberEquipment: number,
      maxNumberUsers: number,
      name: string,
      nextBillingDate?: string | null,
      notes?: string | null,
      numberOfUsers?: number | null,
      paidStartDate?: string | null,
      paymentFailedAt?: string | null,
      paymentMethod?: string | null,
      pmModuleEnrollment?: boolean | null,
      primaryContactEmail?: string | null,
      primaryContactName?: string | null,
      primaryContactPhone?: string | null,
      primaryContactPosition?: string | null,
      primaryLocation?: string | null,
      referredBy?: string | null,
      retryAttempts?: number | null,
      safetyComplianceStandard?: string | null,
      secondaryContactEmail?: string | null,
      secondaryContactName?: string | null,
      secondaryContactPhone?: string | null,
      secondaryContactPosition?: string | null,
      skillTrackingModuleEnrollment?: boolean | null,
      starterPackage?: string | null,
      status?: string | null,
      subscriptionExpiration: string,
      subscriptionType: string,
      tiresModuleEnrollment?: boolean | null,
      trainingModuleEnrollment?: boolean | null,
      trialEndDate?: string | null,
      trialStartDate?: string | null,
      type?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyNoteByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelCompanyNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanyNoteByCompanyIdAndCreatedAtQuery = {
  listCompanyNoteByCompanyIdAndCreatedAt?:  {
    __typename: "ModelCompanyNoteConnection",
    items:  Array< {
      __typename: "CompanyNote",
      authorName: string,
      companyId: string,
      content: string,
      createdAt?: string | null,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyNotesQueryVariables = {
  filter?: ModelCompanyNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyNotesQuery = {
  listCompanyNotes?:  {
    __typename: "ModelCompanyNoteConnection",
    items:  Array< {
      __typename: "CompanyNote",
      authorName: string,
      companyId: string,
      content: string,
      createdAt?: string | null,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyOwnerByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelCompanyOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanyOwnerByCompanyIdQuery = {
  listCompanyOwnerByCompanyId?:  {
    __typename: "ModelCompanyOwnerConnection",
    items:  Array< {
      __typename: "CompanyOwner",
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      createdAt: string,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      email: string,
      id: string,
      name: string,
      owner?: string | null,
      permissions?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      role?: string | null,
      siteAdmin: boolean,
      subscriptionType: string,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyOwnersQueryVariables = {
  filter?: ModelCompanyOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyOwnersQuery = {
  listCompanyOwners?:  {
    __typename: "ModelCompanyOwnerConnection",
    items:  Array< {
      __typename: "CompanyOwner",
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      createdAt: string,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      email: string,
      id: string,
      name: string,
      owner?: string | null,
      permissions?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      role?: string | null,
      siteAdmin: boolean,
      subscriptionType: string,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyResourceByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelCompanyResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanyResourceByCompanyIdQuery = {
  listCompanyResourceByCompanyId?:  {
    __typename: "ModelCompanyResourceConnection",
    items:  Array< {
      __typename: "CompanyResource",
      category: string,
      companyId: string,
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      description?: string | null,
      fileType: string,
      folderName?: string | null,
      id: string,
      owner?: string | null,
      title: string,
      trainingTopicId?: string | null,
      updatedAt: string,
      uploadedByUserId?: string | null,
      uploadedByUserName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyResourcesQueryVariables = {
  filter?: ModelCompanyResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyResourcesQuery = {
  listCompanyResources?:  {
    __typename: "ModelCompanyResourceConnection",
    items:  Array< {
      __typename: "CompanyResource",
      category: string,
      companyId: string,
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      description?: string | null,
      fileType: string,
      folderName?: string | null,
      id: string,
      owner?: string | null,
      title: string,
      trainingTopicId?: string | null,
      updatedAt: string,
      uploadedByUserId?: string | null,
      uploadedByUserName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDOTInspectionReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDOTInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDOTInspectionReportByCompanyIdAndCreatedAtQuery = {
  listDOTInspectionReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelDOTInspectionReportConnection",
    items:  Array< {
      __typename: "DOTInspectionReport",
      companyId: string,
      complianceStatus?: string | null,
      createdAt?: string | null,
      dotInspectionType?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      inspectorCertificationId?: string | null,
      locationId?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      regulatoryStandard?: string | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      vehicleLicensePlate?: string | null,
      vehicleVIN?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDOTInspectionReportByEquipmentCategoryIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  equipmentCategoryId: string,
  filter?: ModelDOTInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDOTInspectionReportByEquipmentCategoryIdAndCreatedAtQuery = {
  listDOTInspectionReportByEquipmentCategoryIdAndCreatedAt?:  {
    __typename: "ModelDOTInspectionReportConnection",
    items:  Array< {
      __typename: "DOTInspectionReport",
      companyId: string,
      complianceStatus?: string | null,
      createdAt?: string | null,
      dotInspectionType?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      inspectorCertificationId?: string | null,
      locationId?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      regulatoryStandard?: string | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      vehicleLicensePlate?: string | null,
      vehicleVIN?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDOTInspectionReportByUnitIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDOTInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListDOTInspectionReportByUnitIdAndCreatedAtQuery = {
  listDOTInspectionReportByUnitIdAndCreatedAt?:  {
    __typename: "ModelDOTInspectionReportConnection",
    items:  Array< {
      __typename: "DOTInspectionReport",
      companyId: string,
      complianceStatus?: string | null,
      createdAt?: string | null,
      dotInspectionType?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      inspectorCertificationId?: string | null,
      locationId?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      regulatoryStandard?: string | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      vehicleLicensePlate?: string | null,
      vehicleVIN?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDOTInspectionReportByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDOTInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListDOTInspectionReportByUserIdAndCreatedAtQuery = {
  listDOTInspectionReportByUserIdAndCreatedAt?:  {
    __typename: "ModelDOTInspectionReportConnection",
    items:  Array< {
      __typename: "DOTInspectionReport",
      companyId: string,
      complianceStatus?: string | null,
      createdAt?: string | null,
      dotInspectionType?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      inspectorCertificationId?: string | null,
      locationId?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      regulatoryStandard?: string | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      vehicleLicensePlate?: string | null,
      vehicleVIN?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDOTInspectionReportsQueryVariables = {
  filter?: ModelDOTInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDOTInspectionReportsQuery = {
  listDOTInspectionReports?:  {
    __typename: "ModelDOTInspectionReportConnection",
    items:  Array< {
      __typename: "DOTInspectionReport",
      companyId: string,
      complianceStatus?: string | null,
      createdAt?: string | null,
      dotInspectionType?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      inspectorCertificationId?: string | null,
      locationId?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      regulatoryStandard?: string | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      vehicleLicensePlate?: string | null,
      vehicleVIN?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyServiceReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDailyServiceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDailyServiceReportByCompanyIdAndCreatedAtQuery = {
  listDailyServiceReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelDailyServiceReportConnection",
    items:  Array< {
      __typename: "DailyServiceReport",
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogFormId?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtService?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtService?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyServiceReportByEquipmentCategoryIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  equipmentCategoryId: string,
  filter?: ModelDailyServiceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDailyServiceReportByEquipmentCategoryIdAndCreatedAtQuery = {
  listDailyServiceReportByEquipmentCategoryIdAndCreatedAt?:  {
    __typename: "ModelDailyServiceReportConnection",
    items:  Array< {
      __typename: "DailyServiceReport",
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogFormId?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtService?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtService?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyServiceReportByUnitIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDailyServiceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListDailyServiceReportByUnitIdAndCreatedAtQuery = {
  listDailyServiceReportByUnitIdAndCreatedAt?:  {
    __typename: "ModelDailyServiceReportConnection",
    items:  Array< {
      __typename: "DailyServiceReport",
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogFormId?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtService?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtService?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyServiceReportByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDailyServiceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListDailyServiceReportByUserIdAndCreatedAtQuery = {
  listDailyServiceReportByUserIdAndCreatedAt?:  {
    __typename: "ModelDailyServiceReportConnection",
    items:  Array< {
      __typename: "DailyServiceReport",
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogFormId?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtService?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtService?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyServiceReportsQueryVariables = {
  filter?: ModelDailyServiceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDailyServiceReportsQuery = {
  listDailyServiceReports?:  {
    __typename: "ModelDailyServiceReportConnection",
    items:  Array< {
      __typename: "DailyServiceReport",
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogFormId?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtService?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtService?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscrepanciesQueryVariables = {
  filter?: ModelDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscrepanciesQuery = {
  listDiscrepancies?:  {
    __typename: "ModelDiscrepancyConnection",
    items:  Array< {
      __typename: "Discrepancy",
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscrepancyByCompanyIdAndUpdatedAtQueryVariables = {
  companyId: string,
  filter?: ModelDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListDiscrepancyByCompanyIdAndUpdatedAtQuery = {
  listDiscrepancyByCompanyIdAndUpdatedAt?:  {
    __typename: "ModelDiscrepancyConnection",
    items:  Array< {
      __typename: "Discrepancy",
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscrepancyByEquipmentIdAndUpdatedAtQueryVariables = {
  equipmentId: string,
  filter?: ModelDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListDiscrepancyByEquipmentIdAndUpdatedAtQuery = {
  listDiscrepancyByEquipmentIdAndUpdatedAt?:  {
    __typename: "ModelDiscrepancyConnection",
    items:  Array< {
      __typename: "Discrepancy",
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscrepancyByUnitIdAndUpdatedAtQueryVariables = {
  filter?: ModelDiscrepancyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListDiscrepancyByUnitIdAndUpdatedAtQuery = {
  listDiscrepancyByUnitIdAndUpdatedAt?:  {
    __typename: "ModelDiscrepancyConnection",
    items:  Array< {
      __typename: "Discrepancy",
      companyId: string,
      createdAt?: string | null,
      downReason?: string | null,
      equipmentId: string,
      equipmentName: string,
      id: string,
      initialStatus?: string | null,
      log?: string | null,
      owner?: string | null,
      promptDescription?: string | null,
      promptLabel?: string | null,
      promptTitle?: string | null,
      questionIndex?: number | null,
      reportId?: string | null,
      status: string,
      unitId?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDocumentsQueryVariables = {
  filter?: ModelDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentsQuery = {
  listDocuments?:  {
    __typename: "ModelDocumentConnection",
    items:  Array< {
      __typename: "Document",
      assignedSafetyLesson?: string | null,
      contentPath: string,
      createdAt: string,
      folderName?: string | null,
      id: string,
      owner?: string | null,
      resourceLibraryID?: string | null,
      safetyLesson?: boolean | null,
      sharedWithCompanyIds?: Array< string | null > | null,
      title: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentQueryVariables = {
  filter?: ModelEquipmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEquipmentQuery = {
  listEquipment?:  {
    __typename: "ModelEquipmentConnection",
    items:  Array< {
      __typename: "Equipment",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      units?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelEquipmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEquipmentByCompanyIdQuery = {
  listEquipmentByCompanyId?:  {
    __typename: "ModelEquipmentConnection",
    items:  Array< {
      __typename: "Equipment",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      units?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentByFormIdQueryVariables = {
  filter?: ModelEquipmentFilterInput | null,
  formId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEquipmentByFormIdQuery = {
  listEquipmentByFormId?:  {
    __typename: "ModelEquipmentConnection",
    items:  Array< {
      __typename: "Equipment",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      units?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentCategoriesQueryVariables = {
  filter?: ModelEquipmentCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEquipmentCategoriesQuery = {
  listEquipmentCategories?:  {
    __typename: "ModelEquipmentCategoryConnection",
    items:  Array< {
      __typename: "EquipmentCategory",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentCategoryByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelEquipmentCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEquipmentCategoryByCompanyIdQuery = {
  listEquipmentCategoryByCompanyId?:  {
    __typename: "ModelEquipmentCategoryConnection",
    items:  Array< {
      __typename: "EquipmentCategory",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEquipmentCategoryByFormIdQueryVariables = {
  filter?: ModelEquipmentCategoryFilterInput | null,
  formId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEquipmentCategoryByFormIdQuery = {
  listEquipmentCategoryByFormId?:  {
    __typename: "ModelEquipmentCategoryConnection",
    items:  Array< {
      __typename: "EquipmentCategory",
      companyId: string,
      createdAt: string,
      formId: string,
      id: string,
      image?: string | null,
      name: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListErrorsQueryVariables = {
  filter?: ModelErrorsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListErrorsQuery = {
  listErrors?:  {
    __typename: "ModelErrorsConnection",
    items:  Array< {
      __typename: "Errors",
      createdAt: string,
      errors: string,
      id: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseCategoriesQueryVariables = {
  filter?: ModelExpenseCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExpenseCategoriesQuery = {
  listExpenseCategories?:  {
    __typename: "ModelExpenseCategoryConnection",
    items:  Array< {
      __typename: "ExpenseCategory",
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      startingBalance?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseCategoryByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelExpenseCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpenseCategoryByCompanyIdQuery = {
  listExpenseCategoryByCompanyId?:  {
    __typename: "ModelExpenseCategoryConnection",
    items:  Array< {
      __typename: "ExpenseCategory",
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      startingBalance?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseRecordByCompanyIdAndDateOfServiceQueryVariables = {
  companyId: string,
  dateOfService?: ModelStringKeyConditionInput | null,
  filter?: ModelExpenseRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpenseRecordByCompanyIdAndDateOfServiceQuery = {
  listExpenseRecordByCompanyIdAndDateOfService?:  {
    __typename: "ModelExpenseRecordConnection",
    items:  Array< {
      __typename: "ExpenseRecord",
      attachments?: Array< string | null > | null,
      companyId: string,
      createdAt: string,
      dateOfInput: string,
      dateOfService: string,
      equipmentCategoryId?: string | null,
      expenseCategories?: string | null,
      id: string,
      invoiceNumber?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      pmExpense?: number | null,
      pmServiceLevelId?: string | null,
      pmServiceLevelName?: string | null,
      totalExpense: number,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
      workDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseRecordByUnitIdAndDateOfServiceQueryVariables = {
  dateOfService?: ModelStringKeyConditionInput | null,
  filter?: ModelExpenseRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListExpenseRecordByUnitIdAndDateOfServiceQuery = {
  listExpenseRecordByUnitIdAndDateOfService?:  {
    __typename: "ModelExpenseRecordConnection",
    items:  Array< {
      __typename: "ExpenseRecord",
      attachments?: Array< string | null > | null,
      companyId: string,
      createdAt: string,
      dateOfInput: string,
      dateOfService: string,
      equipmentCategoryId?: string | null,
      expenseCategories?: string | null,
      id: string,
      invoiceNumber?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      pmExpense?: number | null,
      pmServiceLevelId?: string | null,
      pmServiceLevelName?: string | null,
      totalExpense: number,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
      workDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseRecordsQueryVariables = {
  filter?: ModelExpenseRecordFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExpenseRecordsQuery = {
  listExpenseRecords?:  {
    __typename: "ModelExpenseRecordConnection",
    items:  Array< {
      __typename: "ExpenseRecord",
      attachments?: Array< string | null > | null,
      companyId: string,
      createdAt: string,
      dateOfInput: string,
      dateOfService: string,
      equipmentCategoryId?: string | null,
      expenseCategories?: string | null,
      id: string,
      invoiceNumber?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      pmExpense?: number | null,
      pmServiceLevelId?: string | null,
      pmServiceLevelName?: string | null,
      totalExpense: number,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
      workDescription?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFormByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelFormFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFormByCompanyIdQuery = {
  listFormByCompanyId?:  {
    __typename: "ModelFormConnection",
    items:  Array< {
      __typename: "Form",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt: string,
      dailyServiceLogForm?: boolean | null,
      equipmentType?: string | null,
      formData: string,
      formType?: string | null,
      id: string,
      inspectionForm?: boolean | null,
      name: string,
      noMachineHours?: boolean | null,
      noUMCounter?: boolean | null,
      owner?: string | null,
      pmServiceScheduleForm?: boolean | null,
      status?: string | null,
      umCounterLabel?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFormTemplateGroupsQueryVariables = {
  filter?: ModelFormTemplateGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFormTemplateGroupsQuery = {
  listFormTemplateGroups?:  {
    __typename: "ModelFormTemplateGroupConnection",
    items:  Array< {
      __typename: "FormTemplateGroup",
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      resourceLibraryID?: string | null,
      sharedWithCompanyIds?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFormTemplatesQueryVariables = {
  filter?: ModelFormTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFormTemplatesQuery = {
  listFormTemplates?:  {
    __typename: "ModelFormTemplateConnection",
    items:  Array< {
      __typename: "FormTemplate",
      createdAt: string,
      createdByCompanyOwnerId?: string | null,
      dailyServiceLogForm?: boolean | null,
      formTemplateGroupID?: string | null,
      id: string,
      inspectionForm?: boolean | null,
      originalCompanyId?: string | null,
      owner?: string | null,
      pmServiceScheduleForm?: boolean | null,
      templateData: string,
      templateName: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFormsQueryVariables = {
  filter?: ModelFormFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFormsQuery = {
  listForms?:  {
    __typename: "ModelFormConnection",
    items:  Array< {
      __typename: "Form",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt: string,
      dailyServiceLogForm?: boolean | null,
      equipmentType?: string | null,
      formData: string,
      formType?: string | null,
      id: string,
      inspectionForm?: boolean | null,
      name: string,
      noMachineHours?: boolean | null,
      noUMCounter?: boolean | null,
      owner?: string | null,
      pmServiceScheduleForm?: boolean | null,
      status?: string | null,
      umCounterLabel?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHelpSupportDocsQueryVariables = {
  filter?: ModelHelpSupportDocFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHelpSupportDocsQuery = {
  listHelpSupportDocs?:  {
    __typename: "ModelHelpSupportDocConnection",
    items:  Array< {
      __typename: "HelpSupportDoc",
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      createdByAdminId: string,
      description?: string | null,
      docType: string,
      id: string,
      owner?: string | null,
      sharedWithCompanyIds?: Array< string | null > | null,
      status: string,
      title: string,
      updatedAt: string,
      visibility: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInspectionReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListInspectionReportByCompanyIdAndCreatedAtQuery = {
  listInspectionReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelInspectionReportConnection",
    items:  Array< {
      __typename: "InspectionReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtInspection?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtInspection?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInspectionReportByEquipmentCategoryIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  equipmentCategoryId: string,
  filter?: ModelInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListInspectionReportByEquipmentCategoryIdAndCreatedAtQuery = {
  listInspectionReportByEquipmentCategoryIdAndCreatedAt?:  {
    __typename: "ModelInspectionReportConnection",
    items:  Array< {
      __typename: "InspectionReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtInspection?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtInspection?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInspectionReportByUnitIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListInspectionReportByUnitIdAndCreatedAtQuery = {
  listInspectionReportByUnitIdAndCreatedAt?:  {
    __typename: "ModelInspectionReportConnection",
    items:  Array< {
      __typename: "InspectionReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtInspection?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtInspection?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInspectionReportByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListInspectionReportByUserIdAndCreatedAtQuery = {
  listInspectionReportByUserIdAndCreatedAt?:  {
    __typename: "ModelInspectionReportConnection",
    items:  Array< {
      __typename: "InspectionReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtInspection?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtInspection?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInspectionReportsQueryVariables = {
  filter?: ModelInspectionReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInspectionReportsQuery = {
  listInspectionReports?:  {
    __typename: "ModelInspectionReportConnection",
    items:  Array< {
      __typename: "InspectionReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      machineHoursAtInspection?: number | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      umCounterAtInspection?: number | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInvoiceByCompanyIdAndDateQueryVariables = {
  companyId: string,
  date?: ModelStringKeyConditionInput | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListInvoiceByCompanyIdAndDateQuery = {
  listInvoiceByCompanyIdAndDate?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      amount: number,
      companyId: string,
      createdAt: string,
      date: string,
      description: string,
      id: string,
      invoiceNumber: string,
      lineItems?: string | null,
      owner?: string | null,
      pdfUrl?: string | null,
      status: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInvoicesQueryVariables = {
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInvoicesQuery = {
  listInvoices?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      amount: number,
      companyId: string,
      createdAt: string,
      date: string,
      description: string,
      id: string,
      invoiceNumber: string,
      lineItems?: string | null,
      owner?: string | null,
      pdfUrl?: string | null,
      status: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLaborCategoriesQueryVariables = {
  filter?: ModelLaborCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLaborCategoriesQuery = {
  listLaborCategories?:  {
    __typename: "ModelLaborCategoryConnection",
    items:  Array< {
      __typename: "LaborCategory",
      companyId: string,
      createdAt: string,
      id: string,
      isActive: boolean,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLaborCategoryByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelLaborCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLaborCategoryByCompanyIdQuery = {
  listLaborCategoryByCompanyId?:  {
    __typename: "ModelLaborCategoryConnection",
    items:  Array< {
      __typename: "LaborCategory",
      companyId: string,
      createdAt: string,
      id: string,
      isActive: boolean,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLaborRateByCategoryIdAndEffectiveDateQueryVariables = {
  categoryId: string,
  effectiveDate?: ModelStringKeyConditionInput | null,
  filter?: ModelLaborRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLaborRateByCategoryIdAndEffectiveDateQuery = {
  listLaborRateByCategoryIdAndEffectiveDate?:  {
    __typename: "ModelLaborRateConnection",
    items:  Array< {
      __typename: "LaborRate",
      categoryId: string,
      createdAt: string,
      effectiveDate: string,
      id: string,
      overtimeRate: number,
      owner?: string | null,
      standardRate: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLaborRatesQueryVariables = {
  filter?: ModelLaborRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLaborRatesQuery = {
  listLaborRates?:  {
    __typename: "ModelLaborRateConnection",
    items:  Array< {
      __typename: "LaborRate",
      categoryId: string,
      createdAt: string,
      effectiveDate: string,
      id: string,
      overtimeRate: number,
      owner?: string | null,
      standardRate: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLibraryPlanTemplatesQueryVariables = {
  filter?: ModelLibraryPlanTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLibraryPlanTemplatesQuery = {
  listLibraryPlanTemplates?:  {
    __typename: "ModelLibraryPlanTemplateConnection",
    items:  Array< {
      __typename: "LibraryPlanTemplate",
      categories: string,
      categoryCount?: number | null,
      createdAt: string,
      createdByAdminId: string,
      createdByAdminName?: string | null,
      cycleDuration: number,
      description?: string | null,
      governingStandard: string,
      id: string,
      minimumTimeRequired: number,
      name: string,
      owner?: string | null,
      sharedWithCompanyIds?: Array< string | null > | null,
      status: string,
      topicCount?: number | null,
      updatedAt: string,
      workingDays: Array< number | null >,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLibraryTopicTemplatesQueryVariables = {
  filter?: ModelLibraryTopicTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLibraryTopicTemplatesQuery = {
  listLibraryTopicTemplates?:  {
    __typename: "ModelLibraryTopicTemplateConnection",
    items:  Array< {
      __typename: "LibraryTopicTemplate",
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      createdByAdminId: string,
      description: string,
      id: string,
      owner?: string | null,
      style: string,
      timeValue: number,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLocationByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLocationByCompanyIdQuery = {
  listLocationByCompanyId?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      regionalDivisionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLocationByRegionalDivisionIdQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  regionalDivisionId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListLocationByRegionalDivisionIdQuery = {
  listLocationByRegionalDivisionId?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      regionalDivisionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      regionalDivisionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListModuleSubscriptionByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelModuleSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListModuleSubscriptionByCompanyIdQuery = {
  listModuleSubscriptionByCompanyId?:  {
    __typename: "ModelModuleSubscriptionConnection",
    items:  Array< {
      __typename: "ModuleSubscription",
      activatedAt: string,
      cancelRequestedAt?: string | null,
      companyId: string,
      createdAt: string,
      effectiveEndDate?: string | null,
      id: string,
      moduleKey: string,
      monthlyRate: number,
      owner?: string | null,
      pricingModel: string,
      status: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListModuleSubscriptionsQueryVariables = {
  filter?: ModelModuleSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListModuleSubscriptionsQuery = {
  listModuleSubscriptions?:  {
    __typename: "ModelModuleSubscriptionConnection",
    items:  Array< {
      __typename: "ModuleSubscription",
      activatedAt: string,
      cancelRequestedAt?: string | null,
      companyId: string,
      createdAt: string,
      effectiveEndDate?: string | null,
      id: string,
      moduleKey: string,
      monthlyRate: number,
      owner?: string | null,
      pricingModel: string,
      status: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMConfigurationByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelPMConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMConfigurationByCompanyIdQuery = {
  listPMConfigurationByCompanyId?:  {
    __typename: "ModelPMConfigurationConnection",
    items:  Array< {
      __typename: "PMConfiguration",
      companyId: string,
      createdAt: string,
      dueSoonPercentage?: number | null,
      id: string,
      laborCategoryId?: string | null,
      owner?: string | null,
      unitId: string,
      unitOfMeasure: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMConfigurationByUnitIdQueryVariables = {
  filter?: ModelPMConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListPMConfigurationByUnitIdQuery = {
  listPMConfigurationByUnitId?:  {
    __typename: "ModelPMConfigurationConnection",
    items:  Array< {
      __typename: "PMConfiguration",
      companyId: string,
      createdAt: string,
      dueSoonPercentage?: number | null,
      id: string,
      laborCategoryId?: string | null,
      owner?: string | null,
      unitId: string,
      unitOfMeasure: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMConfigurationsQueryVariables = {
  filter?: ModelPMConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMConfigurationsQuery = {
  listPMConfigurations?:  {
    __typename: "ModelPMConfigurationConnection",
    items:  Array< {
      __typename: "PMConfiguration",
      companyId: string,
      createdAt: string,
      dueSoonPercentage?: number | null,
      id: string,
      laborCategoryId?: string | null,
      owner?: string | null,
      unitId: string,
      unitOfMeasure: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMModuleContentByPmServiceFormIdQueryVariables = {
  filter?: ModelPMModuleContentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pmServiceFormId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMModuleContentByPmServiceFormIdQuery = {
  listPMModuleContentByPmServiceFormId?:  {
    __typename: "ModelPMModuleContentConnection",
    items:  Array< {
      __typename: "PMModuleContent",
      createdAt: string,
      id: string,
      owner?: string | null,
      pmServiceFormId: string,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMModuleContentByUnitIdQueryVariables = {
  filter?: ModelPMModuleContentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListPMModuleContentByUnitIdQuery = {
  listPMModuleContentByUnitId?:  {
    __typename: "ModelPMModuleContentConnection",
    items:  Array< {
      __typename: "PMModuleContent",
      createdAt: string,
      id: string,
      owner?: string | null,
      pmServiceFormId: string,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMModuleContentsQueryVariables = {
  filter?: ModelPMModuleContentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMModuleContentsQuery = {
  listPMModuleContents?:  {
    __typename: "ModelPMModuleContentConnection",
    items:  Array< {
      __typename: "PMModuleContent",
      createdAt: string,
      id: string,
      owner?: string | null,
      pmServiceFormId: string,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMNotificationSettingByPmConfigurationIdQueryVariables = {
  filter?: ModelPMNotificationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pmConfigurationId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMNotificationSettingByPmConfigurationIdQuery = {
  listPMNotificationSettingByPmConfigurationId?:  {
    __typename: "ModelPMNotificationSettingConnection",
    items:  Array< {
      __typename: "PMNotificationSetting",
      createdAt: string,
      emailThresholdUM: number,
      id: string,
      lastNotificationSent?: string | null,
      notificationFrequency: string,
      owner?: string | null,
      pmConfigurationId: string,
      recipients?: Array< string | null > | null,
      serviceLevelId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMNotificationSettingsQueryVariables = {
  filter?: ModelPMNotificationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMNotificationSettingsQuery = {
  listPMNotificationSettings?:  {
    __typename: "ModelPMNotificationSettingConnection",
    items:  Array< {
      __typename: "PMNotificationSetting",
      createdAt: string,
      emailThresholdUM: number,
      id: string,
      lastNotificationSent?: string | null,
      notificationFrequency: string,
      owner?: string | null,
      pmConfigurationId: string,
      recipients?: Array< string | null > | null,
      serviceLevelId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMPartsAndProcedureByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelPMPartsAndProcedureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMPartsAndProcedureByCompanyIdQuery = {
  listPMPartsAndProcedureByCompanyId?:  {
    __typename: "ModelPMPartsAndProcedureConnection",
    items:  Array< {
      __typename: "PMPartsAndProcedure",
      category?: string | null,
      companyId?: string | null,
      createdAt: string,
      createdByUserId?: string | null,
      createdByUserName?: string | null,
      id: string,
      itemName: string,
      itemType?: string | null,
      manufacturer?: string | null,
      owner?: string | null,
      partNumber?: string | null,
      pmConfigurationId?: string | null,
      pmConfigurationIds?: Array< string | null > | null,
      price?: number | null,
      quantity?: number | null,
      sortOrder?: number | null,
      unitOfMeasure?: string | null,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMPartsAndProcedureByPmConfigurationIdQueryVariables = {
  filter?: ModelPMPartsAndProcedureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pmConfigurationId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMPartsAndProcedureByPmConfigurationIdQuery = {
  listPMPartsAndProcedureByPmConfigurationId?:  {
    __typename: "ModelPMPartsAndProcedureConnection",
    items:  Array< {
      __typename: "PMPartsAndProcedure",
      category?: string | null,
      companyId?: string | null,
      createdAt: string,
      createdByUserId?: string | null,
      createdByUserName?: string | null,
      id: string,
      itemName: string,
      itemType?: string | null,
      manufacturer?: string | null,
      owner?: string | null,
      partNumber?: string | null,
      pmConfigurationId?: string | null,
      pmConfigurationIds?: Array< string | null > | null,
      price?: number | null,
      quantity?: number | null,
      sortOrder?: number | null,
      unitOfMeasure?: string | null,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMPartsAndProceduresQueryVariables = {
  filter?: ModelPMPartsAndProcedureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMPartsAndProceduresQuery = {
  listPMPartsAndProcedures?:  {
    __typename: "ModelPMPartsAndProcedureConnection",
    items:  Array< {
      __typename: "PMPartsAndProcedure",
      category?: string | null,
      companyId?: string | null,
      createdAt: string,
      createdByUserId?: string | null,
      createdByUserName?: string | null,
      id: string,
      itemName: string,
      itemType?: string | null,
      manufacturer?: string | null,
      owner?: string | null,
      partNumber?: string | null,
      pmConfigurationId?: string | null,
      pmConfigurationIds?: Array< string | null > | null,
      price?: number | null,
      quantity?: number | null,
      sortOrder?: number | null,
      unitOfMeasure?: string | null,
      updatedAt: string,
      vendorId?: string | null,
      vendorName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelPMReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMReportByCompanyIdAndCreatedAtQuery = {
  listPMReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelPMReportConnection",
    items:  Array< {
      __typename: "PMReport",
      actualUM: number,
      companyId: string,
      createdAt?: string | null,
      id: string,
      issueDescription?: string | null,
      issueTicketCreated?: boolean | null,
      issueTicketId?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      photos?: Array< string | null > | null,
      pmConfigurationId: string,
      reportData?: string | null,
      serviceDate: string,
      serviceLevelId: string,
      serviceLevelName?: string | null,
      signature?: string | null,
      status?: string | null,
      technicianId: string,
      technicianName?: string | null,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMReportByPmConfigurationIdQueryVariables = {
  filter?: ModelPMReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pmConfigurationId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMReportByPmConfigurationIdQuery = {
  listPMReportByPmConfigurationId?:  {
    __typename: "ModelPMReportConnection",
    items:  Array< {
      __typename: "PMReport",
      actualUM: number,
      companyId: string,
      createdAt?: string | null,
      id: string,
      issueDescription?: string | null,
      issueTicketCreated?: boolean | null,
      issueTicketId?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      photos?: Array< string | null > | null,
      pmConfigurationId: string,
      reportData?: string | null,
      serviceDate: string,
      serviceLevelId: string,
      serviceLevelName?: string | null,
      signature?: string | null,
      status?: string | null,
      technicianId: string,
      technicianName?: string | null,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMReportByUnitIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelPMReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListPMReportByUnitIdAndCreatedAtQuery = {
  listPMReportByUnitIdAndCreatedAt?:  {
    __typename: "ModelPMReportConnection",
    items:  Array< {
      __typename: "PMReport",
      actualUM: number,
      companyId: string,
      createdAt?: string | null,
      id: string,
      issueDescription?: string | null,
      issueTicketCreated?: boolean | null,
      issueTicketId?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      photos?: Array< string | null > | null,
      pmConfigurationId: string,
      reportData?: string | null,
      serviceDate: string,
      serviceLevelId: string,
      serviceLevelName?: string | null,
      signature?: string | null,
      status?: string | null,
      technicianId: string,
      technicianName?: string | null,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMReportsQueryVariables = {
  filter?: ModelPMReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMReportsQuery = {
  listPMReports?:  {
    __typename: "ModelPMReportConnection",
    items:  Array< {
      __typename: "PMReport",
      actualUM: number,
      companyId: string,
      createdAt?: string | null,
      id: string,
      issueDescription?: string | null,
      issueTicketCreated?: boolean | null,
      issueTicketId?: string | null,
      laborHoursOT?: number | null,
      laborHoursST?: number | null,
      laborRateOT?: number | null,
      laborRateST?: number | null,
      laborRateScheduleId?: string | null,
      laborRateScheduleName?: string | null,
      owner?: string | null,
      photos?: Array< string | null > | null,
      pmConfigurationId: string,
      reportData?: string | null,
      serviceDate: string,
      serviceLevelId: string,
      serviceLevelName?: string | null,
      signature?: string | null,
      status?: string | null,
      technicianId: string,
      technicianName?: string | null,
      totalLaborCost?: number | null,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMServiceLevelByPmConfigurationIdQueryVariables = {
  filter?: ModelPMServiceLevelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pmConfigurationId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListPMServiceLevelByPmConfigurationIdQuery = {
  listPMServiceLevelByPmConfigurationId?:  {
    __typename: "ModelPMServiceLevelConnection",
    items:  Array< {
      __typename: "PMServiceLevel",
      createdAt: string,
      description?: string | null,
      id: string,
      intervalValue: number,
      lastServiceDate?: string | null,
      lastServiceUM?: number | null,
      levelIdentifier: string,
      owner?: string | null,
      pmConfigurationId: string,
      pmServiceFormId?: string | null,
      serviceLevelAssignments?: string | null,
      targetUM: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPMServiceLevelsQueryVariables = {
  filter?: ModelPMServiceLevelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPMServiceLevelsQuery = {
  listPMServiceLevels?:  {
    __typename: "ModelPMServiceLevelConnection",
    items:  Array< {
      __typename: "PMServiceLevel",
      createdAt: string,
      description?: string | null,
      id: string,
      intervalValue: number,
      lastServiceDate?: string | null,
      lastServiceUM?: number | null,
      levelIdentifier: string,
      owner?: string | null,
      pmConfigurationId: string,
      pmServiceFormId?: string | null,
      serviceLevelAssignments?: string | null,
      targetUM: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRegionalDivisionByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelRegionalDivisionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRegionalDivisionByCompanyIdQuery = {
  listRegionalDivisionByCompanyId?:  {
    __typename: "ModelRegionalDivisionConnection",
    items:  Array< {
      __typename: "RegionalDivision",
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRegionalDivisionsQueryVariables = {
  filter?: ModelRegionalDivisionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegionalDivisionsQuery = {
  listRegionalDivisions?:  {
    __typename: "ModelRegionalDivisionConnection",
    items:  Array< {
      __typename: "RegionalDivision",
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportAnswerByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelReportAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReportAnswerByCompanyIdQuery = {
  listReportAnswerByCompanyId?:  {
    __typename: "ModelReportAnswerConnection",
    items:  Array< {
      __typename: "ReportAnswer",
      companyId: string,
      createdAt?: string | null,
      id: string,
      notes?: string | null,
      parentReportId: string,
      photos?: Array< string | null > | null,
      promptDescription?: string | null,
      promptKey: string,
      promptLabel?: string | null,
      promptTitle?: string | null,
      promptType?: string | null,
      reportType: string,
      sortOrder?: number | null,
      unitId?: string | null,
      updatedAt: string,
      value?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportAnswerByParentReportIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelReportAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  parentReportId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListReportAnswerByParentReportIdAndCreatedAtQuery = {
  listReportAnswerByParentReportIdAndCreatedAt?:  {
    __typename: "ModelReportAnswerConnection",
    items:  Array< {
      __typename: "ReportAnswer",
      companyId: string,
      createdAt?: string | null,
      id: string,
      notes?: string | null,
      parentReportId: string,
      photos?: Array< string | null > | null,
      promptDescription?: string | null,
      promptKey: string,
      promptLabel?: string | null,
      promptTitle?: string | null,
      promptType?: string | null,
      reportType: string,
      sortOrder?: number | null,
      unitId?: string | null,
      updatedAt: string,
      value?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportAnswerByPromptKeyAndValueQueryVariables = {
  filter?: ModelReportAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  promptKey: string,
  sortDirection?: ModelSortDirection | null,
  value?: ModelStringKeyConditionInput | null,
};

export type ListReportAnswerByPromptKeyAndValueQuery = {
  listReportAnswerByPromptKeyAndValue?:  {
    __typename: "ModelReportAnswerConnection",
    items:  Array< {
      __typename: "ReportAnswer",
      companyId: string,
      createdAt?: string | null,
      id: string,
      notes?: string | null,
      parentReportId: string,
      photos?: Array< string | null > | null,
      promptDescription?: string | null,
      promptKey: string,
      promptLabel?: string | null,
      promptTitle?: string | null,
      promptType?: string | null,
      reportType: string,
      sortOrder?: number | null,
      unitId?: string | null,
      updatedAt: string,
      value?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportAnswerByUnitIdQueryVariables = {
  filter?: ModelReportAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListReportAnswerByUnitIdQuery = {
  listReportAnswerByUnitId?:  {
    __typename: "ModelReportAnswerConnection",
    items:  Array< {
      __typename: "ReportAnswer",
      companyId: string,
      createdAt?: string | null,
      id: string,
      notes?: string | null,
      parentReportId: string,
      photos?: Array< string | null > | null,
      promptDescription?: string | null,
      promptKey: string,
      promptLabel?: string | null,
      promptTitle?: string | null,
      promptType?: string | null,
      reportType: string,
      sortOrder?: number | null,
      unitId?: string | null,
      updatedAt: string,
      value?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportAnswersQueryVariables = {
  filter?: ModelReportAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportAnswersQuery = {
  listReportAnswers?:  {
    __typename: "ModelReportAnswerConnection",
    items:  Array< {
      __typename: "ReportAnswer",
      companyId: string,
      createdAt?: string | null,
      id: string,
      notes?: string | null,
      parentReportId: string,
      photos?: Array< string | null > | null,
      promptDescription?: string | null,
      promptKey: string,
      promptLabel?: string | null,
      promptTitle?: string | null,
      promptType?: string | null,
      reportType: string,
      sortOrder?: number | null,
      unitId?: string | null,
      updatedAt: string,
      value?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportsQueryVariables = {
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportsQuery = {
  listReports?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogReport?: boolean | null,
      equipmentId: string,
      equipmentLocationId?: string | null,
      equipmentName?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListResourceLibrariesQueryVariables = {
  filter?: ModelResourceLibraryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceLibrariesQuery = {
  listResourceLibraries?:  {
    __typename: "ModelResourceLibraryConnection",
    items:  Array< {
      __typename: "ResourceLibrary",
      companyOwnerId: string,
      createdAt: string,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSavedReportConfigurationByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelSavedReportConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSavedReportConfigurationByCompanyIdAndCreatedAtQuery = {
  listSavedReportConfigurationByCompanyIdAndCreatedAt?:  {
    __typename: "ModelSavedReportConfigurationConnection",
    items:  Array< {
      __typename: "SavedReportConfiguration",
      companyId: string,
      compareDateRangeEnd?: string | null,
      compareDateRangeStart?: string | null,
      createdAt?: string | null,
      dateRangeEnd?: string | null,
      dateRangeStart?: string | null,
      dateRangeType?: string | null,
      filtersJson?: string | null,
      groupByField?: string | null,
      id: string,
      lastRunAt?: string | null,
      metricCategory?: string | null,
      metricKey: string,
      reportName: string,
      updatedAt: string,
      userId: string,
      visualizationType?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSavedReportConfigurationByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelSavedReportConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListSavedReportConfigurationByUserIdAndCreatedAtQuery = {
  listSavedReportConfigurationByUserIdAndCreatedAt?:  {
    __typename: "ModelSavedReportConfigurationConnection",
    items:  Array< {
      __typename: "SavedReportConfiguration",
      companyId: string,
      compareDateRangeEnd?: string | null,
      compareDateRangeStart?: string | null,
      createdAt?: string | null,
      dateRangeEnd?: string | null,
      dateRangeStart?: string | null,
      dateRangeType?: string | null,
      filtersJson?: string | null,
      groupByField?: string | null,
      id: string,
      lastRunAt?: string | null,
      metricCategory?: string | null,
      metricKey: string,
      reportName: string,
      updatedAt: string,
      userId: string,
      visualizationType?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSavedReportConfigurationsQueryVariables = {
  filter?: ModelSavedReportConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSavedReportConfigurationsQuery = {
  listSavedReportConfigurations?:  {
    __typename: "ModelSavedReportConfigurationConnection",
    items:  Array< {
      __typename: "SavedReportConfiguration",
      companyId: string,
      compareDateRangeEnd?: string | null,
      compareDateRangeStart?: string | null,
      createdAt?: string | null,
      dateRangeEnd?: string | null,
      dateRangeStart?: string | null,
      dateRangeType?: string | null,
      filtersJson?: string | null,
      groupByField?: string | null,
      id: string,
      lastRunAt?: string | null,
      metricCategory?: string | null,
      metricKey: string,
      reportName: string,
      updatedAt: string,
      userId: string,
      visualizationType?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSensitiveUserInfosQueryVariables = {
  filter?: ModelSensitiveUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSensitiveUserInfosQuery = {
  listSensitiveUserInfos?:  {
    __typename: "ModelSensitiveUserInfoConnection",
    items:  Array< {
      __typename: "SensitiveUserInfo",
      cognitoId?: string | null,
      companyId?: string | null,
      createdAt: string,
      dateOfBirth?: string | null,
      driversLicenseClass?: string | null,
      driversLicenseExpirationDate?: string | null,
      driversLicenseNumber?: string | null,
      driversLicenseState?: string | null,
      emergencyContactName?: string | null,
      emergencyContactPhoneNumber?: string | null,
      emergencyContactRelationship?: string | null,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListShiftReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelShiftReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListShiftReportByCompanyIdAndCreatedAtQuery = {
  listShiftReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelShiftReportConnection",
    items:  Array< {
      __typename: "ShiftReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      locationName?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      shiftType?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListShiftReportByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelShiftReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListShiftReportByUserIdAndCreatedAtQuery = {
  listShiftReportByUserIdAndCreatedAt?:  {
    __typename: "ModelShiftReportConnection",
    items:  Array< {
      __typename: "ShiftReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      locationName?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      shiftType?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListShiftReportsQueryVariables = {
  filter?: ModelShiftReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShiftReportsQuery = {
  listShiftReports?:  {
    __typename: "ModelShiftReportConnection",
    items:  Array< {
      __typename: "ShiftReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      locationId?: string | null,
      locationName?: string | null,
      okCount?: number | null,
      photos?: Array< string | null > | null,
      responseData?: string | null,
      shiftType?: string | null,
      signature?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSingleUnitsQueryVariables = {
  filter?: ModelSingleUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSingleUnitsQuery = {
  listSingleUnits?:  {
    __typename: "ModelSingleUnitConnection",
    items:  Array< {
      __typename: "SingleUnit",
      annualProjectedUsage?: number | null,
      aquisitionCost?: number | null,
      aquisitionDate?: string | null,
      assignedTo?: string | null,
      axleConfiguration?: string | null,
      categoryId?: string | null,
      costTrackingModuleEnrollment?: boolean | null,
      createdAt: string,
      currentMachineHours?: number | null,
      currentUMCounterValue?: number | null,
      dailyServiceLogFormId?: string | null,
      description?: string | null,
      dispositionDate?: string | null,
      dispositionReason?: string | null,
      downReason?: string | null,
      engineManufacturer?: string | null,
      engineModelNumber?: string | null,
      equipmentStatus?: boolean | null,
      extraUnitInfo?: string | null,
      id: string,
      image?: string | null,
      inputByPerson?: string | null,
      inputDate?: string | null,
      lastDailyServiceDate?: string | null,
      lastInspectionDate?: string | null,
      lastServiceHours?: number | null,
      licenseNumber?: string | null,
      locationId?: string | null,
      machineHoursAtAquisition?: number | null,
      machineUMCounterAtAquisition?: number | null,
      manufactureDate?: string | null,
      manufacturerName?: string | null,
      modelNumber?: string | null,
      name: string,
      pmModuleEnrollment?: boolean | null,
      putInServiceDate?: string | null,
      removedFromServiceDate?: string | null,
      removedFromServiceReason?: string | null,
      replacedUMCounterHistory?: string | null,
      replacedUMCounterStatus?: boolean | null,
      replacedUMCounterValue?: number | null,
      serialNumber?: string | null,
      tiresModuleEnrollment?: boolean | null,
      unitOfMeasure?: string | null,
      updatedAt: string,
      utilizationAdjustmentDays?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSingleUnitsByCategoryIdQueryVariables = {
  categoryId: string,
  filter?: ModelSingleUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSingleUnitsByCategoryIdQuery = {
  listSingleUnitsByCategoryId?:  {
    __typename: "ModelSingleUnitConnection",
    items:  Array< {
      __typename: "SingleUnit",
      annualProjectedUsage?: number | null,
      aquisitionCost?: number | null,
      aquisitionDate?: string | null,
      assignedTo?: string | null,
      axleConfiguration?: string | null,
      categoryId?: string | null,
      costTrackingModuleEnrollment?: boolean | null,
      createdAt: string,
      currentMachineHours?: number | null,
      currentUMCounterValue?: number | null,
      dailyServiceLogFormId?: string | null,
      description?: string | null,
      dispositionDate?: string | null,
      dispositionReason?: string | null,
      downReason?: string | null,
      engineManufacturer?: string | null,
      engineModelNumber?: string | null,
      equipmentStatus?: boolean | null,
      extraUnitInfo?: string | null,
      id: string,
      image?: string | null,
      inputByPerson?: string | null,
      inputDate?: string | null,
      lastDailyServiceDate?: string | null,
      lastInspectionDate?: string | null,
      lastServiceHours?: number | null,
      licenseNumber?: string | null,
      locationId?: string | null,
      machineHoursAtAquisition?: number | null,
      machineUMCounterAtAquisition?: number | null,
      manufactureDate?: string | null,
      manufacturerName?: string | null,
      modelNumber?: string | null,
      name: string,
      pmModuleEnrollment?: boolean | null,
      putInServiceDate?: string | null,
      removedFromServiceDate?: string | null,
      removedFromServiceReason?: string | null,
      replacedUMCounterHistory?: string | null,
      replacedUMCounterStatus?: boolean | null,
      replacedUMCounterValue?: number | null,
      serialNumber?: string | null,
      tiresModuleEnrollment?: boolean | null,
      unitOfMeasure?: string | null,
      updatedAt: string,
      utilizationAdjustmentDays?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSkillAssignmentsQueryVariables = {
  filter?: ModelSkillAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillAssignmentsQuery = {
  listSkillAssignments?:  {
    __typename: "ModelSkillAssignmentConnection",
    items:  Array< {
      __typename: "SkillAssignment",
      companyId: string,
      createdAt: string,
      evaluatedBy?: string | null,
      evaluatedByName?: string | null,
      evaluationDate?: string | null,
      id: string,
      owner?: string | null,
      skillLevel: string,
      subCategoryId?: string | null,
      taskId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSkillCategoriesQueryVariables = {
  filter?: ModelSkillCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillCategoriesQuery = {
  listSkillCategories?:  {
    __typename: "ModelSkillCategoryConnection",
    items:  Array< {
      __typename: "SkillCategory",
      allowMachineNumber?: boolean | null,
      classificationId: string,
      companyId: string,
      createdAt: string,
      equipmentCategoryId?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSkillLevelsQueryVariables = {
  filter?: ModelSkillLevelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillLevelsQuery = {
  listSkillLevels?:  {
    __typename: "ModelSkillLevelConnection",
    items:  Array< {
      __typename: "SkillLevel",
      color?: string | null,
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      sortOrder: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSkillTasksQueryVariables = {
  filter?: ModelSkillTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillTasksQuery = {
  listSkillTasks?:  {
    __typename: "ModelSkillTaskConnection",
    items:  Array< {
      __typename: "SkillTask",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubCategoriesQueryVariables = {
  filter?: ModelSubCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubCategoriesQuery = {
  listSubCategories?:  {
    __typename: "ModelSubCategoryConnection",
    items:  Array< {
      __typename: "SubCategory",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTireByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTireFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTireByCompanyIdQuery = {
  listTireByCompanyId?:  {
    __typename: "ModelTireConnection",
    items:  Array< {
      __typename: "Tire",
      assignedAxle?: string | null,
      assignedPosition?: string | null,
      companyId: string,
      createdAt: string,
      currentTirePressure?: number | null,
      currentTreadDepth?: number | null,
      dateInstalled?: string | null,
      dateUninstalled?: string | null,
      failureReason?: string | null,
      id: string,
      inflationMedium?: string | null,
      loadRating?: number | null,
      loadRatingUnit?: string | null,
      minimumTreadDepth?: number | null,
      name?: string | null,
      owner?: string | null,
      recommendedTirePressure?: number | null,
      removedFromService?: boolean | null,
      removedFromServiceDate?: string | null,
      tireCategory?: string | null,
      tireManufacturer?: string | null,
      tireModel?: string | null,
      tireSize?: string | null,
      tireStatus?: string | null,
      treadDepthAtInstall?: number | null,
      unitId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTireByUnitIdQueryVariables = {
  filter?: ModelTireFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListTireByUnitIdQuery = {
  listTireByUnitId?:  {
    __typename: "ModelTireConnection",
    items:  Array< {
      __typename: "Tire",
      assignedAxle?: string | null,
      assignedPosition?: string | null,
      companyId: string,
      createdAt: string,
      currentTirePressure?: number | null,
      currentTreadDepth?: number | null,
      dateInstalled?: string | null,
      dateUninstalled?: string | null,
      failureReason?: string | null,
      id: string,
      inflationMedium?: string | null,
      loadRating?: number | null,
      loadRatingUnit?: string | null,
      minimumTreadDepth?: number | null,
      name?: string | null,
      owner?: string | null,
      recommendedTirePressure?: number | null,
      removedFromService?: boolean | null,
      removedFromServiceDate?: string | null,
      tireCategory?: string | null,
      tireManufacturer?: string | null,
      tireModel?: string | null,
      tireSize?: string | null,
      tireStatus?: string | null,
      treadDepthAtInstall?: number | null,
      unitId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTireReportsQueryVariables = {
  filter?: ModelTireReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTireReportsQuery = {
  listTireReports?:  {
    __typename: "ModelTireReportConnection",
    items:  Array< {
      __typename: "TireReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      equipmentLocationId?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      tireId?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTiresQueryVariables = {
  filter?: ModelTireFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTiresQuery = {
  listTires?:  {
    __typename: "ModelTireConnection",
    items:  Array< {
      __typename: "Tire",
      assignedAxle?: string | null,
      assignedPosition?: string | null,
      companyId: string,
      createdAt: string,
      currentTirePressure?: number | null,
      currentTreadDepth?: number | null,
      dateInstalled?: string | null,
      dateUninstalled?: string | null,
      failureReason?: string | null,
      id: string,
      inflationMedium?: string | null,
      loadRating?: number | null,
      loadRatingUnit?: string | null,
      minimumTreadDepth?: number | null,
      name?: string | null,
      owner?: string | null,
      recommendedTirePressure?: number | null,
      removedFromService?: boolean | null,
      removedFromServiceDate?: string | null,
      tireCategory?: string | null,
      tireManufacturer?: string | null,
      tireModel?: string | null,
      tireSize?: string | null,
      tireStatus?: string | null,
      treadDepthAtInstall?: number | null,
      unitId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingAffidavitByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingAffidavitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingAffidavitByCompanyIdQuery = {
  listTrainingAffidavitByCompanyId?:  {
    __typename: "ModelTrainingAffidavitConnection",
    items:  Array< {
      __typename: "TrainingAffidavit",
      adminId: string,
      affidavitDate: string,
      companyId: string,
      createdAt: string,
      id: string,
      legalText: string,
      nextDueDate: string,
      owner?: string | null,
      planId: string,
      signaturePath: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingAffidavitByPlanIdQueryVariables = {
  filter?: ModelTrainingAffidavitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  planId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingAffidavitByPlanIdQuery = {
  listTrainingAffidavitByPlanId?:  {
    __typename: "ModelTrainingAffidavitConnection",
    items:  Array< {
      __typename: "TrainingAffidavit",
      adminId: string,
      affidavitDate: string,
      companyId: string,
      createdAt: string,
      id: string,
      legalText: string,
      nextDueDate: string,
      owner?: string | null,
      planId: string,
      signaturePath: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingAffidavitsQueryVariables = {
  filter?: ModelTrainingAffidavitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingAffidavitsQuery = {
  listTrainingAffidavits?:  {
    __typename: "ModelTrainingAffidavitConnection",
    items:  Array< {
      __typename: "TrainingAffidavit",
      adminId: string,
      affidavitDate: string,
      companyId: string,
      createdAt: string,
      id: string,
      legalText: string,
      nextDueDate: string,
      owner?: string | null,
      planId: string,
      signaturePath: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingCompletionByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingCompletionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingCompletionByCompanyIdQuery = {
  listTrainingCompletionByCompanyId?:  {
    __typename: "ModelTrainingCompletionConnection",
    items:  Array< {
      __typename: "TrainingCompletion",
      categoryId?: string | null,
      companyId: string,
      completionDate: string,
      createdAt: string,
      id: string,
      launched: boolean,
      markedAsViewed: boolean,
      owner?: string | null,
      planId: string,
      scheduleDate: string,
      signaturePath?: string | null,
      timeValueMinutes: number,
      topicId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingCompletionByPlanIdQueryVariables = {
  filter?: ModelTrainingCompletionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  planId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingCompletionByPlanIdQuery = {
  listTrainingCompletionByPlanId?:  {
    __typename: "ModelTrainingCompletionConnection",
    items:  Array< {
      __typename: "TrainingCompletion",
      categoryId?: string | null,
      companyId: string,
      completionDate: string,
      createdAt: string,
      id: string,
      launched: boolean,
      markedAsViewed: boolean,
      owner?: string | null,
      planId: string,
      scheduleDate: string,
      signaturePath?: string | null,
      timeValueMinutes: number,
      topicId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingCompletionByScheduledDateQueryVariables = {
  filter?: ModelTrainingCompletionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  scheduleDate: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingCompletionByScheduledDateQuery = {
  listTrainingCompletionByScheduledDate?:  {
    __typename: "ModelTrainingCompletionConnection",
    items:  Array< {
      __typename: "TrainingCompletion",
      categoryId?: string | null,
      companyId: string,
      completionDate: string,
      createdAt: string,
      id: string,
      launched: boolean,
      markedAsViewed: boolean,
      owner?: string | null,
      planId: string,
      scheduleDate: string,
      signaturePath?: string | null,
      timeValueMinutes: number,
      topicId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingCompletionByUserIdAndCompletionDateQueryVariables = {
  completionDate?: ModelStringKeyConditionInput | null,
  filter?: ModelTrainingCompletionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListTrainingCompletionByUserIdAndCompletionDateQuery = {
  listTrainingCompletionByUserIdAndCompletionDate?:  {
    __typename: "ModelTrainingCompletionConnection",
    items:  Array< {
      __typename: "TrainingCompletion",
      categoryId?: string | null,
      companyId: string,
      completionDate: string,
      createdAt: string,
      id: string,
      launched: boolean,
      markedAsViewed: boolean,
      owner?: string | null,
      planId: string,
      scheduleDate: string,
      signaturePath?: string | null,
      timeValueMinutes: number,
      topicId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingCompletionsQueryVariables = {
  filter?: ModelTrainingCompletionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingCompletionsQuery = {
  listTrainingCompletions?:  {
    __typename: "ModelTrainingCompletionConnection",
    items:  Array< {
      __typename: "TrainingCompletion",
      categoryId?: string | null,
      companyId: string,
      completionDate: string,
      createdAt: string,
      id: string,
      launched: boolean,
      markedAsViewed: boolean,
      owner?: string | null,
      planId: string,
      scheduleDate: string,
      signaturePath?: string | null,
      timeValueMinutes: number,
      topicId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingEnrollmentByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingEnrollmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingEnrollmentByCompanyIdQuery = {
  listTrainingEnrollmentByCompanyId?:  {
    __typename: "ModelTrainingEnrollmentConnection",
    items:  Array< {
      __typename: "TrainingEnrollment",
      companyId: string,
      createdAt: string,
      enrolledDate: string,
      id: string,
      lastCompletionDate?: string | null,
      nextDueDate?: string | null,
      owner?: string | null,
      planId: string,
      status: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingEnrollmentByPlanIdQueryVariables = {
  filter?: ModelTrainingEnrollmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  planId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingEnrollmentByPlanIdQuery = {
  listTrainingEnrollmentByPlanId?:  {
    __typename: "ModelTrainingEnrollmentConnection",
    items:  Array< {
      __typename: "TrainingEnrollment",
      companyId: string,
      createdAt: string,
      enrolledDate: string,
      id: string,
      lastCompletionDate?: string | null,
      nextDueDate?: string | null,
      owner?: string | null,
      planId: string,
      status: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingEnrollmentByUserIdQueryVariables = {
  filter?: ModelTrainingEnrollmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListTrainingEnrollmentByUserIdQuery = {
  listTrainingEnrollmentByUserId?:  {
    __typename: "ModelTrainingEnrollmentConnection",
    items:  Array< {
      __typename: "TrainingEnrollment",
      companyId: string,
      createdAt: string,
      enrolledDate: string,
      id: string,
      lastCompletionDate?: string | null,
      nextDueDate?: string | null,
      owner?: string | null,
      planId: string,
      status: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingEnrollmentsQueryVariables = {
  filter?: ModelTrainingEnrollmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingEnrollmentsQuery = {
  listTrainingEnrollments?:  {
    __typename: "ModelTrainingEnrollmentConnection",
    items:  Array< {
      __typename: "TrainingEnrollment",
      companyId: string,
      createdAt: string,
      enrolledDate: string,
      id: string,
      lastCompletionDate?: string | null,
      nextDueDate?: string | null,
      owner?: string | null,
      planId: string,
      status: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingPlanByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingPlanByCompanyIdQuery = {
  listTrainingPlanByCompanyId?:  {
    __typename: "ModelTrainingPlanConnection",
    items:  Array< {
      __typename: "TrainingPlan",
      categories: string,
      companyId: string,
      createdAt: string,
      cycleDuration: number,
      governingStandard: string,
      holidays?: string | null,
      id: string,
      minimumTimeRequired: number,
      name: string,
      owner?: string | null,
      startDate?: string | null,
      status: string,
      updatedAt: string,
      workingDays?: Array< number | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingPlansQueryVariables = {
  filter?: ModelTrainingPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingPlansQuery = {
  listTrainingPlans?:  {
    __typename: "ModelTrainingPlanConnection",
    items:  Array< {
      __typename: "TrainingPlan",
      categories: string,
      companyId: string,
      createdAt: string,
      cycleDuration: number,
      governingStandard: string,
      holidays?: string | null,
      id: string,
      minimumTimeRequired: number,
      name: string,
      owner?: string | null,
      startDate?: string | null,
      status: string,
      updatedAt: string,
      workingDays?: Array< number | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingQuizResponsesQueryVariables = {
  filter?: ModelTrainingQuizResponseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingQuizResponsesQuery = {
  listTrainingQuizResponses?:  {
    __typename: "ModelTrainingQuizResponseConnection",
    items:  Array< {
      __typename: "TrainingQuizResponse",
      attemptNumber?: number | null,
      categoryId?: string | null,
      companyId: string,
      completedAt?: string | null,
      createdAt: string,
      cycleStartDate?: string | null,
      formId?: string | null,
      id: string,
      owner?: string | null,
      passed?: boolean | null,
      planId: string,
      responseData?: string | null,
      score?: number | null,
      signaturePath?: string | null,
      totalQuestions?: number | null,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingScheduleByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingScheduleByCompanyIdQuery = {
  listTrainingScheduleByCompanyId?:  {
    __typename: "ModelTrainingScheduleConnection",
    items:  Array< {
      __typename: "TrainingSchedule",
      assignedUserId?: string | null,
      categoryId?: string | null,
      companyId: string,
      createdAt: string,
      dayNumber: number,
      id: string,
      locked?: boolean | null,
      owner?: string | null,
      planId: string,
      scheduledDate: string,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingScheduleByPlanIdAndScheduledDateQueryVariables = {
  filter?: ModelTrainingScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  planId: string,
  scheduledDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingScheduleByPlanIdAndScheduledDateQuery = {
  listTrainingScheduleByPlanIdAndScheduledDate?:  {
    __typename: "ModelTrainingScheduleConnection",
    items:  Array< {
      __typename: "TrainingSchedule",
      assignedUserId?: string | null,
      categoryId?: string | null,
      companyId: string,
      createdAt: string,
      dayNumber: number,
      id: string,
      locked?: boolean | null,
      owner?: string | null,
      planId: string,
      scheduledDate: string,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingScheduleByScheduledDateQueryVariables = {
  filter?: ModelTrainingScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  scheduledDate: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingScheduleByScheduledDateQuery = {
  listTrainingScheduleByScheduledDate?:  {
    __typename: "ModelTrainingScheduleConnection",
    items:  Array< {
      __typename: "TrainingSchedule",
      assignedUserId?: string | null,
      categoryId?: string | null,
      companyId: string,
      createdAt: string,
      dayNumber: number,
      id: string,
      locked?: boolean | null,
      owner?: string | null,
      planId: string,
      scheduledDate: string,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingSchedulesQueryVariables = {
  filter?: ModelTrainingScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingSchedulesQuery = {
  listTrainingSchedules?:  {
    __typename: "ModelTrainingScheduleConnection",
    items:  Array< {
      __typename: "TrainingSchedule",
      assignedUserId?: string | null,
      categoryId?: string | null,
      companyId: string,
      createdAt: string,
      dayNumber: number,
      id: string,
      locked?: boolean | null,
      owner?: string | null,
      planId: string,
      scheduledDate: string,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingTopicByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingTopicFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTrainingTopicByCompanyIdQuery = {
  listTrainingTopicByCompanyId?:  {
    __typename: "ModelTrainingTopicConnection",
    items:  Array< {
      __typename: "TrainingTopic",
      categoryIds?: Array< string | null > | null,
      companyId: string,
      companyResourceId?: string | null,
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      description: string,
      id: string,
      owner?: string | null,
      planIds?: Array< string | null > | null,
      style: string,
      timeValue: number,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingTopicByTopicIdQueryVariables = {
  filter?: ModelTrainingTopicFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  topicId: string,
};

export type ListTrainingTopicByTopicIdQuery = {
  listTrainingTopicByTopicId?:  {
    __typename: "ModelTrainingTopicConnection",
    items:  Array< {
      __typename: "TrainingTopic",
      categoryIds?: Array< string | null > | null,
      companyId: string,
      companyResourceId?: string | null,
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      description: string,
      id: string,
      owner?: string | null,
      planIds?: Array< string | null > | null,
      style: string,
      timeValue: number,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTrainingTopicsQueryVariables = {
  filter?: ModelTrainingTopicFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTrainingTopicsQuery = {
  listTrainingTopics?:  {
    __typename: "ModelTrainingTopicConnection",
    items:  Array< {
      __typename: "TrainingTopic",
      categoryIds?: Array< string | null > | null,
      companyId: string,
      companyResourceId?: string | null,
      contentFilePath?: string | null,
      contentUrl?: string | null,
      createdAt: string,
      description: string,
      id: string,
      owner?: string | null,
      planIds?: Array< string | null > | null,
      style: string,
      timeValue: number,
      topicId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUnitExpenseBudgetByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelUnitExpenseBudgetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUnitExpenseBudgetByCompanyIdQuery = {
  listUnitExpenseBudgetByCompanyId?:  {
    __typename: "ModelUnitExpenseBudgetConnection",
    items:  Array< {
      __typename: "UnitExpenseBudget",
      companyId: string,
      createdAt: string,
      expenseCategoryId: string,
      id: string,
      owner?: string | null,
      startingBalance: number,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUnitExpenseBudgetByExpenseCategoryIdQueryVariables = {
  expenseCategoryId: string,
  filter?: ModelUnitExpenseBudgetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUnitExpenseBudgetByExpenseCategoryIdQuery = {
  listUnitExpenseBudgetByExpenseCategoryId?:  {
    __typename: "ModelUnitExpenseBudgetConnection",
    items:  Array< {
      __typename: "UnitExpenseBudget",
      companyId: string,
      createdAt: string,
      expenseCategoryId: string,
      id: string,
      owner?: string | null,
      startingBalance: number,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUnitExpenseBudgetByUnitIdQueryVariables = {
  filter?: ModelUnitExpenseBudgetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ListUnitExpenseBudgetByUnitIdQuery = {
  listUnitExpenseBudgetByUnitId?:  {
    __typename: "ModelUnitExpenseBudgetConnection",
    items:  Array< {
      __typename: "UnitExpenseBudget",
      companyId: string,
      createdAt: string,
      expenseCategoryId: string,
      id: string,
      owner?: string | null,
      startingBalance: number,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUnitExpenseBudgetsQueryVariables = {
  filter?: ModelUnitExpenseBudgetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitExpenseBudgetsQuery = {
  listUnitExpenseBudgets?:  {
    __typename: "ModelUnitExpenseBudgetConnection",
    items:  Array< {
      __typename: "UnitExpenseBudget",
      companyId: string,
      createdAt: string,
      expenseCategoryId: string,
      id: string,
      owner?: string | null,
      startingBalance: number,
      unitId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserFilesQueryVariables = {
  filter?: ModelUserFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFilesQuery = {
  listUserFiles?:  {
    __typename: "ModelUserFileConnection",
    items:  Array< {
      __typename: "UserFile",
      companyId: string,
      createdAt: string,
      fileName: string,
      fileSize: number,
      id: string,
      owner?: string | null,
      s3Path: string,
      updatedAt: string,
      uploadedAt: string,
      uploadedBy: string,
      uploadedByName: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserReportFavoriteByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelUserReportFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserReportFavoriteByCompanyIdQuery = {
  listUserReportFavoriteByCompanyId?:  {
    __typename: "ModelUserReportFavoriteConnection",
    items:  Array< {
      __typename: "UserReportFavorite",
      companyId: string,
      createdAt: string,
      id: string,
      reportTypeKey: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserReportFavoriteByUserIdAndReportTypeKeyQueryVariables = {
  filter?: ModelUserReportFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  reportTypeKey?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListUserReportFavoriteByUserIdAndReportTypeKeyQuery = {
  listUserReportFavoriteByUserIdAndReportTypeKey?:  {
    __typename: "ModelUserReportFavoriteConnection",
    items:  Array< {
      __typename: "UserReportFavorite",
      companyId: string,
      createdAt: string,
      id: string,
      reportTypeKey: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserReportFavoritesQueryVariables = {
  filter?: ModelUserReportFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserReportFavoritesQuery = {
  listUserReportFavorites?:  {
    __typename: "ModelUserReportFavoriteConnection",
    items:  Array< {
      __typename: "UserReportFavorite",
      companyId: string,
      createdAt: string,
      id: string,
      reportTypeKey: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSkillReportByCompanyIdAndCreatedAtQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelUserSkillReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserSkillReportByCompanyIdAndCreatedAtQuery = {
  listUserSkillReportByCompanyIdAndCreatedAt?:  {
    __typename: "ModelUserSkillReportConnection",
    items:  Array< {
      __typename: "UserSkillReport",
      assessorId?: string | null,
      assessorName?: string | null,
      companyId: string,
      createdAt?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      okCount?: number | null,
      passFailStatus?: string | null,
      photos?: Array< string | null > | null,
      qualificationLevel?: string | null,
      responseData?: string | null,
      signature?: string | null,
      skillCategory?: string | null,
      skillName?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSkillReportByUserIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelUserSkillReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListUserSkillReportByUserIdAndCreatedAtQuery = {
  listUserSkillReportByUserIdAndCreatedAt?:  {
    __typename: "ModelUserSkillReportConnection",
    items:  Array< {
      __typename: "UserSkillReport",
      assessorId?: string | null,
      assessorName?: string | null,
      companyId: string,
      createdAt?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      okCount?: number | null,
      passFailStatus?: string | null,
      photos?: Array< string | null > | null,
      qualificationLevel?: string | null,
      responseData?: string | null,
      signature?: string | null,
      skillCategory?: string | null,
      skillName?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSkillReportsQueryVariables = {
  filter?: ModelUserSkillReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserSkillReportsQuery = {
  listUserSkillReports?:  {
    __typename: "ModelUserSkillReportConnection",
    items:  Array< {
      __typename: "UserSkillReport",
      assessorId?: string | null,
      assessorName?: string | null,
      companyId: string,
      createdAt?: string | null,
      expirationDate?: string | null,
      formId?: string | null,
      gpsLatitude?: number | null,
      gpsLocationType?: string | null,
      gpsLongitude?: number | null,
      id: string,
      inopCount?: number | null,
      inspectionCompleted?: string | null,
      inspectionDurationSeconds?: number | null,
      inspectionStarted?: string | null,
      okCount?: number | null,
      passFailStatus?: string | null,
      photos?: Array< string | null > | null,
      qualificationLevel?: string | null,
      responseData?: string | null,
      signature?: string | null,
      skillCategory?: string | null,
      skillName?: string | null,
      totalItems?: number | null,
      updatedAt: string,
      userId: string,
      userName?: string | null,
      warnCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      archived?: boolean | null,
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      contactPhoneType?: string | null,
      createdAt: string,
      currentJobClassification?: string | null,
      dateOfHire?: string | null,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      driversLicenseStatus?: boolean | null,
      email: string,
      globalLocationPermission?: boolean | null,
      id: string,
      inputByPerson?: string | null,
      inputDate?: string | null,
      locationAssignment?: Array< string | null > | null,
      name: string,
      notesAboutUser?: string | null,
      onHighwayEligibility?: boolean | null,
      owner?: string | null,
      permissions?: string | null,
      personalIdentification?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      position?: string | null,
      regionalAssignment?: Array< string | null > | null,
      role?: string | null,
      safetyLessons?: string | null,
      skillTrackingModuleEnrollment?: boolean | null,
      trainingModuleEnrollment?: boolean | null,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
      userPhoto?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVendorListByCompanyIdAndUpdatedAtQueryVariables = {
  companyId: string,
  filter?: ModelVendorListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListVendorListByCompanyIdAndUpdatedAtQuery = {
  listVendorListByCompanyIdAndUpdatedAt?:  {
    __typename: "ModelVendorListConnection",
    items:  Array< {
      __typename: "VendorList",
      address?: string | null,
      companyId: string,
      createdAt: string,
      faxNumber?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      phoneNumber?: string | null,
      repName?: string | null,
      repPhoneNumber?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVendorListsQueryVariables = {
  filter?: ModelVendorListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVendorListsQuery = {
  listVendorLists?:  {
    __typename: "ModelVendorListConnection",
    items:  Array< {
      __typename: "VendorList",
      address?: string | null,
      companyId: string,
      createdAt: string,
      faxNumber?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      phoneNumber?: string | null,
      repName?: string | null,
      repPhoneNumber?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVideosQueryVariables = {
  filter?: ModelVideoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVideosQuery = {
  listVideos?:  {
    __typename: "ModelVideoConnection",
    items:  Array< {
      __typename: "Video",
      assignedSafetyLesson?: string | null,
      contentPath: string,
      createdAt: string,
      folderName?: string | null,
      id: string,
      owner?: string | null,
      resourceLibraryID?: string | null,
      safetyLesson?: boolean | null,
      sharedWithCompanyIds?: Array< string | null > | null,
      title: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReportsByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ReportsByCompanyIdQuery = {
  reportsByCompanyId?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogReport?: boolean | null,
      equipmentId: string,
      equipmentLocationId?: string | null,
      equipmentName?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReportsByEquipmentIdQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  equipmentId: string,
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ReportsByEquipmentIdQuery = {
  reportsByEquipmentId?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogReport?: boolean | null,
      equipmentId: string,
      equipmentLocationId?: string | null,
      equipmentName?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReportsByUnitIdQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type ReportsByUnitIdQuery = {
  reportsByUnitId?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      dailyServiceLogReport?: boolean | null,
      equipmentId: string,
      equipmentLocationId?: string | null,
      equipmentName?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SensitiveUserInfoByCognitoIdQueryVariables = {
  cognitoId: string,
  filter?: ModelSensitiveUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SensitiveUserInfoByCognitoIdQuery = {
  sensitiveUserInfoByCognitoId?:  {
    __typename: "ModelSensitiveUserInfoConnection",
    items:  Array< {
      __typename: "SensitiveUserInfo",
      cognitoId?: string | null,
      companyId?: string | null,
      createdAt: string,
      dateOfBirth?: string | null,
      driversLicenseClass?: string | null,
      driversLicenseExpirationDate?: string | null,
      driversLicenseNumber?: string | null,
      driversLicenseState?: string | null,
      emergencyContactName?: string | null,
      emergencyContactPhoneNumber?: string | null,
      emergencyContactRelationship?: string | null,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SensitiveUserInfoByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSensitiveUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SensitiveUserInfoByCompanyIdQuery = {
  sensitiveUserInfoByCompanyId?:  {
    __typename: "ModelSensitiveUserInfoConnection",
    items:  Array< {
      __typename: "SensitiveUserInfo",
      cognitoId?: string | null,
      companyId?: string | null,
      createdAt: string,
      dateOfBirth?: string | null,
      driversLicenseClass?: string | null,
      driversLicenseExpirationDate?: string | null,
      driversLicenseNumber?: string | null,
      driversLicenseState?: string | null,
      emergencyContactName?: string | null,
      emergencyContactPhoneNumber?: string | null,
      emergencyContactRelationship?: string | null,
      id: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillAssignmentsByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSkillAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillAssignmentsByCompanyIdQuery = {
  skillAssignmentsByCompanyId?:  {
    __typename: "ModelSkillAssignmentConnection",
    items:  Array< {
      __typename: "SkillAssignment",
      companyId: string,
      createdAt: string,
      evaluatedBy?: string | null,
      evaluatedByName?: string | null,
      evaluationDate?: string | null,
      id: string,
      owner?: string | null,
      skillLevel: string,
      subCategoryId?: string | null,
      taskId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillAssignmentsByUserIdQueryVariables = {
  filter?: ModelSkillAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type SkillAssignmentsByUserIdQuery = {
  skillAssignmentsByUserId?:  {
    __typename: "ModelSkillAssignmentConnection",
    items:  Array< {
      __typename: "SkillAssignment",
      companyId: string,
      createdAt: string,
      evaluatedBy?: string | null,
      evaluatedByName?: string | null,
      evaluationDate?: string | null,
      id: string,
      owner?: string | null,
      skillLevel: string,
      subCategoryId?: string | null,
      taskId: string,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillCategoriesByClassificationIdQueryVariables = {
  classificationId: string,
  filter?: ModelSkillCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillCategoriesByClassificationIdQuery = {
  skillCategoriesByClassificationId?:  {
    __typename: "ModelSkillCategoryConnection",
    items:  Array< {
      __typename: "SkillCategory",
      allowMachineNumber?: boolean | null,
      classificationId: string,
      companyId: string,
      createdAt: string,
      equipmentCategoryId?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillCategoriesByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSkillCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillCategoriesByCompanyIdQuery = {
  skillCategoriesByCompanyId?:  {
    __typename: "ModelSkillCategoryConnection",
    items:  Array< {
      __typename: "SkillCategory",
      allowMachineNumber?: boolean | null,
      classificationId: string,
      companyId: string,
      createdAt: string,
      equipmentCategoryId?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillLevelsByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSkillLevelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillLevelsByCompanyIdQuery = {
  skillLevelsByCompanyId?:  {
    __typename: "ModelSkillLevelConnection",
    items:  Array< {
      __typename: "SkillLevel",
      color?: string | null,
      companyId: string,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      owner?: string | null,
      sortOrder: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillTasksByCategoryIdQueryVariables = {
  categoryId: string,
  filter?: ModelSkillTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillTasksByCategoryIdQuery = {
  skillTasksByCategoryId?:  {
    __typename: "ModelSkillTaskConnection",
    items:  Array< {
      __typename: "SkillTask",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SkillTasksByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSkillTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SkillTasksByCompanyIdQuery = {
  skillTasksByCompanyId?:  {
    __typename: "ModelSkillTaskConnection",
    items:  Array< {
      __typename: "SkillTask",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SubCategoriesByCategoryIdQueryVariables = {
  categoryId: string,
  filter?: ModelSubCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SubCategoriesByCategoryIdQuery = {
  subCategoriesByCategoryId?:  {
    __typename: "ModelSubCategoryConnection",
    items:  Array< {
      __typename: "SubCategory",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SubCategoriesByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelSubCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SubCategoriesByCompanyIdQuery = {
  subCategoriesByCompanyId?:  {
    __typename: "ModelSubCategoryConnection",
    items:  Array< {
      __typename: "SubCategory",
      categoryId: string,
      companyId: string,
      createdAt: string,
      id: string,
      name: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TireReportsByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelTireReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type TireReportsByCompanyIdQuery = {
  tireReportsByCompanyId?:  {
    __typename: "ModelTireReportConnection",
    items:  Array< {
      __typename: "TireReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      equipmentLocationId?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      tireId?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TireReportsByEquipmentCategoryIdQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  equipmentCategoryId: string,
  filter?: ModelTireReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type TireReportsByEquipmentCategoryIdQuery = {
  tireReportsByEquipmentCategoryId?:  {
    __typename: "ModelTireReportConnection",
    items:  Array< {
      __typename: "TireReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      equipmentLocationId?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      tireId?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TireReportsByTireIdQueryVariables = {
  filter?: ModelTireReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  tireId: string,
};

export type TireReportsByTireIdQuery = {
  tireReportsByTireId?:  {
    __typename: "ModelTireReportConnection",
    items:  Array< {
      __typename: "TireReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      equipmentLocationId?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      tireId?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TireReportsByUnitIdQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelTireReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  unitId: string,
};

export type TireReportsByUnitIdQuery = {
  tireReportsByUnitId?:  {
    __typename: "ModelTireReportConnection",
    items:  Array< {
      __typename: "TireReport",
      alwaysTriggerEmail?: boolean | null,
      companyId: string,
      createdAt?: string | null,
      equipmentCategoryId: string,
      equipmentCategoryName?: string | null,
      equipmentLocationId?: string | null,
      id: string,
      inspectionCompleted?: string | null,
      inspectionStarted?: string | null,
      name: string,
      signature?: string | null,
      tireId?: string | null,
      unitId?: string | null,
      unitName?: string | null,
      updatedAt: string,
      userData: string,
      userId: string,
      userLocation: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TrainingQuizResponsesByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelTrainingQuizResponseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type TrainingQuizResponsesByCompanyIdQuery = {
  trainingQuizResponsesByCompanyId?:  {
    __typename: "ModelTrainingQuizResponseConnection",
    items:  Array< {
      __typename: "TrainingQuizResponse",
      attemptNumber?: number | null,
      categoryId?: string | null,
      companyId: string,
      completedAt?: string | null,
      createdAt: string,
      cycleStartDate?: string | null,
      formId?: string | null,
      id: string,
      owner?: string | null,
      passed?: boolean | null,
      planId: string,
      responseData?: string | null,
      score?: number | null,
      signaturePath?: string | null,
      totalQuestions?: number | null,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TrainingQuizResponsesByUserIdQueryVariables = {
  filter?: ModelTrainingQuizResponseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type TrainingQuizResponsesByUserIdQuery = {
  trainingQuizResponsesByUserId?:  {
    __typename: "ModelTrainingQuizResponseConnection",
    items:  Array< {
      __typename: "TrainingQuizResponse",
      attemptNumber?: number | null,
      categoryId?: string | null,
      companyId: string,
      completedAt?: string | null,
      createdAt: string,
      cycleStartDate?: string | null,
      formId?: string | null,
      id: string,
      owner?: string | null,
      passed?: boolean | null,
      planId: string,
      responseData?: string | null,
      score?: number | null,
      signaturePath?: string | null,
      totalQuestions?: number | null,
      updatedAt: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserFilesByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelUserFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type UserFilesByCompanyIdQuery = {
  userFilesByCompanyId?:  {
    __typename: "ModelUserFileConnection",
    items:  Array< {
      __typename: "UserFile",
      companyId: string,
      createdAt: string,
      fileName: string,
      fileSize: number,
      id: string,
      owner?: string | null,
      s3Path: string,
      updatedAt: string,
      uploadedAt: string,
      uploadedBy: string,
      uploadedByName: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserFilesByUserIdQueryVariables = {
  filter?: ModelUserFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type UserFilesByUserIdQuery = {
  userFilesByUserId?:  {
    __typename: "ModelUserFileConnection",
    items:  Array< {
      __typename: "UserFile",
      companyId: string,
      createdAt: string,
      fileName: string,
      fileSize: number,
      id: string,
      owner?: string | null,
      s3Path: string,
      updatedAt: string,
      uploadedAt: string,
      uploadedBy: string,
      uploadedByName: string,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByCognitoIdQueryVariables = {
  cognitoId: string,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type UsersByCognitoIdQuery = {
  usersByCognitoId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      archived?: boolean | null,
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      contactPhoneType?: string | null,
      createdAt: string,
      currentJobClassification?: string | null,
      dateOfHire?: string | null,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      driversLicenseStatus?: boolean | null,
      email: string,
      globalLocationPermission?: boolean | null,
      id: string,
      inputByPerson?: string | null,
      inputDate?: string | null,
      locationAssignment?: Array< string | null > | null,
      name: string,
      notesAboutUser?: string | null,
      onHighwayEligibility?: boolean | null,
      owner?: string | null,
      permissions?: string | null,
      personalIdentification?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      position?: string | null,
      regionalAssignment?: Array< string | null > | null,
      role?: string | null,
      safetyLessons?: string | null,
      skillTrackingModuleEnrollment?: boolean | null,
      trainingModuleEnrollment?: boolean | null,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
      userPhoto?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByCompanyIdQueryVariables = {
  companyId: string,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type UsersByCompanyIdQuery = {
  usersByCompanyId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      archived?: boolean | null,
      cognitoId?: string | null,
      companyId?: string | null,
      contactPhoneNumber?: string | null,
      contactPhoneType?: string | null,
      createdAt: string,
      currentJobClassification?: string | null,
      dateOfHire?: string | null,
      discrepancyNotification?: boolean | null,
      discrepancyNotificationTypes?: string | null,
      domain?: string | null,
      driversLicenseStatus?: boolean | null,
      email: string,
      globalLocationPermission?: boolean | null,
      id: string,
      inputByPerson?: string | null,
      inputDate?: string | null,
      locationAssignment?: Array< string | null > | null,
      name: string,
      notesAboutUser?: string | null,
      onHighwayEligibility?: boolean | null,
      owner?: string | null,
      permissions?: string | null,
      personalIdentification?: string | null,
      pmNotification?: boolean | null,
      pmNotificationTypes?: string | null,
      position?: string | null,
      regionalAssignment?: Array< string | null > | null,
      role?: string | null,
      safetyLessons?: string | null,
      skillTrackingModuleEnrollment?: boolean | null,
      trainingModuleEnrollment?: boolean | null,
      trainingNotification?: boolean | null,
      trainingNotificationTypes?: string | null,
      updatedAt: string,
      userPhoto?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CreateArchivedDiscrepancyMutationVariables = {
  condition?: ModelArchivedDiscrepancyConditionInput | null,
  input: CreateArchivedDiscrepancyInput,
};

export type CreateArchivedDiscrepancyMutation = {
  createArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAuditLogMutationVariables = {
  condition?: ModelAuditLogConditionInput | null,
  input: CreateAuditLogInput,
};

export type CreateAuditLogMutation = {
  createAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type CreateAxleBlueprintMutationVariables = {
  condition?: ModelAxleBlueprintConditionInput | null,
  input: CreateAxleBlueprintInput,
};

export type CreateAxleBlueprintMutation = {
  createAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateBillingRateMutationVariables = {
  condition?: ModelBillingRateConditionInput | null,
  input: CreateBillingRateInput,
};

export type CreateBillingRateMutation = {
  createBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateBusinessAdminMutationVariables = {
  condition?: ModelBusinessAdminConditionInput | null,
  input: CreateBusinessAdminInput,
};

export type CreateBusinessAdminMutation = {
  createBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type CreateChangeLogEntryMutationVariables = {
  condition?: ModelChangeLogEntryConditionInput | null,
  input: CreateChangeLogEntryInput,
};

export type CreateChangeLogEntryMutation = {
  createChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateClassificationMutationVariables = {
  condition?: ModelClassificationConditionInput | null,
  input: CreateClassificationInput,
};

export type CreateClassificationMutation = {
  createClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCompanyMutationVariables = {
  condition?: ModelCompanyConditionInput | null,
  input: CreateCompanyInput,
};

export type CreateCompanyMutation = {
  createCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCompanyNoteMutationVariables = {
  condition?: ModelCompanyNoteConditionInput | null,
  input: CreateCompanyNoteInput,
};

export type CreateCompanyNoteMutation = {
  createCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCompanyOwnerMutationVariables = {
  condition?: ModelCompanyOwnerConditionInput | null,
  input: CreateCompanyOwnerInput,
};

export type CreateCompanyOwnerMutation = {
  createCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCompanyResourceMutationVariables = {
  condition?: ModelCompanyResourceConditionInput | null,
  input: CreateCompanyResourceInput,
};

export type CreateCompanyResourceMutation = {
  createCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type CreateDOTInspectionReportMutationVariables = {
  condition?: ModelDOTInspectionReportConditionInput | null,
  input: CreateDOTInspectionReportInput,
};

export type CreateDOTInspectionReportMutation = {
  createDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type CreateDailyServiceReportMutationVariables = {
  condition?: ModelDailyServiceReportConditionInput | null,
  input: CreateDailyServiceReportInput,
};

export type CreateDailyServiceReportMutation = {
  createDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type CreateDiscrepancyMutationVariables = {
  condition?: ModelDiscrepancyConditionInput | null,
  input: CreateDiscrepancyInput,
};

export type CreateDiscrepancyMutation = {
  createDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateDocumentMutationVariables = {
  condition?: ModelDocumentConditionInput | null,
  input: CreateDocumentInput,
};

export type CreateDocumentMutation = {
  createDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type CreateEquipmentMutationVariables = {
  condition?: ModelEquipmentConditionInput | null,
  input: CreateEquipmentInput,
};

export type CreateEquipmentMutation = {
  createEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateEquipmentCategoryMutationVariables = {
  condition?: ModelEquipmentCategoryConditionInput | null,
  input: CreateEquipmentCategoryInput,
};

export type CreateEquipmentCategoryMutation = {
  createEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type CreateErrorsMutationVariables = {
  condition?: ModelErrorsConditionInput | null,
  input: CreateErrorsInput,
};

export type CreateErrorsMutation = {
  createErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type CreateExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: CreateExpenseCategoryInput,
};

export type CreateExpenseCategoryMutation = {
  createExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateExpenseRecordMutationVariables = {
  condition?: ModelExpenseRecordConditionInput | null,
  input: CreateExpenseRecordInput,
};

export type CreateExpenseRecordMutation = {
  createExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type CreateFormMutationVariables = {
  condition?: ModelFormConditionInput | null,
  input: CreateFormInput,
};

export type CreateFormMutation = {
  createForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateFormTemplateMutationVariables = {
  condition?: ModelFormTemplateConditionInput | null,
  input: CreateFormTemplateInput,
};

export type CreateFormTemplateMutation = {
  createFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type CreateFormTemplateGroupMutationVariables = {
  condition?: ModelFormTemplateGroupConditionInput | null,
  input: CreateFormTemplateGroupInput,
};

export type CreateFormTemplateGroupMutation = {
  createFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type CreateHelpSupportDocMutationVariables = {
  condition?: ModelHelpSupportDocConditionInput | null,
  input: CreateHelpSupportDocInput,
};

export type CreateHelpSupportDocMutation = {
  createHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type CreateInspectionReportMutationVariables = {
  condition?: ModelInspectionReportConditionInput | null,
  input: CreateInspectionReportInput,
};

export type CreateInspectionReportMutation = {
  createInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type CreateInvoiceMutationVariables = {
  condition?: ModelInvoiceConditionInput | null,
  input: CreateInvoiceInput,
};

export type CreateInvoiceMutation = {
  createInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type CreateLaborCategoryMutationVariables = {
  condition?: ModelLaborCategoryConditionInput | null,
  input: CreateLaborCategoryInput,
};

export type CreateLaborCategoryMutation = {
  createLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLaborRateMutationVariables = {
  condition?: ModelLaborRateConditionInput | null,
  input: CreateLaborRateInput,
};

export type CreateLaborRateMutation = {
  createLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type CreateLibraryPlanTemplateMutationVariables = {
  condition?: ModelLibraryPlanTemplateConditionInput | null,
  input: CreateLibraryPlanTemplateInput,
};

export type CreateLibraryPlanTemplateMutation = {
  createLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type CreateLibraryTopicTemplateMutationVariables = {
  condition?: ModelLibraryTopicTemplateConditionInput | null,
  input: CreateLibraryTopicTemplateInput,
};

export type CreateLibraryTopicTemplateMutation = {
  createLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type CreateLocationMutationVariables = {
  condition?: ModelLocationConditionInput | null,
  input: CreateLocationInput,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type CreateModuleSubscriptionMutationVariables = {
  condition?: ModelModuleSubscriptionConditionInput | null,
  input: CreateModuleSubscriptionInput,
};

export type CreateModuleSubscriptionMutation = {
  createModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type CreatePMConfigurationMutationVariables = {
  condition?: ModelPMConfigurationConditionInput | null,
  input: CreatePMConfigurationInput,
};

export type CreatePMConfigurationMutation = {
  createPMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type CreatePMModuleContentMutationVariables = {
  condition?: ModelPMModuleContentConditionInput | null,
  input: CreatePMModuleContentInput,
};

export type CreatePMModuleContentMutation = {
  createPMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type CreatePMNotificationSettingMutationVariables = {
  condition?: ModelPMNotificationSettingConditionInput | null,
  input: CreatePMNotificationSettingInput,
};

export type CreatePMNotificationSettingMutation = {
  createPMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePMPartsAndProcedureMutationVariables = {
  condition?: ModelPMPartsAndProcedureConditionInput | null,
  input: CreatePMPartsAndProcedureInput,
};

export type CreatePMPartsAndProcedureMutation = {
  createPMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type CreatePMReportMutationVariables = {
  condition?: ModelPMReportConditionInput | null,
  input: CreatePMReportInput,
};

export type CreatePMReportMutation = {
  createPMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type CreatePMServiceLevelMutationVariables = {
  condition?: ModelPMServiceLevelConditionInput | null,
  input: CreatePMServiceLevelInput,
};

export type CreatePMServiceLevelMutation = {
  createPMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type CreateRegionalDivisionMutationVariables = {
  condition?: ModelRegionalDivisionConditionInput | null,
  input: CreateRegionalDivisionInput,
};

export type CreateRegionalDivisionMutation = {
  createRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: CreateReportInput,
};

export type CreateReportMutation = {
  createReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type CreateReportAnswerMutationVariables = {
  condition?: ModelReportAnswerConditionInput | null,
  input: CreateReportAnswerInput,
};

export type CreateReportAnswerMutation = {
  createReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type CreateResourceLibraryMutationVariables = {
  condition?: ModelResourceLibraryConditionInput | null,
  input: CreateResourceLibraryInput,
};

export type CreateResourceLibraryMutation = {
  createResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateSavedReportConfigurationMutationVariables = {
  condition?: ModelSavedReportConfigurationConditionInput | null,
  input: CreateSavedReportConfigurationInput,
};

export type CreateSavedReportConfigurationMutation = {
  createSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type CreateSensitiveUserInfoMutationVariables = {
  condition?: ModelSensitiveUserInfoConditionInput | null,
  input: CreateSensitiveUserInfoInput,
};

export type CreateSensitiveUserInfoMutation = {
  createSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateShiftReportMutationVariables = {
  condition?: ModelShiftReportConditionInput | null,
  input: CreateShiftReportInput,
};

export type CreateShiftReportMutation = {
  createShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type CreateSingleUnitMutationVariables = {
  condition?: ModelSingleUnitConditionInput | null,
  input: CreateSingleUnitInput,
};

export type CreateSingleUnitMutation = {
  createSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type CreateSkillAssignmentMutationVariables = {
  condition?: ModelSkillAssignmentConditionInput | null,
  input: CreateSkillAssignmentInput,
};

export type CreateSkillAssignmentMutation = {
  createSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateSkillCategoryMutationVariables = {
  condition?: ModelSkillCategoryConditionInput | null,
  input: CreateSkillCategoryInput,
};

export type CreateSkillCategoryMutation = {
  createSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateSkillLevelMutationVariables = {
  condition?: ModelSkillLevelConditionInput | null,
  input: CreateSkillLevelInput,
};

export type CreateSkillLevelMutation = {
  createSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type CreateSkillTaskMutationVariables = {
  condition?: ModelSkillTaskConditionInput | null,
  input: CreateSkillTaskInput,
};

export type CreateSkillTaskMutation = {
  createSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateSubCategoryMutationVariables = {
  condition?: ModelSubCategoryConditionInput | null,
  input: CreateSubCategoryInput,
};

export type CreateSubCategoryMutation = {
  createSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateTireMutationVariables = {
  condition?: ModelTireConditionInput | null,
  input: CreateTireInput,
};

export type CreateTireMutation = {
  createTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateTireReportMutationVariables = {
  condition?: ModelTireReportConditionInput | null,
  input: CreateTireReportInput,
};

export type CreateTireReportMutation = {
  createTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type CreateTrainingAffidavitMutationVariables = {
  condition?: ModelTrainingAffidavitConditionInput | null,
  input: CreateTrainingAffidavitInput,
};

export type CreateTrainingAffidavitMutation = {
  createTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateTrainingCompletionMutationVariables = {
  condition?: ModelTrainingCompletionConditionInput | null,
  input: CreateTrainingCompletionInput,
};

export type CreateTrainingCompletionMutation = {
  createTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateTrainingEnrollmentMutationVariables = {
  condition?: ModelTrainingEnrollmentConditionInput | null,
  input: CreateTrainingEnrollmentInput,
};

export type CreateTrainingEnrollmentMutation = {
  createTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateTrainingPlanMutationVariables = {
  condition?: ModelTrainingPlanConditionInput | null,
  input: CreateTrainingPlanInput,
};

export type CreateTrainingPlanMutation = {
  createTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type CreateTrainingQuizResponseMutationVariables = {
  condition?: ModelTrainingQuizResponseConditionInput | null,
  input: CreateTrainingQuizResponseInput,
};

export type CreateTrainingQuizResponseMutation = {
  createTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateTrainingScheduleMutationVariables = {
  condition?: ModelTrainingScheduleConditionInput | null,
  input: CreateTrainingScheduleInput,
};

export type CreateTrainingScheduleMutation = {
  createTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type CreateTrainingTopicMutationVariables = {
  condition?: ModelTrainingTopicConditionInput | null,
  input: CreateTrainingTopicInput,
};

export type CreateTrainingTopicMutation = {
  createTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type CreateUnitExpenseBudgetMutationVariables = {
  condition?: ModelUnitExpenseBudgetConditionInput | null,
  input: CreateUnitExpenseBudgetInput,
};

export type CreateUnitExpenseBudgetMutation = {
  createUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: CreateUserInput,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type CreateUserFileMutationVariables = {
  condition?: ModelUserFileConditionInput | null,
  input: CreateUserFileInput,
};

export type CreateUserFileMutation = {
  createUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type CreateUserReportFavoriteMutationVariables = {
  condition?: ModelUserReportFavoriteConditionInput | null,
  input: CreateUserReportFavoriteInput,
};

export type CreateUserReportFavoriteMutation = {
  createUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type CreateUserSkillReportMutationVariables = {
  condition?: ModelUserSkillReportConditionInput | null,
  input: CreateUserSkillReportInput,
};

export type CreateUserSkillReportMutation = {
  createUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type CreateVendorListMutationVariables = {
  condition?: ModelVendorListConditionInput | null,
  input: CreateVendorListInput,
};

export type CreateVendorListMutation = {
  createVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateVideoMutationVariables = {
  condition?: ModelVideoConditionInput | null,
  input: CreateVideoInput,
};

export type CreateVideoMutation = {
  createVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type DeleteArchivedDiscrepancyMutationVariables = {
  condition?: ModelArchivedDiscrepancyConditionInput | null,
  input: DeleteArchivedDiscrepancyInput,
};

export type DeleteArchivedDiscrepancyMutation = {
  deleteArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAuditLogMutationVariables = {
  condition?: ModelAuditLogConditionInput | null,
  input: DeleteAuditLogInput,
};

export type DeleteAuditLogMutation = {
  deleteAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type DeleteAxleBlueprintMutationVariables = {
  condition?: ModelAxleBlueprintConditionInput | null,
  input: DeleteAxleBlueprintInput,
};

export type DeleteAxleBlueprintMutation = {
  deleteAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteBillingRateMutationVariables = {
  condition?: ModelBillingRateConditionInput | null,
  input: DeleteBillingRateInput,
};

export type DeleteBillingRateMutation = {
  deleteBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteBusinessAdminMutationVariables = {
  condition?: ModelBusinessAdminConditionInput | null,
  input: DeleteBusinessAdminInput,
};

export type DeleteBusinessAdminMutation = {
  deleteBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type DeleteChangeLogEntryMutationVariables = {
  condition?: ModelChangeLogEntryConditionInput | null,
  input: DeleteChangeLogEntryInput,
};

export type DeleteChangeLogEntryMutation = {
  deleteChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteClassificationMutationVariables = {
  condition?: ModelClassificationConditionInput | null,
  input: DeleteClassificationInput,
};

export type DeleteClassificationMutation = {
  deleteClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyMutationVariables = {
  condition?: ModelCompanyConditionInput | null,
  input: DeleteCompanyInput,
};

export type DeleteCompanyMutation = {
  deleteCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyNoteMutationVariables = {
  condition?: ModelCompanyNoteConditionInput | null,
  input: DeleteCompanyNoteInput,
};

export type DeleteCompanyNoteMutation = {
  deleteCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyOwnerMutationVariables = {
  condition?: ModelCompanyOwnerConditionInput | null,
  input: DeleteCompanyOwnerInput,
};

export type DeleteCompanyOwnerMutation = {
  deleteCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyResourceMutationVariables = {
  condition?: ModelCompanyResourceConditionInput | null,
  input: DeleteCompanyResourceInput,
};

export type DeleteCompanyResourceMutation = {
  deleteCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type DeleteDOTInspectionReportMutationVariables = {
  condition?: ModelDOTInspectionReportConditionInput | null,
  input: DeleteDOTInspectionReportInput,
};

export type DeleteDOTInspectionReportMutation = {
  deleteDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type DeleteDailyServiceReportMutationVariables = {
  condition?: ModelDailyServiceReportConditionInput | null,
  input: DeleteDailyServiceReportInput,
};

export type DeleteDailyServiceReportMutation = {
  deleteDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type DeleteDiscrepancyMutationVariables = {
  condition?: ModelDiscrepancyConditionInput | null,
  input: DeleteDiscrepancyInput,
};

export type DeleteDiscrepancyMutation = {
  deleteDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteDocumentMutationVariables = {
  condition?: ModelDocumentConditionInput | null,
  input: DeleteDocumentInput,
};

export type DeleteDocumentMutation = {
  deleteDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type DeleteEquipmentMutationVariables = {
  condition?: ModelEquipmentConditionInput | null,
  input: DeleteEquipmentInput,
};

export type DeleteEquipmentMutation = {
  deleteEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteEquipmentCategoryMutationVariables = {
  condition?: ModelEquipmentCategoryConditionInput | null,
  input: DeleteEquipmentCategoryInput,
};

export type DeleteEquipmentCategoryMutation = {
  deleteEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type DeleteErrorsMutationVariables = {
  condition?: ModelErrorsConditionInput | null,
  input: DeleteErrorsInput,
};

export type DeleteErrorsMutation = {
  deleteErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type DeleteExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: DeleteExpenseCategoryInput,
};

export type DeleteExpenseCategoryMutation = {
  deleteExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteExpenseRecordMutationVariables = {
  condition?: ModelExpenseRecordConditionInput | null,
  input: DeleteExpenseRecordInput,
};

export type DeleteExpenseRecordMutation = {
  deleteExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type DeleteFormMutationVariables = {
  condition?: ModelFormConditionInput | null,
  input: DeleteFormInput,
};

export type DeleteFormMutation = {
  deleteForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteFormTemplateMutationVariables = {
  condition?: ModelFormTemplateConditionInput | null,
  input: DeleteFormTemplateInput,
};

export type DeleteFormTemplateMutation = {
  deleteFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type DeleteFormTemplateGroupMutationVariables = {
  condition?: ModelFormTemplateGroupConditionInput | null,
  input: DeleteFormTemplateGroupInput,
};

export type DeleteFormTemplateGroupMutation = {
  deleteFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type DeleteHelpSupportDocMutationVariables = {
  condition?: ModelHelpSupportDocConditionInput | null,
  input: DeleteHelpSupportDocInput,
};

export type DeleteHelpSupportDocMutation = {
  deleteHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type DeleteInspectionReportMutationVariables = {
  condition?: ModelInspectionReportConditionInput | null,
  input: DeleteInspectionReportInput,
};

export type DeleteInspectionReportMutation = {
  deleteInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type DeleteInvoiceMutationVariables = {
  condition?: ModelInvoiceConditionInput | null,
  input: DeleteInvoiceInput,
};

export type DeleteInvoiceMutation = {
  deleteInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type DeleteLaborCategoryMutationVariables = {
  condition?: ModelLaborCategoryConditionInput | null,
  input: DeleteLaborCategoryInput,
};

export type DeleteLaborCategoryMutation = {
  deleteLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLaborRateMutationVariables = {
  condition?: ModelLaborRateConditionInput | null,
  input: DeleteLaborRateInput,
};

export type DeleteLaborRateMutation = {
  deleteLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type DeleteLibraryPlanTemplateMutationVariables = {
  condition?: ModelLibraryPlanTemplateConditionInput | null,
  input: DeleteLibraryPlanTemplateInput,
};

export type DeleteLibraryPlanTemplateMutation = {
  deleteLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type DeleteLibraryTopicTemplateMutationVariables = {
  condition?: ModelLibraryTopicTemplateConditionInput | null,
  input: DeleteLibraryTopicTemplateInput,
};

export type DeleteLibraryTopicTemplateMutation = {
  deleteLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type DeleteLocationMutationVariables = {
  condition?: ModelLocationConditionInput | null,
  input: DeleteLocationInput,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type DeleteModuleSubscriptionMutationVariables = {
  condition?: ModelModuleSubscriptionConditionInput | null,
  input: DeleteModuleSubscriptionInput,
};

export type DeleteModuleSubscriptionMutation = {
  deleteModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type DeletePMConfigurationMutationVariables = {
  condition?: ModelPMConfigurationConditionInput | null,
  input: DeletePMConfigurationInput,
};

export type DeletePMConfigurationMutation = {
  deletePMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type DeletePMModuleContentMutationVariables = {
  condition?: ModelPMModuleContentConditionInput | null,
  input: DeletePMModuleContentInput,
};

export type DeletePMModuleContentMutation = {
  deletePMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type DeletePMNotificationSettingMutationVariables = {
  condition?: ModelPMNotificationSettingConditionInput | null,
  input: DeletePMNotificationSettingInput,
};

export type DeletePMNotificationSettingMutation = {
  deletePMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePMPartsAndProcedureMutationVariables = {
  condition?: ModelPMPartsAndProcedureConditionInput | null,
  input: DeletePMPartsAndProcedureInput,
};

export type DeletePMPartsAndProcedureMutation = {
  deletePMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type DeletePMReportMutationVariables = {
  condition?: ModelPMReportConditionInput | null,
  input: DeletePMReportInput,
};

export type DeletePMReportMutation = {
  deletePMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type DeletePMServiceLevelMutationVariables = {
  condition?: ModelPMServiceLevelConditionInput | null,
  input: DeletePMServiceLevelInput,
};

export type DeletePMServiceLevelMutation = {
  deletePMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type DeleteRegionalDivisionMutationVariables = {
  condition?: ModelRegionalDivisionConditionInput | null,
  input: DeleteRegionalDivisionInput,
};

export type DeleteRegionalDivisionMutation = {
  deleteRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: DeleteReportInput,
};

export type DeleteReportMutation = {
  deleteReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type DeleteReportAnswerMutationVariables = {
  condition?: ModelReportAnswerConditionInput | null,
  input: DeleteReportAnswerInput,
};

export type DeleteReportAnswerMutation = {
  deleteReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type DeleteResourceLibraryMutationVariables = {
  condition?: ModelResourceLibraryConditionInput | null,
  input: DeleteResourceLibraryInput,
};

export type DeleteResourceLibraryMutation = {
  deleteResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteSavedReportConfigurationMutationVariables = {
  condition?: ModelSavedReportConfigurationConditionInput | null,
  input: DeleteSavedReportConfigurationInput,
};

export type DeleteSavedReportConfigurationMutation = {
  deleteSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type DeleteSensitiveUserInfoMutationVariables = {
  condition?: ModelSensitiveUserInfoConditionInput | null,
  input: DeleteSensitiveUserInfoInput,
};

export type DeleteSensitiveUserInfoMutation = {
  deleteSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteShiftReportMutationVariables = {
  condition?: ModelShiftReportConditionInput | null,
  input: DeleteShiftReportInput,
};

export type DeleteShiftReportMutation = {
  deleteShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type DeleteSingleUnitMutationVariables = {
  condition?: ModelSingleUnitConditionInput | null,
  input: DeleteSingleUnitInput,
};

export type DeleteSingleUnitMutation = {
  deleteSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type DeleteSkillAssignmentMutationVariables = {
  condition?: ModelSkillAssignmentConditionInput | null,
  input: DeleteSkillAssignmentInput,
};

export type DeleteSkillAssignmentMutation = {
  deleteSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteSkillCategoryMutationVariables = {
  condition?: ModelSkillCategoryConditionInput | null,
  input: DeleteSkillCategoryInput,
};

export type DeleteSkillCategoryMutation = {
  deleteSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteSkillLevelMutationVariables = {
  condition?: ModelSkillLevelConditionInput | null,
  input: DeleteSkillLevelInput,
};

export type DeleteSkillLevelMutation = {
  deleteSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type DeleteSkillTaskMutationVariables = {
  condition?: ModelSkillTaskConditionInput | null,
  input: DeleteSkillTaskInput,
};

export type DeleteSkillTaskMutation = {
  deleteSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteSubCategoryMutationVariables = {
  condition?: ModelSubCategoryConditionInput | null,
  input: DeleteSubCategoryInput,
};

export type DeleteSubCategoryMutation = {
  deleteSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteTireMutationVariables = {
  condition?: ModelTireConditionInput | null,
  input: DeleteTireInput,
};

export type DeleteTireMutation = {
  deleteTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteTireReportMutationVariables = {
  condition?: ModelTireReportConditionInput | null,
  input: DeleteTireReportInput,
};

export type DeleteTireReportMutation = {
  deleteTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type DeleteTrainingAffidavitMutationVariables = {
  condition?: ModelTrainingAffidavitConditionInput | null,
  input: DeleteTrainingAffidavitInput,
};

export type DeleteTrainingAffidavitMutation = {
  deleteTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteTrainingCompletionMutationVariables = {
  condition?: ModelTrainingCompletionConditionInput | null,
  input: DeleteTrainingCompletionInput,
};

export type DeleteTrainingCompletionMutation = {
  deleteTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteTrainingEnrollmentMutationVariables = {
  condition?: ModelTrainingEnrollmentConditionInput | null,
  input: DeleteTrainingEnrollmentInput,
};

export type DeleteTrainingEnrollmentMutation = {
  deleteTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteTrainingPlanMutationVariables = {
  condition?: ModelTrainingPlanConditionInput | null,
  input: DeleteTrainingPlanInput,
};

export type DeleteTrainingPlanMutation = {
  deleteTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type DeleteTrainingQuizResponseMutationVariables = {
  condition?: ModelTrainingQuizResponseConditionInput | null,
  input: DeleteTrainingQuizResponseInput,
};

export type DeleteTrainingQuizResponseMutation = {
  deleteTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteTrainingScheduleMutationVariables = {
  condition?: ModelTrainingScheduleConditionInput | null,
  input: DeleteTrainingScheduleInput,
};

export type DeleteTrainingScheduleMutation = {
  deleteTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type DeleteTrainingTopicMutationVariables = {
  condition?: ModelTrainingTopicConditionInput | null,
  input: DeleteTrainingTopicInput,
};

export type DeleteTrainingTopicMutation = {
  deleteTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type DeleteUnitExpenseBudgetMutationVariables = {
  condition?: ModelUnitExpenseBudgetConditionInput | null,
  input: DeleteUnitExpenseBudgetInput,
};

export type DeleteUnitExpenseBudgetMutation = {
  deleteUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: DeleteUserInput,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type DeleteUserFileMutationVariables = {
  condition?: ModelUserFileConditionInput | null,
  input: DeleteUserFileInput,
};

export type DeleteUserFileMutation = {
  deleteUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type DeleteUserReportFavoriteMutationVariables = {
  condition?: ModelUserReportFavoriteConditionInput | null,
  input: DeleteUserReportFavoriteInput,
};

export type DeleteUserReportFavoriteMutation = {
  deleteUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type DeleteUserSkillReportMutationVariables = {
  condition?: ModelUserSkillReportConditionInput | null,
  input: DeleteUserSkillReportInput,
};

export type DeleteUserSkillReportMutation = {
  deleteUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type DeleteVendorListMutationVariables = {
  condition?: ModelVendorListConditionInput | null,
  input: DeleteVendorListInput,
};

export type DeleteVendorListMutation = {
  deleteVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteVideoMutationVariables = {
  condition?: ModelVideoConditionInput | null,
  input: DeleteVideoInput,
};

export type DeleteVideoMutation = {
  deleteVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type ResendInvitationMutationVariables = {
  email: string,
};

export type ResendInvitationMutation = {
  resendInvitation?: string | null,
};

export type UpdateArchivedDiscrepancyMutationVariables = {
  condition?: ModelArchivedDiscrepancyConditionInput | null,
  input: UpdateArchivedDiscrepancyInput,
};

export type UpdateArchivedDiscrepancyMutation = {
  updateArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAuditLogMutationVariables = {
  condition?: ModelAuditLogConditionInput | null,
  input: UpdateAuditLogInput,
};

export type UpdateAuditLogMutation = {
  updateAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type UpdateAxleBlueprintMutationVariables = {
  condition?: ModelAxleBlueprintConditionInput | null,
  input: UpdateAxleBlueprintInput,
};

export type UpdateAxleBlueprintMutation = {
  updateAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateBillingRateMutationVariables = {
  condition?: ModelBillingRateConditionInput | null,
  input: UpdateBillingRateInput,
};

export type UpdateBillingRateMutation = {
  updateBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateBusinessAdminMutationVariables = {
  condition?: ModelBusinessAdminConditionInput | null,
  input: UpdateBusinessAdminInput,
};

export type UpdateBusinessAdminMutation = {
  updateBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type UpdateChangeLogEntryMutationVariables = {
  condition?: ModelChangeLogEntryConditionInput | null,
  input: UpdateChangeLogEntryInput,
};

export type UpdateChangeLogEntryMutation = {
  updateChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateClassificationMutationVariables = {
  condition?: ModelClassificationConditionInput | null,
  input: UpdateClassificationInput,
};

export type UpdateClassificationMutation = {
  updateClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyMutationVariables = {
  condition?: ModelCompanyConditionInput | null,
  input: UpdateCompanyInput,
};

export type UpdateCompanyMutation = {
  updateCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyNoteMutationVariables = {
  condition?: ModelCompanyNoteConditionInput | null,
  input: UpdateCompanyNoteInput,
};

export type UpdateCompanyNoteMutation = {
  updateCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyOwnerMutationVariables = {
  condition?: ModelCompanyOwnerConditionInput | null,
  input: UpdateCompanyOwnerInput,
};

export type UpdateCompanyOwnerMutation = {
  updateCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyResourceMutationVariables = {
  condition?: ModelCompanyResourceConditionInput | null,
  input: UpdateCompanyResourceInput,
};

export type UpdateCompanyResourceMutation = {
  updateCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type UpdateDOTInspectionReportMutationVariables = {
  condition?: ModelDOTInspectionReportConditionInput | null,
  input: UpdateDOTInspectionReportInput,
};

export type UpdateDOTInspectionReportMutation = {
  updateDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type UpdateDailyServiceReportMutationVariables = {
  condition?: ModelDailyServiceReportConditionInput | null,
  input: UpdateDailyServiceReportInput,
};

export type UpdateDailyServiceReportMutation = {
  updateDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type UpdateDiscrepancyMutationVariables = {
  condition?: ModelDiscrepancyConditionInput | null,
  input: UpdateDiscrepancyInput,
};

export type UpdateDiscrepancyMutation = {
  updateDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateDocumentMutationVariables = {
  condition?: ModelDocumentConditionInput | null,
  input: UpdateDocumentInput,
};

export type UpdateDocumentMutation = {
  updateDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type UpdateEquipmentMutationVariables = {
  condition?: ModelEquipmentConditionInput | null,
  input: UpdateEquipmentInput,
};

export type UpdateEquipmentMutation = {
  updateEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateEquipmentCategoryMutationVariables = {
  condition?: ModelEquipmentCategoryConditionInput | null,
  input: UpdateEquipmentCategoryInput,
};

export type UpdateEquipmentCategoryMutation = {
  updateEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type UpdateErrorsMutationVariables = {
  condition?: ModelErrorsConditionInput | null,
  input: UpdateErrorsInput,
};

export type UpdateErrorsMutation = {
  updateErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type UpdateExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: UpdateExpenseCategoryInput,
};

export type UpdateExpenseCategoryMutation = {
  updateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateExpenseRecordMutationVariables = {
  condition?: ModelExpenseRecordConditionInput | null,
  input: UpdateExpenseRecordInput,
};

export type UpdateExpenseRecordMutation = {
  updateExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type UpdateFormMutationVariables = {
  condition?: ModelFormConditionInput | null,
  input: UpdateFormInput,
};

export type UpdateFormMutation = {
  updateForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateFormTemplateMutationVariables = {
  condition?: ModelFormTemplateConditionInput | null,
  input: UpdateFormTemplateInput,
};

export type UpdateFormTemplateMutation = {
  updateFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type UpdateFormTemplateGroupMutationVariables = {
  condition?: ModelFormTemplateGroupConditionInput | null,
  input: UpdateFormTemplateGroupInput,
};

export type UpdateFormTemplateGroupMutation = {
  updateFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type UpdateHelpSupportDocMutationVariables = {
  condition?: ModelHelpSupportDocConditionInput | null,
  input: UpdateHelpSupportDocInput,
};

export type UpdateHelpSupportDocMutation = {
  updateHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type UpdateInspectionReportMutationVariables = {
  condition?: ModelInspectionReportConditionInput | null,
  input: UpdateInspectionReportInput,
};

export type UpdateInspectionReportMutation = {
  updateInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type UpdateInvoiceMutationVariables = {
  condition?: ModelInvoiceConditionInput | null,
  input: UpdateInvoiceInput,
};

export type UpdateInvoiceMutation = {
  updateInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type UpdateLaborCategoryMutationVariables = {
  condition?: ModelLaborCategoryConditionInput | null,
  input: UpdateLaborCategoryInput,
};

export type UpdateLaborCategoryMutation = {
  updateLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLaborRateMutationVariables = {
  condition?: ModelLaborRateConditionInput | null,
  input: UpdateLaborRateInput,
};

export type UpdateLaborRateMutation = {
  updateLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type UpdateLibraryPlanTemplateMutationVariables = {
  condition?: ModelLibraryPlanTemplateConditionInput | null,
  input: UpdateLibraryPlanTemplateInput,
};

export type UpdateLibraryPlanTemplateMutation = {
  updateLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type UpdateLibraryTopicTemplateMutationVariables = {
  condition?: ModelLibraryTopicTemplateConditionInput | null,
  input: UpdateLibraryTopicTemplateInput,
};

export type UpdateLibraryTopicTemplateMutation = {
  updateLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type UpdateLocationMutationVariables = {
  condition?: ModelLocationConditionInput | null,
  input: UpdateLocationInput,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type UpdateModuleSubscriptionMutationVariables = {
  condition?: ModelModuleSubscriptionConditionInput | null,
  input: UpdateModuleSubscriptionInput,
};

export type UpdateModuleSubscriptionMutation = {
  updateModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type UpdatePMConfigurationMutationVariables = {
  condition?: ModelPMConfigurationConditionInput | null,
  input: UpdatePMConfigurationInput,
};

export type UpdatePMConfigurationMutation = {
  updatePMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type UpdatePMModuleContentMutationVariables = {
  condition?: ModelPMModuleContentConditionInput | null,
  input: UpdatePMModuleContentInput,
};

export type UpdatePMModuleContentMutation = {
  updatePMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type UpdatePMNotificationSettingMutationVariables = {
  condition?: ModelPMNotificationSettingConditionInput | null,
  input: UpdatePMNotificationSettingInput,
};

export type UpdatePMNotificationSettingMutation = {
  updatePMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePMPartsAndProcedureMutationVariables = {
  condition?: ModelPMPartsAndProcedureConditionInput | null,
  input: UpdatePMPartsAndProcedureInput,
};

export type UpdatePMPartsAndProcedureMutation = {
  updatePMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type UpdatePMReportMutationVariables = {
  condition?: ModelPMReportConditionInput | null,
  input: UpdatePMReportInput,
};

export type UpdatePMReportMutation = {
  updatePMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type UpdatePMServiceLevelMutationVariables = {
  condition?: ModelPMServiceLevelConditionInput | null,
  input: UpdatePMServiceLevelInput,
};

export type UpdatePMServiceLevelMutation = {
  updatePMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type UpdateRegionalDivisionMutationVariables = {
  condition?: ModelRegionalDivisionConditionInput | null,
  input: UpdateRegionalDivisionInput,
};

export type UpdateRegionalDivisionMutation = {
  updateRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: UpdateReportInput,
};

export type UpdateReportMutation = {
  updateReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type UpdateReportAnswerMutationVariables = {
  condition?: ModelReportAnswerConditionInput | null,
  input: UpdateReportAnswerInput,
};

export type UpdateReportAnswerMutation = {
  updateReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type UpdateResourceLibraryMutationVariables = {
  condition?: ModelResourceLibraryConditionInput | null,
  input: UpdateResourceLibraryInput,
};

export type UpdateResourceLibraryMutation = {
  updateResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateSavedReportConfigurationMutationVariables = {
  condition?: ModelSavedReportConfigurationConditionInput | null,
  input: UpdateSavedReportConfigurationInput,
};

export type UpdateSavedReportConfigurationMutation = {
  updateSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type UpdateSensitiveUserInfoMutationVariables = {
  condition?: ModelSensitiveUserInfoConditionInput | null,
  input: UpdateSensitiveUserInfoInput,
};

export type UpdateSensitiveUserInfoMutation = {
  updateSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateShiftReportMutationVariables = {
  condition?: ModelShiftReportConditionInput | null,
  input: UpdateShiftReportInput,
};

export type UpdateShiftReportMutation = {
  updateShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type UpdateSingleUnitMutationVariables = {
  condition?: ModelSingleUnitConditionInput | null,
  input: UpdateSingleUnitInput,
};

export type UpdateSingleUnitMutation = {
  updateSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type UpdateSkillAssignmentMutationVariables = {
  condition?: ModelSkillAssignmentConditionInput | null,
  input: UpdateSkillAssignmentInput,
};

export type UpdateSkillAssignmentMutation = {
  updateSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateSkillCategoryMutationVariables = {
  condition?: ModelSkillCategoryConditionInput | null,
  input: UpdateSkillCategoryInput,
};

export type UpdateSkillCategoryMutation = {
  updateSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateSkillLevelMutationVariables = {
  condition?: ModelSkillLevelConditionInput | null,
  input: UpdateSkillLevelInput,
};

export type UpdateSkillLevelMutation = {
  updateSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type UpdateSkillTaskMutationVariables = {
  condition?: ModelSkillTaskConditionInput | null,
  input: UpdateSkillTaskInput,
};

export type UpdateSkillTaskMutation = {
  updateSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateSubCategoryMutationVariables = {
  condition?: ModelSubCategoryConditionInput | null,
  input: UpdateSubCategoryInput,
};

export type UpdateSubCategoryMutation = {
  updateSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateTireMutationVariables = {
  condition?: ModelTireConditionInput | null,
  input: UpdateTireInput,
};

export type UpdateTireMutation = {
  updateTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateTireReportMutationVariables = {
  condition?: ModelTireReportConditionInput | null,
  input: UpdateTireReportInput,
};

export type UpdateTireReportMutation = {
  updateTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type UpdateTrainingAffidavitMutationVariables = {
  condition?: ModelTrainingAffidavitConditionInput | null,
  input: UpdateTrainingAffidavitInput,
};

export type UpdateTrainingAffidavitMutation = {
  updateTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateTrainingCompletionMutationVariables = {
  condition?: ModelTrainingCompletionConditionInput | null,
  input: UpdateTrainingCompletionInput,
};

export type UpdateTrainingCompletionMutation = {
  updateTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateTrainingEnrollmentMutationVariables = {
  condition?: ModelTrainingEnrollmentConditionInput | null,
  input: UpdateTrainingEnrollmentInput,
};

export type UpdateTrainingEnrollmentMutation = {
  updateTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateTrainingPlanMutationVariables = {
  condition?: ModelTrainingPlanConditionInput | null,
  input: UpdateTrainingPlanInput,
};

export type UpdateTrainingPlanMutation = {
  updateTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type UpdateTrainingQuizResponseMutationVariables = {
  condition?: ModelTrainingQuizResponseConditionInput | null,
  input: UpdateTrainingQuizResponseInput,
};

export type UpdateTrainingQuizResponseMutation = {
  updateTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateTrainingScheduleMutationVariables = {
  condition?: ModelTrainingScheduleConditionInput | null,
  input: UpdateTrainingScheduleInput,
};

export type UpdateTrainingScheduleMutation = {
  updateTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type UpdateTrainingTopicMutationVariables = {
  condition?: ModelTrainingTopicConditionInput | null,
  input: UpdateTrainingTopicInput,
};

export type UpdateTrainingTopicMutation = {
  updateTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type UpdateUnitExpenseBudgetMutationVariables = {
  condition?: ModelUnitExpenseBudgetConditionInput | null,
  input: UpdateUnitExpenseBudgetInput,
};

export type UpdateUnitExpenseBudgetMutation = {
  updateUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: UpdateUserInput,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type UpdateUserFileMutationVariables = {
  condition?: ModelUserFileConditionInput | null,
  input: UpdateUserFileInput,
};

export type UpdateUserFileMutation = {
  updateUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type UpdateUserReportFavoriteMutationVariables = {
  condition?: ModelUserReportFavoriteConditionInput | null,
  input: UpdateUserReportFavoriteInput,
};

export type UpdateUserReportFavoriteMutation = {
  updateUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type UpdateUserSkillReportMutationVariables = {
  condition?: ModelUserSkillReportConditionInput | null,
  input: UpdateUserSkillReportInput,
};

export type UpdateUserSkillReportMutation = {
  updateUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type UpdateVendorListMutationVariables = {
  condition?: ModelVendorListConditionInput | null,
  input: UpdateVendorListInput,
};

export type UpdateVendorListMutation = {
  updateVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateVideoMutationVariables = {
  condition?: ModelVideoConditionInput | null,
  input: UpdateVideoInput,
};

export type UpdateVideoMutation = {
  updateVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnCreateArchivedDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionArchivedDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnCreateArchivedDiscrepancySubscription = {
  onCreateArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAuditLogSubscriptionVariables = {
  filter?: ModelSubscriptionAuditLogFilterInput | null,
};

export type OnCreateAuditLogSubscription = {
  onCreateAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type OnCreateAxleBlueprintSubscriptionVariables = {
  filter?: ModelSubscriptionAxleBlueprintFilterInput | null,
  owner?: string | null,
};

export type OnCreateAxleBlueprintSubscription = {
  onCreateAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateBillingRateSubscriptionVariables = {
  filter?: ModelSubscriptionBillingRateFilterInput | null,
  owner?: string | null,
};

export type OnCreateBillingRateSubscription = {
  onCreateBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateBusinessAdminSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessAdminFilterInput | null,
  owner?: string | null,
};

export type OnCreateBusinessAdminSubscription = {
  onCreateBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type OnCreateChangeLogEntrySubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogEntryFilterInput | null,
  owner?: string | null,
};

export type OnCreateChangeLogEntrySubscription = {
  onCreateChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateClassificationSubscriptionVariables = {
  filter?: ModelSubscriptionClassificationFilterInput | null,
  owner?: string | null,
};

export type OnCreateClassificationSubscription = {
  onCreateClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanySubscriptionVariables = {
  filter?: ModelSubscriptionCompanyFilterInput | null,
};

export type OnCreateCompanySubscription = {
  onCreateCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanyNoteSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyNoteFilterInput | null,
  owner?: string | null,
};

export type OnCreateCompanyNoteSubscription = {
  onCreateCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanyOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyOwnerFilterInput | null,
  owner?: string | null,
};

export type OnCreateCompanyOwnerSubscription = {
  onCreateCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanyResourceSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyResourceFilterInput | null,
  owner?: string | null,
};

export type OnCreateCompanyResourceSubscription = {
  onCreateCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type OnCreateDOTInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionDOTInspectionReportFilterInput | null,
};

export type OnCreateDOTInspectionReportSubscription = {
  onCreateDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnCreateDailyServiceReportSubscriptionVariables = {
  filter?: ModelSubscriptionDailyServiceReportFilterInput | null,
};

export type OnCreateDailyServiceReportSubscription = {
  onCreateDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnCreateDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnCreateDiscrepancySubscription = {
  onCreateDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentFilterInput | null,
  owner?: string | null,
};

export type OnCreateDocumentSubscription = {
  onCreateDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentFilterInput | null,
};

export type OnCreateEquipmentSubscription = {
  onCreateEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateEquipmentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentCategoryFilterInput | null,
};

export type OnCreateEquipmentCategorySubscription = {
  onCreateEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type OnCreateErrorsSubscriptionVariables = {
  filter?: ModelSubscriptionErrorsFilterInput | null,
};

export type OnCreateErrorsSubscription = {
  onCreateErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type OnCreateExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
  owner?: string | null,
};

export type OnCreateExpenseCategorySubscription = {
  onCreateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateExpenseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseRecordFilterInput | null,
  owner?: string | null,
};

export type OnCreateExpenseRecordSubscription = {
  onCreateExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type OnCreateFormSubscriptionVariables = {
  filter?: ModelSubscriptionFormFilterInput | null,
  owner?: string | null,
};

export type OnCreateFormSubscription = {
  onCreateForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateFormTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreateFormTemplateSubscription = {
  onCreateFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFormTemplateGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateGroupFilterInput | null,
  owner?: string | null,
};

export type OnCreateFormTemplateGroupSubscription = {
  onCreateFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnCreateHelpSupportDocSubscriptionVariables = {
  filter?: ModelSubscriptionHelpSupportDocFilterInput | null,
  owner?: string | null,
};

export type OnCreateHelpSupportDocSubscription = {
  onCreateHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type OnCreateInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionReportFilterInput | null,
};

export type OnCreateInspectionReportSubscription = {
  onCreateInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnCreateInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
  owner?: string | null,
};

export type OnCreateInvoiceSubscription = {
  onCreateInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLaborCategorySubscriptionVariables = {
  filter?: ModelSubscriptionLaborCategoryFilterInput | null,
  owner?: string | null,
};

export type OnCreateLaborCategorySubscription = {
  onCreateLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateLaborRateSubscriptionVariables = {
  filter?: ModelSubscriptionLaborRateFilterInput | null,
  owner?: string | null,
};

export type OnCreateLaborRateSubscription = {
  onCreateLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type OnCreateLibraryPlanTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryPlanTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreateLibraryPlanTemplateSubscription = {
  onCreateLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type OnCreateLibraryTopicTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryTopicTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreateLibraryTopicTemplateSubscription = {
  onCreateLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
  owner?: string | null,
};

export type OnCreateLocationSubscription = {
  onCreateLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateModuleSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionModuleSubscriptionFilterInput | null,
  owner?: string | null,
};

export type OnCreateModuleSubscriptionSubscription = {
  onCreateModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePMConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionPMConfigurationFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMConfigurationSubscription = {
  onCreatePMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePMModuleContentSubscriptionVariables = {
  filter?: ModelSubscriptionPMModuleContentFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMModuleContentSubscription = {
  onCreatePMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePMNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionPMNotificationSettingFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMNotificationSettingSubscription = {
  onCreatePMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePMPartsAndProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionPMPartsAndProcedureFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMPartsAndProcedureSubscription = {
  onCreatePMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type OnCreatePMReportSubscriptionVariables = {
  filter?: ModelSubscriptionPMReportFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMReportSubscription = {
  onCreatePMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePMServiceLevelSubscriptionVariables = {
  filter?: ModelSubscriptionPMServiceLevelFilterInput | null,
  owner?: string | null,
};

export type OnCreatePMServiceLevelSubscription = {
  onCreatePMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type OnCreateRegionalDivisionSubscriptionVariables = {
  filter?: ModelSubscriptionRegionalDivisionFilterInput | null,
  owner?: string | null,
};

export type OnCreateRegionalDivisionSubscription = {
  onCreateRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateReportSubscriptionVariables = {
  filter?: ModelSubscriptionReportFilterInput | null,
};

export type OnCreateReportSubscription = {
  onCreateReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnCreateReportAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionReportAnswerFilterInput | null,
};

export type OnCreateReportAnswerSubscription = {
  onCreateReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type OnCreateResourceLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionResourceLibraryFilterInput | null,
  owner?: string | null,
};

export type OnCreateResourceLibrarySubscription = {
  onCreateResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateSavedReportConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionSavedReportConfigurationFilterInput | null,
};

export type OnCreateSavedReportConfigurationSubscription = {
  onCreateSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type OnCreateSensitiveUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionSensitiveUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnCreateSensitiveUserInfoSubscription = {
  onCreateSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateShiftReportSubscriptionVariables = {
  filter?: ModelSubscriptionShiftReportFilterInput | null,
};

export type OnCreateShiftReportSubscription = {
  onCreateShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnCreateSingleUnitSubscriptionVariables = {
  filter?: ModelSubscriptionSingleUnitFilterInput | null,
};

export type OnCreateSingleUnitSubscription = {
  onCreateSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type OnCreateSkillAssignmentSubscriptionVariables = {
  filter?: ModelSubscriptionSkillAssignmentFilterInput | null,
  owner?: string | null,
};

export type OnCreateSkillAssignmentSubscription = {
  onCreateSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateSkillCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSkillCategoryFilterInput | null,
  owner?: string | null,
};

export type OnCreateSkillCategorySubscription = {
  onCreateSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateSkillLevelSubscriptionVariables = {
  filter?: ModelSubscriptionSkillLevelFilterInput | null,
  owner?: string | null,
};

export type OnCreateSkillLevelSubscription = {
  onCreateSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type OnCreateSkillTaskSubscriptionVariables = {
  filter?: ModelSubscriptionSkillTaskFilterInput | null,
  owner?: string | null,
};

export type OnCreateSkillTaskSubscription = {
  onCreateSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateSubCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSubCategoryFilterInput | null,
  owner?: string | null,
};

export type OnCreateSubCategorySubscription = {
  onCreateSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateTireSubscriptionVariables = {
  filter?: ModelSubscriptionTireFilterInput | null,
  owner?: string | null,
};

export type OnCreateTireSubscription = {
  onCreateTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateTireReportSubscriptionVariables = {
  filter?: ModelSubscriptionTireReportFilterInput | null,
};

export type OnCreateTireReportSubscription = {
  onCreateTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnCreateTrainingAffidavitSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingAffidavitFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingAffidavitSubscription = {
  onCreateTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateTrainingCompletionSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingCompletionFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingCompletionSubscription = {
  onCreateTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateTrainingEnrollmentSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingEnrollmentFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingEnrollmentSubscription = {
  onCreateTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateTrainingPlanSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingPlanFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingPlanSubscription = {
  onCreateTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type OnCreateTrainingQuizResponseSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingQuizResponseFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingQuizResponseSubscription = {
  onCreateTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateTrainingScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingScheduleFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingScheduleSubscription = {
  onCreateTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTrainingTopicSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingTopicFilterInput | null,
  owner?: string | null,
};

export type OnCreateTrainingTopicSubscription = {
  onCreateTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUnitExpenseBudgetSubscriptionVariables = {
  filter?: ModelSubscriptionUnitExpenseBudgetFilterInput | null,
  owner?: string | null,
};

export type OnCreateUnitExpenseBudgetSubscription = {
  onCreateUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type OnCreateUserFileSubscriptionVariables = {
  filter?: ModelSubscriptionUserFileFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserFileSubscription = {
  onCreateUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type OnCreateUserReportFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionUserReportFavoriteFilterInput | null,
};

export type OnCreateUserReportFavoriteSubscription = {
  onCreateUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnCreateUserSkillReportSubscriptionVariables = {
  filter?: ModelSubscriptionUserSkillReportFilterInput | null,
};

export type OnCreateUserSkillReportSubscription = {
  onCreateUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnCreateVendorListSubscriptionVariables = {
  filter?: ModelSubscriptionVendorListFilterInput | null,
  owner?: string | null,
};

export type OnCreateVendorListSubscription = {
  onCreateVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateVideoSubscriptionVariables = {
  filter?: ModelSubscriptionVideoFilterInput | null,
  owner?: string | null,
};

export type OnCreateVideoSubscription = {
  onCreateVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteArchivedDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionArchivedDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnDeleteArchivedDiscrepancySubscription = {
  onDeleteArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAuditLogSubscriptionVariables = {
  filter?: ModelSubscriptionAuditLogFilterInput | null,
};

export type OnDeleteAuditLogSubscription = {
  onDeleteAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type OnDeleteAxleBlueprintSubscriptionVariables = {
  filter?: ModelSubscriptionAxleBlueprintFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAxleBlueprintSubscription = {
  onDeleteAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteBillingRateSubscriptionVariables = {
  filter?: ModelSubscriptionBillingRateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteBillingRateSubscription = {
  onDeleteBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteBusinessAdminSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessAdminFilterInput | null,
  owner?: string | null,
};

export type OnDeleteBusinessAdminSubscription = {
  onDeleteBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteChangeLogEntrySubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogEntryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteChangeLogEntrySubscription = {
  onDeleteChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteClassificationSubscriptionVariables = {
  filter?: ModelSubscriptionClassificationFilterInput | null,
  owner?: string | null,
};

export type OnDeleteClassificationSubscription = {
  onDeleteClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteCompanySubscriptionVariables = {
  filter?: ModelSubscriptionCompanyFilterInput | null,
};

export type OnDeleteCompanySubscription = {
  onDeleteCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteCompanyNoteSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyNoteFilterInput | null,
  owner?: string | null,
};

export type OnDeleteCompanyNoteSubscription = {
  onDeleteCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteCompanyOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyOwnerFilterInput | null,
  owner?: string | null,
};

export type OnDeleteCompanyOwnerSubscription = {
  onDeleteCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteCompanyResourceSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyResourceFilterInput | null,
  owner?: string | null,
};

export type OnDeleteCompanyResourceSubscription = {
  onDeleteCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type OnDeleteDOTInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionDOTInspectionReportFilterInput | null,
};

export type OnDeleteDOTInspectionReportSubscription = {
  onDeleteDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnDeleteDailyServiceReportSubscriptionVariables = {
  filter?: ModelSubscriptionDailyServiceReportFilterInput | null,
};

export type OnDeleteDailyServiceReportSubscription = {
  onDeleteDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnDeleteDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDiscrepancySubscription = {
  onDeleteDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDocumentSubscription = {
  onDeleteDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentFilterInput | null,
};

export type OnDeleteEquipmentSubscription = {
  onDeleteEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteEquipmentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentCategoryFilterInput | null,
};

export type OnDeleteEquipmentCategorySubscription = {
  onDeleteEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteErrorsSubscriptionVariables = {
  filter?: ModelSubscriptionErrorsFilterInput | null,
};

export type OnDeleteErrorsSubscription = {
  onDeleteErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteExpenseCategorySubscription = {
  onDeleteExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteExpenseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseRecordFilterInput | null,
  owner?: string | null,
};

export type OnDeleteExpenseRecordSubscription = {
  onDeleteExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type OnDeleteFormSubscriptionVariables = {
  filter?: ModelSubscriptionFormFilterInput | null,
  owner?: string | null,
};

export type OnDeleteFormSubscription = {
  onDeleteForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteFormTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteFormTemplateSubscription = {
  onDeleteFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFormTemplateGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateGroupFilterInput | null,
  owner?: string | null,
};

export type OnDeleteFormTemplateGroupSubscription = {
  onDeleteFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteHelpSupportDocSubscriptionVariables = {
  filter?: ModelSubscriptionHelpSupportDocFilterInput | null,
  owner?: string | null,
};

export type OnDeleteHelpSupportDocSubscription = {
  onDeleteHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type OnDeleteInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionReportFilterInput | null,
};

export type OnDeleteInspectionReportSubscription = {
  onDeleteInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnDeleteInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
  owner?: string | null,
};

export type OnDeleteInvoiceSubscription = {
  onDeleteInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLaborCategorySubscriptionVariables = {
  filter?: ModelSubscriptionLaborCategoryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLaborCategorySubscription = {
  onDeleteLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteLaborRateSubscriptionVariables = {
  filter?: ModelSubscriptionLaborRateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLaborRateSubscription = {
  onDeleteLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type OnDeleteLibraryPlanTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryPlanTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLibraryPlanTemplateSubscription = {
  onDeleteLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type OnDeleteLibraryTopicTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryTopicTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLibraryTopicTemplateSubscription = {
  onDeleteLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteModuleSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionModuleSubscriptionFilterInput | null,
  owner?: string | null,
};

export type OnDeleteModuleSubscriptionSubscription = {
  onDeleteModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePMConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionPMConfigurationFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMConfigurationSubscription = {
  onDeletePMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePMModuleContentSubscriptionVariables = {
  filter?: ModelSubscriptionPMModuleContentFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMModuleContentSubscription = {
  onDeletePMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePMNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionPMNotificationSettingFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMNotificationSettingSubscription = {
  onDeletePMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePMPartsAndProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionPMPartsAndProcedureFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMPartsAndProcedureSubscription = {
  onDeletePMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type OnDeletePMReportSubscriptionVariables = {
  filter?: ModelSubscriptionPMReportFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMReportSubscription = {
  onDeletePMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePMServiceLevelSubscriptionVariables = {
  filter?: ModelSubscriptionPMServiceLevelFilterInput | null,
  owner?: string | null,
};

export type OnDeletePMServiceLevelSubscription = {
  onDeletePMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type OnDeleteRegionalDivisionSubscriptionVariables = {
  filter?: ModelSubscriptionRegionalDivisionFilterInput | null,
  owner?: string | null,
};

export type OnDeleteRegionalDivisionSubscription = {
  onDeleteRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteReportSubscriptionVariables = {
  filter?: ModelSubscriptionReportFilterInput | null,
};

export type OnDeleteReportSubscription = {
  onDeleteReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnDeleteReportAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionReportAnswerFilterInput | null,
};

export type OnDeleteReportAnswerSubscription = {
  onDeleteReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type OnDeleteResourceLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionResourceLibraryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteResourceLibrarySubscription = {
  onDeleteResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteSavedReportConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionSavedReportConfigurationFilterInput | null,
};

export type OnDeleteSavedReportConfigurationSubscription = {
  onDeleteSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type OnDeleteSensitiveUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionSensitiveUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSensitiveUserInfoSubscription = {
  onDeleteSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteShiftReportSubscriptionVariables = {
  filter?: ModelSubscriptionShiftReportFilterInput | null,
};

export type OnDeleteShiftReportSubscription = {
  onDeleteShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnDeleteSingleUnitSubscriptionVariables = {
  filter?: ModelSubscriptionSingleUnitFilterInput | null,
};

export type OnDeleteSingleUnitSubscription = {
  onDeleteSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type OnDeleteSkillAssignmentSubscriptionVariables = {
  filter?: ModelSubscriptionSkillAssignmentFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSkillAssignmentSubscription = {
  onDeleteSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteSkillCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSkillCategoryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSkillCategorySubscription = {
  onDeleteSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteSkillLevelSubscriptionVariables = {
  filter?: ModelSubscriptionSkillLevelFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSkillLevelSubscription = {
  onDeleteSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type OnDeleteSkillTaskSubscriptionVariables = {
  filter?: ModelSubscriptionSkillTaskFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSkillTaskSubscription = {
  onDeleteSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteSubCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSubCategoryFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSubCategorySubscription = {
  onDeleteSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteTireSubscriptionVariables = {
  filter?: ModelSubscriptionTireFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTireSubscription = {
  onDeleteTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteTireReportSubscriptionVariables = {
  filter?: ModelSubscriptionTireReportFilterInput | null,
};

export type OnDeleteTireReportSubscription = {
  onDeleteTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnDeleteTrainingAffidavitSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingAffidavitFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingAffidavitSubscription = {
  onDeleteTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteTrainingCompletionSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingCompletionFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingCompletionSubscription = {
  onDeleteTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteTrainingEnrollmentSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingEnrollmentFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingEnrollmentSubscription = {
  onDeleteTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteTrainingPlanSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingPlanFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingPlanSubscription = {
  onDeleteTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type OnDeleteTrainingQuizResponseSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingQuizResponseFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingQuizResponseSubscription = {
  onDeleteTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteTrainingScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingScheduleFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingScheduleSubscription = {
  onDeleteTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTrainingTopicSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingTopicFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTrainingTopicSubscription = {
  onDeleteTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUnitExpenseBudgetSubscriptionVariables = {
  filter?: ModelSubscriptionUnitExpenseBudgetFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUnitExpenseBudgetSubscription = {
  onDeleteUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type OnDeleteUserFileSubscriptionVariables = {
  filter?: ModelSubscriptionUserFileFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserFileSubscription = {
  onDeleteUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type OnDeleteUserReportFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionUserReportFavoriteFilterInput | null,
};

export type OnDeleteUserReportFavoriteSubscription = {
  onDeleteUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnDeleteUserSkillReportSubscriptionVariables = {
  filter?: ModelSubscriptionUserSkillReportFilterInput | null,
};

export type OnDeleteUserSkillReportSubscription = {
  onDeleteUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnDeleteVendorListSubscriptionVariables = {
  filter?: ModelSubscriptionVendorListFilterInput | null,
  owner?: string | null,
};

export type OnDeleteVendorListSubscription = {
  onDeleteVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteVideoSubscriptionVariables = {
  filter?: ModelSubscriptionVideoFilterInput | null,
  owner?: string | null,
};

export type OnDeleteVideoSubscription = {
  onDeleteVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateArchivedDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionArchivedDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnUpdateArchivedDiscrepancySubscription = {
  onUpdateArchivedDiscrepancy?:  {
    __typename: "ArchivedDiscrepancy",
    archivedDate?: string | null,
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAuditLogSubscriptionVariables = {
  filter?: ModelSubscriptionAuditLogFilterInput | null,
};

export type OnUpdateAuditLogSubscription = {
  onUpdateAuditLog?:  {
    __typename: "AuditLog",
    action: string,
    companyId: string,
    createdAt?: string | null,
    details?: string | null,
    id: string,
    resourceId: string,
    resourceName?: string | null,
    resourceType: string,
    ttl?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
  } | null,
};

export type OnUpdateAxleBlueprintSubscriptionVariables = {
  filter?: ModelSubscriptionAxleBlueprintFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAxleBlueprintSubscription = {
  onUpdateAxleBlueprint?:  {
    __typename: "AxleBlueprint",
    axles: string,
    centerlineLength: number,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateBillingRateSubscriptionVariables = {
  filter?: ModelSubscriptionBillingRateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateBillingRateSubscription = {
  onUpdateBillingRate?:  {
    __typename: "BillingRate",
    companyId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    ratePerCostTracking?: number | null,
    ratePerEquipment?: number | null,
    ratePerPM?: number | null,
    ratePerSafetyEnrollment?: number | null,
    ratePerSkillQualification?: number | null,
    ratePerTireMaint?: number | null,
    ratePerUser?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateBusinessAdminSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessAdminFilterInput | null,
  owner?: string | null,
};

export type OnUpdateBusinessAdminSubscription = {
  onUpdateBusinessAdmin?:  {
    __typename: "BusinessAdmin",
    cognitoId: string,
    createdAt: string,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    role: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateChangeLogEntrySubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogEntryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateChangeLogEntrySubscription = {
  onUpdateChangeLogEntry?:  {
    __typename: "ChangeLogEntry",
    changedBy: string,
    changedByName: string,
    companyId: string,
    createdAt?: string | null,
    description: string,
    fieldName: string,
    id: string,
    newValue?: string | null,
    oldValue?: string | null,
    owner?: string | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateClassificationSubscriptionVariables = {
  filter?: ModelSubscriptionClassificationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateClassificationSubscription = {
  onUpdateClassification?:  {
    __typename: "Classification",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanySubscriptionVariables = {
  filter?: ModelSubscriptionCompanyFilterInput | null,
};

export type OnUpdateCompanySubscription = {
  onUpdateCompany?:  {
    __typename: "Company",
    accountNumber?: string | null,
    accountOrigin?: string | null,
    accountStatus?: string | null,
    addOnGracePeriodEndDate?: string | null,
    archived?: boolean | null,
    assignedRep?: string | null,
    billingAnchorDay?: number | null,
    billingContactAddress?: string | null,
    billingContactEmail?: string | null,
    billingContactName?: string | null,
    billingContactPhone?: string | null,
    billingCycle?: string | null,
    businessType?: string | null,
    cancelEffectiveDate?: string | null,
    cancelReason?: string | null,
    cancelReasonNote?: string | null,
    cancelRequestedAt?: string | null,
    companyOwnerId?: string | null,
    coreMonthlyRate?: number | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    dataRetentionEndDate?: string | null,
    description?: string | null,
    gracePeriodEndDate?: string | null,
    id: string,
    industryNAICS?: string | null,
    industrySIC?: string | null,
    initialContactDate?: string | null,
    initialStarterPackageEnrollment?: boolean | null,
    logo?: string | null,
    maxNumberEquipment: number,
    maxNumberUsers: number,
    name: string,
    nextBillingDate?: string | null,
    notes?: string | null,
    numberOfUsers?: number | null,
    paidStartDate?: string | null,
    paymentFailedAt?: string | null,
    paymentMethod?: string | null,
    pmModuleEnrollment?: boolean | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    primaryContactPhone?: string | null,
    primaryContactPosition?: string | null,
    primaryLocation?: string | null,
    referredBy?: string | null,
    retryAttempts?: number | null,
    safetyComplianceStandard?: string | null,
    secondaryContactEmail?: string | null,
    secondaryContactName?: string | null,
    secondaryContactPhone?: string | null,
    secondaryContactPosition?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    starterPackage?: string | null,
    status?: string | null,
    subscriptionExpiration: string,
    subscriptionType: string,
    tiresModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trialEndDate?: string | null,
    trialStartDate?: string | null,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanyNoteSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyNoteFilterInput | null,
  owner?: string | null,
};

export type OnUpdateCompanyNoteSubscription = {
  onUpdateCompanyNote?:  {
    __typename: "CompanyNote",
    authorName: string,
    companyId: string,
    content: string,
    createdAt?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanyOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyOwnerFilterInput | null,
  owner?: string | null,
};

export type OnUpdateCompanyOwnerSubscription = {
  onUpdateCompanyOwner?:  {
    __typename: "CompanyOwner",
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    createdAt: string,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    email: string,
    id: string,
    name: string,
    owner?: string | null,
    permissions?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    role?: string | null,
    siteAdmin: boolean,
    subscriptionType: string,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanyResourceSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyResourceFilterInput | null,
  owner?: string | null,
};

export type OnUpdateCompanyResourceSubscription = {
  onUpdateCompanyResource?:  {
    __typename: "CompanyResource",
    category: string,
    companyId: string,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description?: string | null,
    fileType: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    title: string,
    trainingTopicId?: string | null,
    updatedAt: string,
    uploadedByUserId?: string | null,
    uploadedByUserName?: string | null,
  } | null,
};

export type OnUpdateDOTInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionDOTInspectionReportFilterInput | null,
};

export type OnUpdateDOTInspectionReportSubscription = {
  onUpdateDOTInspectionReport?:  {
    __typename: "DOTInspectionReport",
    companyId: string,
    complianceStatus?: string | null,
    createdAt?: string | null,
    dotInspectionType?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    inspectorCertificationId?: string | null,
    locationId?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    regulatoryStandard?: string | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    vehicleLicensePlate?: string | null,
    vehicleVIN?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnUpdateDailyServiceReportSubscriptionVariables = {
  filter?: ModelSubscriptionDailyServiceReportFilterInput | null,
};

export type OnUpdateDailyServiceReportSubscription = {
  onUpdateDailyServiceReport?:  {
    __typename: "DailyServiceReport",
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogFormId?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtService?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtService?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnUpdateDiscrepancySubscriptionVariables = {
  filter?: ModelSubscriptionDiscrepancyFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDiscrepancySubscription = {
  onUpdateDiscrepancy?:  {
    __typename: "Discrepancy",
    companyId: string,
    createdAt?: string | null,
    downReason?: string | null,
    equipmentId: string,
    equipmentName: string,
    id: string,
    initialStatus?: string | null,
    log?: string | null,
    owner?: string | null,
    promptDescription?: string | null,
    promptLabel?: string | null,
    promptTitle?: string | null,
    questionIndex?: number | null,
    reportId?: string | null,
    status: string,
    unitId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDocumentSubscription = {
  onUpdateDocument?:  {
    __typename: "Document",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentFilterInput | null,
};

export type OnUpdateEquipmentSubscription = {
  onUpdateEquipment?:  {
    __typename: "Equipment",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    units?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateEquipmentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionEquipmentCategoryFilterInput | null,
};

export type OnUpdateEquipmentCategorySubscription = {
  onUpdateEquipmentCategory?:  {
    __typename: "EquipmentCategory",
    companyId: string,
    createdAt: string,
    formId: string,
    id: string,
    image?: string | null,
    name: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateErrorsSubscriptionVariables = {
  filter?: ModelSubscriptionErrorsFilterInput | null,
};

export type OnUpdateErrorsSubscription = {
  onUpdateErrors?:  {
    __typename: "Errors",
    createdAt: string,
    errors: string,
    id: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateExpenseCategorySubscription = {
  onUpdateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    startingBalance?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateExpenseRecordSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseRecordFilterInput | null,
  owner?: string | null,
};

export type OnUpdateExpenseRecordSubscription = {
  onUpdateExpenseRecord?:  {
    __typename: "ExpenseRecord",
    attachments?: Array< string | null > | null,
    companyId: string,
    createdAt: string,
    dateOfInput: string,
    dateOfService: string,
    equipmentCategoryId?: string | null,
    expenseCategories?: string | null,
    id: string,
    invoiceNumber?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    pmExpense?: number | null,
    pmServiceLevelId?: string | null,
    pmServiceLevelName?: string | null,
    totalExpense: number,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
    workDescription?: string | null,
  } | null,
};

export type OnUpdateFormSubscriptionVariables = {
  filter?: ModelSubscriptionFormFilterInput | null,
  owner?: string | null,
};

export type OnUpdateFormSubscription = {
  onUpdateForm?:  {
    __typename: "Form",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt: string,
    dailyServiceLogForm?: boolean | null,
    equipmentType?: string | null,
    formData: string,
    formType?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    name: string,
    noMachineHours?: boolean | null,
    noUMCounter?: boolean | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    status?: string | null,
    umCounterLabel?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateFormTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateFormTemplateSubscription = {
  onUpdateFormTemplate?:  {
    __typename: "FormTemplate",
    createdAt: string,
    createdByCompanyOwnerId?: string | null,
    dailyServiceLogForm?: boolean | null,
    formTemplateGroupID?: string | null,
    id: string,
    inspectionForm?: boolean | null,
    originalCompanyId?: string | null,
    owner?: string | null,
    pmServiceScheduleForm?: boolean | null,
    templateData: string,
    templateName: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFormTemplateGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFormTemplateGroupFilterInput | null,
  owner?: string | null,
};

export type OnUpdateFormTemplateGroupSubscription = {
  onUpdateFormTemplateGroup?:  {
    __typename: "FormTemplateGroup",
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateHelpSupportDocSubscriptionVariables = {
  filter?: ModelSubscriptionHelpSupportDocFilterInput | null,
  owner?: string | null,
};

export type OnUpdateHelpSupportDocSubscription = {
  onUpdateHelpSupportDoc?:  {
    __typename: "HelpSupportDoc",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description?: string | null,
    docType: string,
    id: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    title: string,
    updatedAt: string,
    visibility: string,
  } | null,
};

export type OnUpdateInspectionReportSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionReportFilterInput | null,
};

export type OnUpdateInspectionReportSubscription = {
  onUpdateInspectionReport?:  {
    __typename: "InspectionReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    machineHoursAtInspection?: number | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    umCounterAtInspection?: number | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnUpdateInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
  owner?: string | null,
};

export type OnUpdateInvoiceSubscription = {
  onUpdateInvoice?:  {
    __typename: "Invoice",
    amount: number,
    companyId: string,
    createdAt: string,
    date: string,
    description: string,
    id: string,
    invoiceNumber: string,
    lineItems?: string | null,
    owner?: string | null,
    pdfUrl?: string | null,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLaborCategorySubscriptionVariables = {
  filter?: ModelSubscriptionLaborCategoryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLaborCategorySubscription = {
  onUpdateLaborCategory?:  {
    __typename: "LaborCategory",
    companyId: string,
    createdAt: string,
    id: string,
    isActive: boolean,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateLaborRateSubscriptionVariables = {
  filter?: ModelSubscriptionLaborRateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLaborRateSubscription = {
  onUpdateLaborRate?:  {
    __typename: "LaborRate",
    categoryId: string,
    createdAt: string,
    effectiveDate: string,
    id: string,
    overtimeRate: number,
    owner?: string | null,
    standardRate: number,
    updatedAt: string,
  } | null,
};

export type OnUpdateLibraryPlanTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryPlanTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLibraryPlanTemplateSubscription = {
  onUpdateLibraryPlanTemplate?:  {
    __typename: "LibraryPlanTemplate",
    categories: string,
    categoryCount?: number | null,
    createdAt: string,
    createdByAdminId: string,
    createdByAdminName?: string | null,
    cycleDuration: number,
    description?: string | null,
    governingStandard: string,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    status: string,
    topicCount?: number | null,
    updatedAt: string,
    workingDays: Array< number | null >,
  } | null,
};

export type OnUpdateLibraryTopicTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionLibraryTopicTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLibraryTopicTemplateSubscription = {
  onUpdateLibraryTopicTemplate?:  {
    __typename: "LibraryTopicTemplate",
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    createdByAdminId: string,
    description: string,
    id: string,
    owner?: string | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLocationSubscription = {
  onUpdateLocation?:  {
    __typename: "Location",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    regionalDivisionId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateModuleSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionModuleSubscriptionFilterInput | null,
  owner?: string | null,
};

export type OnUpdateModuleSubscriptionSubscription = {
  onUpdateModuleSubscription?:  {
    __typename: "ModuleSubscription",
    activatedAt: string,
    cancelRequestedAt?: string | null,
    companyId: string,
    createdAt: string,
    effectiveEndDate?: string | null,
    id: string,
    moduleKey: string,
    monthlyRate: number,
    owner?: string | null,
    pricingModel: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePMConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionPMConfigurationFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMConfigurationSubscription = {
  onUpdatePMConfiguration?:  {
    __typename: "PMConfiguration",
    companyId: string,
    createdAt: string,
    dueSoonPercentage?: number | null,
    id: string,
    laborCategoryId?: string | null,
    owner?: string | null,
    unitId: string,
    unitOfMeasure: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePMModuleContentSubscriptionVariables = {
  filter?: ModelSubscriptionPMModuleContentFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMModuleContentSubscription = {
  onUpdatePMModuleContent?:  {
    __typename: "PMModuleContent",
    createdAt: string,
    id: string,
    owner?: string | null,
    pmServiceFormId: string,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePMNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionPMNotificationSettingFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMNotificationSettingSubscription = {
  onUpdatePMNotificationSetting?:  {
    __typename: "PMNotificationSetting",
    createdAt: string,
    emailThresholdUM: number,
    id: string,
    lastNotificationSent?: string | null,
    notificationFrequency: string,
    owner?: string | null,
    pmConfigurationId: string,
    recipients?: Array< string | null > | null,
    serviceLevelId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePMPartsAndProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionPMPartsAndProcedureFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMPartsAndProcedureSubscription = {
  onUpdatePMPartsAndProcedure?:  {
    __typename: "PMPartsAndProcedure",
    category?: string | null,
    companyId?: string | null,
    createdAt: string,
    createdByUserId?: string | null,
    createdByUserName?: string | null,
    id: string,
    itemName: string,
    itemType?: string | null,
    manufacturer?: string | null,
    owner?: string | null,
    partNumber?: string | null,
    pmConfigurationId?: string | null,
    pmConfigurationIds?: Array< string | null > | null,
    price?: number | null,
    quantity?: number | null,
    sortOrder?: number | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    vendorId?: string | null,
    vendorName?: string | null,
  } | null,
};

export type OnUpdatePMReportSubscriptionVariables = {
  filter?: ModelSubscriptionPMReportFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMReportSubscription = {
  onUpdatePMReport?:  {
    __typename: "PMReport",
    actualUM: number,
    companyId: string,
    createdAt?: string | null,
    id: string,
    issueDescription?: string | null,
    issueTicketCreated?: boolean | null,
    issueTicketId?: string | null,
    laborHoursOT?: number | null,
    laborHoursST?: number | null,
    laborRateOT?: number | null,
    laborRateST?: number | null,
    laborRateScheduleId?: string | null,
    laborRateScheduleName?: string | null,
    owner?: string | null,
    photos?: Array< string | null > | null,
    pmConfigurationId: string,
    reportData?: string | null,
    serviceDate: string,
    serviceLevelId: string,
    serviceLevelName?: string | null,
    signature?: string | null,
    status?: string | null,
    technicianId: string,
    technicianName?: string | null,
    totalLaborCost?: number | null,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePMServiceLevelSubscriptionVariables = {
  filter?: ModelSubscriptionPMServiceLevelFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePMServiceLevelSubscription = {
  onUpdatePMServiceLevel?:  {
    __typename: "PMServiceLevel",
    createdAt: string,
    description?: string | null,
    id: string,
    intervalValue: number,
    lastServiceDate?: string | null,
    lastServiceUM?: number | null,
    levelIdentifier: string,
    owner?: string | null,
    pmConfigurationId: string,
    pmServiceFormId?: string | null,
    serviceLevelAssignments?: string | null,
    targetUM: number,
    updatedAt: string,
  } | null,
};

export type OnUpdateRegionalDivisionSubscriptionVariables = {
  filter?: ModelSubscriptionRegionalDivisionFilterInput | null,
  owner?: string | null,
};

export type OnUpdateRegionalDivisionSubscription = {
  onUpdateRegionalDivision?:  {
    __typename: "RegionalDivision",
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateReportSubscriptionVariables = {
  filter?: ModelSubscriptionReportFilterInput | null,
};

export type OnUpdateReportSubscription = {
  onUpdateReport?:  {
    __typename: "Report",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    dailyServiceLogReport?: boolean | null,
    equipmentId: string,
    equipmentLocationId?: string | null,
    equipmentName?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnUpdateReportAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionReportAnswerFilterInput | null,
};

export type OnUpdateReportAnswerSubscription = {
  onUpdateReportAnswer?:  {
    __typename: "ReportAnswer",
    companyId: string,
    createdAt?: string | null,
    id: string,
    notes?: string | null,
    parentReportId: string,
    photos?: Array< string | null > | null,
    promptDescription?: string | null,
    promptKey: string,
    promptLabel?: string | null,
    promptTitle?: string | null,
    promptType?: string | null,
    reportType: string,
    sortOrder?: number | null,
    unitId?: string | null,
    updatedAt: string,
    value?: string | null,
  } | null,
};

export type OnUpdateResourceLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionResourceLibraryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateResourceLibrarySubscription = {
  onUpdateResourceLibrary?:  {
    __typename: "ResourceLibrary",
    companyOwnerId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateSavedReportConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionSavedReportConfigurationFilterInput | null,
};

export type OnUpdateSavedReportConfigurationSubscription = {
  onUpdateSavedReportConfiguration?:  {
    __typename: "SavedReportConfiguration",
    companyId: string,
    compareDateRangeEnd?: string | null,
    compareDateRangeStart?: string | null,
    createdAt?: string | null,
    dateRangeEnd?: string | null,
    dateRangeStart?: string | null,
    dateRangeType?: string | null,
    filtersJson?: string | null,
    groupByField?: string | null,
    id: string,
    lastRunAt?: string | null,
    metricCategory?: string | null,
    metricKey: string,
    reportName: string,
    updatedAt: string,
    userId: string,
    visualizationType?: string | null,
  } | null,
};

export type OnUpdateSensitiveUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionSensitiveUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSensitiveUserInfoSubscription = {
  onUpdateSensitiveUserInfo?:  {
    __typename: "SensitiveUserInfo",
    cognitoId?: string | null,
    companyId?: string | null,
    createdAt: string,
    dateOfBirth?: string | null,
    driversLicenseClass?: string | null,
    driversLicenseExpirationDate?: string | null,
    driversLicenseNumber?: string | null,
    driversLicenseState?: string | null,
    emergencyContactName?: string | null,
    emergencyContactPhoneNumber?: string | null,
    emergencyContactRelationship?: string | null,
    id: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateShiftReportSubscriptionVariables = {
  filter?: ModelSubscriptionShiftReportFilterInput | null,
};

export type OnUpdateShiftReportSubscription = {
  onUpdateShiftReport?:  {
    __typename: "ShiftReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    locationId?: string | null,
    locationName?: string | null,
    okCount?: number | null,
    photos?: Array< string | null > | null,
    responseData?: string | null,
    shiftType?: string | null,
    signature?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnUpdateSingleUnitSubscriptionVariables = {
  filter?: ModelSubscriptionSingleUnitFilterInput | null,
};

export type OnUpdateSingleUnitSubscription = {
  onUpdateSingleUnit?:  {
    __typename: "SingleUnit",
    annualProjectedUsage?: number | null,
    aquisitionCost?: number | null,
    aquisitionDate?: string | null,
    assignedTo?: string | null,
    axleConfiguration?: string | null,
    categoryId?: string | null,
    costTrackingModuleEnrollment?: boolean | null,
    createdAt: string,
    currentMachineHours?: number | null,
    currentUMCounterValue?: number | null,
    dailyServiceLogFormId?: string | null,
    description?: string | null,
    dispositionDate?: string | null,
    dispositionReason?: string | null,
    downReason?: string | null,
    engineManufacturer?: string | null,
    engineModelNumber?: string | null,
    equipmentStatus?: boolean | null,
    extraUnitInfo?: string | null,
    id: string,
    image?: string | null,
    inputByPerson?: string | null,
    inputDate?: string | null,
    lastDailyServiceDate?: string | null,
    lastInspectionDate?: string | null,
    lastServiceHours?: number | null,
    licenseNumber?: string | null,
    locationId?: string | null,
    machineHoursAtAquisition?: number | null,
    machineUMCounterAtAquisition?: number | null,
    manufactureDate?: string | null,
    manufacturerName?: string | null,
    modelNumber?: string | null,
    name: string,
    pmModuleEnrollment?: boolean | null,
    putInServiceDate?: string | null,
    removedFromServiceDate?: string | null,
    removedFromServiceReason?: string | null,
    replacedUMCounterHistory?: string | null,
    replacedUMCounterStatus?: boolean | null,
    replacedUMCounterValue?: number | null,
    serialNumber?: string | null,
    tiresModuleEnrollment?: boolean | null,
    unitOfMeasure?: string | null,
    updatedAt: string,
    utilizationAdjustmentDays?: number | null,
  } | null,
};

export type OnUpdateSkillAssignmentSubscriptionVariables = {
  filter?: ModelSubscriptionSkillAssignmentFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSkillAssignmentSubscription = {
  onUpdateSkillAssignment?:  {
    __typename: "SkillAssignment",
    companyId: string,
    createdAt: string,
    evaluatedBy?: string | null,
    evaluatedByName?: string | null,
    evaluationDate?: string | null,
    id: string,
    owner?: string | null,
    skillLevel: string,
    subCategoryId?: string | null,
    taskId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateSkillCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSkillCategoryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSkillCategorySubscription = {
  onUpdateSkillCategory?:  {
    __typename: "SkillCategory",
    allowMachineNumber?: boolean | null,
    classificationId: string,
    companyId: string,
    createdAt: string,
    equipmentCategoryId?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateSkillLevelSubscriptionVariables = {
  filter?: ModelSubscriptionSkillLevelFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSkillLevelSubscription = {
  onUpdateSkillLevel?:  {
    __typename: "SkillLevel",
    color?: string | null,
    companyId: string,
    createdAt: string,
    description?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    sortOrder: number,
    updatedAt: string,
  } | null,
};

export type OnUpdateSkillTaskSubscriptionVariables = {
  filter?: ModelSubscriptionSkillTaskFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSkillTaskSubscription = {
  onUpdateSkillTask?:  {
    __typename: "SkillTask",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateSubCategorySubscriptionVariables = {
  filter?: ModelSubscriptionSubCategoryFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSubCategorySubscription = {
  onUpdateSubCategory?:  {
    __typename: "SubCategory",
    categoryId: string,
    companyId: string,
    createdAt: string,
    id: string,
    name: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateTireSubscriptionVariables = {
  filter?: ModelSubscriptionTireFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTireSubscription = {
  onUpdateTire?:  {
    __typename: "Tire",
    assignedAxle?: string | null,
    assignedPosition?: string | null,
    companyId: string,
    createdAt: string,
    currentTirePressure?: number | null,
    currentTreadDepth?: number | null,
    dateInstalled?: string | null,
    dateUninstalled?: string | null,
    failureReason?: string | null,
    id: string,
    inflationMedium?: string | null,
    loadRating?: number | null,
    loadRatingUnit?: string | null,
    minimumTreadDepth?: number | null,
    name?: string | null,
    owner?: string | null,
    recommendedTirePressure?: number | null,
    removedFromService?: boolean | null,
    removedFromServiceDate?: string | null,
    tireCategory?: string | null,
    tireManufacturer?: string | null,
    tireModel?: string | null,
    tireSize?: string | null,
    tireStatus?: string | null,
    treadDepthAtInstall?: number | null,
    unitId?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateTireReportSubscriptionVariables = {
  filter?: ModelSubscriptionTireReportFilterInput | null,
};

export type OnUpdateTireReportSubscription = {
  onUpdateTireReport?:  {
    __typename: "TireReport",
    alwaysTriggerEmail?: boolean | null,
    companyId: string,
    createdAt?: string | null,
    equipmentCategoryId: string,
    equipmentCategoryName?: string | null,
    equipmentLocationId?: string | null,
    id: string,
    inspectionCompleted?: string | null,
    inspectionStarted?: string | null,
    name: string,
    signature?: string | null,
    tireId?: string | null,
    unitId?: string | null,
    unitName?: string | null,
    updatedAt: string,
    userData: string,
    userId: string,
    userLocation: string,
  } | null,
};

export type OnUpdateTrainingAffidavitSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingAffidavitFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingAffidavitSubscription = {
  onUpdateTrainingAffidavit?:  {
    __typename: "TrainingAffidavit",
    adminId: string,
    affidavitDate: string,
    companyId: string,
    createdAt: string,
    id: string,
    legalText: string,
    nextDueDate: string,
    owner?: string | null,
    planId: string,
    signaturePath: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateTrainingCompletionSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingCompletionFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingCompletionSubscription = {
  onUpdateTrainingCompletion?:  {
    __typename: "TrainingCompletion",
    categoryId?: string | null,
    companyId: string,
    completionDate: string,
    createdAt: string,
    id: string,
    launched: boolean,
    markedAsViewed: boolean,
    owner?: string | null,
    planId: string,
    scheduleDate: string,
    signaturePath?: string | null,
    timeValueMinutes: number,
    topicId: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateTrainingEnrollmentSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingEnrollmentFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingEnrollmentSubscription = {
  onUpdateTrainingEnrollment?:  {
    __typename: "TrainingEnrollment",
    companyId: string,
    createdAt: string,
    enrolledDate: string,
    id: string,
    lastCompletionDate?: string | null,
    nextDueDate?: string | null,
    owner?: string | null,
    planId: string,
    status: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateTrainingPlanSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingPlanFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingPlanSubscription = {
  onUpdateTrainingPlan?:  {
    __typename: "TrainingPlan",
    categories: string,
    companyId: string,
    createdAt: string,
    cycleDuration: number,
    governingStandard: string,
    holidays?: string | null,
    id: string,
    minimumTimeRequired: number,
    name: string,
    owner?: string | null,
    startDate?: string | null,
    status: string,
    updatedAt: string,
    workingDays?: Array< number | null > | null,
  } | null,
};

export type OnUpdateTrainingQuizResponseSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingQuizResponseFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingQuizResponseSubscription = {
  onUpdateTrainingQuizResponse?:  {
    __typename: "TrainingQuizResponse",
    attemptNumber?: number | null,
    categoryId?: string | null,
    companyId: string,
    completedAt?: string | null,
    createdAt: string,
    cycleStartDate?: string | null,
    formId?: string | null,
    id: string,
    owner?: string | null,
    passed?: boolean | null,
    planId: string,
    responseData?: string | null,
    score?: number | null,
    signaturePath?: string | null,
    totalQuestions?: number | null,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateTrainingScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingScheduleFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingScheduleSubscription = {
  onUpdateTrainingSchedule?:  {
    __typename: "TrainingSchedule",
    assignedUserId?: string | null,
    categoryId?: string | null,
    companyId: string,
    createdAt: string,
    dayNumber: number,
    id: string,
    locked?: boolean | null,
    owner?: string | null,
    planId: string,
    scheduledDate: string,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTrainingTopicSubscriptionVariables = {
  filter?: ModelSubscriptionTrainingTopicFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTrainingTopicSubscription = {
  onUpdateTrainingTopic?:  {
    __typename: "TrainingTopic",
    categoryIds?: Array< string | null > | null,
    companyId: string,
    companyResourceId?: string | null,
    contentFilePath?: string | null,
    contentUrl?: string | null,
    createdAt: string,
    description: string,
    id: string,
    owner?: string | null,
    planIds?: Array< string | null > | null,
    style: string,
    timeValue: number,
    topicId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUnitExpenseBudgetSubscriptionVariables = {
  filter?: ModelSubscriptionUnitExpenseBudgetFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUnitExpenseBudgetSubscription = {
  onUpdateUnitExpenseBudget?:  {
    __typename: "UnitExpenseBudget",
    companyId: string,
    createdAt: string,
    expenseCategoryId: string,
    id: string,
    owner?: string | null,
    startingBalance: number,
    unitId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    archived?: boolean | null,
    cognitoId?: string | null,
    companyId?: string | null,
    contactPhoneNumber?: string | null,
    contactPhoneType?: string | null,
    createdAt: string,
    currentJobClassification?: string | null,
    dateOfHire?: string | null,
    discrepancyNotification?: boolean | null,
    discrepancyNotificationTypes?: string | null,
    domain?: string | null,
    driversLicenseStatus?: boolean | null,
    email: string,
    globalLocationPermission?: boolean | null,
    id: string,
    inputByPerson?: string | null,
    inputDate?: string | null,
    locationAssignment?: Array< string | null > | null,
    name: string,
    notesAboutUser?: string | null,
    onHighwayEligibility?: boolean | null,
    owner?: string | null,
    permissions?: string | null,
    personalIdentification?: string | null,
    pmNotification?: boolean | null,
    pmNotificationTypes?: string | null,
    position?: string | null,
    regionalAssignment?: Array< string | null > | null,
    role?: string | null,
    safetyLessons?: string | null,
    skillTrackingModuleEnrollment?: boolean | null,
    trainingModuleEnrollment?: boolean | null,
    trainingNotification?: boolean | null,
    trainingNotificationTypes?: string | null,
    updatedAt: string,
    userPhoto?: string | null,
  } | null,
};

export type OnUpdateUserFileSubscriptionVariables = {
  filter?: ModelSubscriptionUserFileFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserFileSubscription = {
  onUpdateUserFile?:  {
    __typename: "UserFile",
    companyId: string,
    createdAt: string,
    fileName: string,
    fileSize: number,
    id: string,
    owner?: string | null,
    s3Path: string,
    updatedAt: string,
    uploadedAt: string,
    uploadedBy: string,
    uploadedByName: string,
    userId: string,
  } | null,
};

export type OnUpdateUserReportFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionUserReportFavoriteFilterInput | null,
};

export type OnUpdateUserReportFavoriteSubscription = {
  onUpdateUserReportFavorite?:  {
    __typename: "UserReportFavorite",
    companyId: string,
    createdAt: string,
    id: string,
    reportTypeKey: string,
    updatedAt: string,
    userId: string,
  } | null,
};

export type OnUpdateUserSkillReportSubscriptionVariables = {
  filter?: ModelSubscriptionUserSkillReportFilterInput | null,
};

export type OnUpdateUserSkillReportSubscription = {
  onUpdateUserSkillReport?:  {
    __typename: "UserSkillReport",
    assessorId?: string | null,
    assessorName?: string | null,
    companyId: string,
    createdAt?: string | null,
    expirationDate?: string | null,
    formId?: string | null,
    gpsLatitude?: number | null,
    gpsLocationType?: string | null,
    gpsLongitude?: number | null,
    id: string,
    inopCount?: number | null,
    inspectionCompleted?: string | null,
    inspectionDurationSeconds?: number | null,
    inspectionStarted?: string | null,
    okCount?: number | null,
    passFailStatus?: string | null,
    photos?: Array< string | null > | null,
    qualificationLevel?: string | null,
    responseData?: string | null,
    signature?: string | null,
    skillCategory?: string | null,
    skillName?: string | null,
    totalItems?: number | null,
    updatedAt: string,
    userId: string,
    userName?: string | null,
    warnCount?: number | null,
  } | null,
};

export type OnUpdateVendorListSubscriptionVariables = {
  filter?: ModelSubscriptionVendorListFilterInput | null,
  owner?: string | null,
};

export type OnUpdateVendorListSubscription = {
  onUpdateVendorList?:  {
    __typename: "VendorList",
    address?: string | null,
    companyId: string,
    createdAt: string,
    faxNumber?: string | null,
    id: string,
    name: string,
    owner?: string | null,
    phoneNumber?: string | null,
    repName?: string | null,
    repPhoneNumber?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateVideoSubscriptionVariables = {
  filter?: ModelSubscriptionVideoFilterInput | null,
  owner?: string | null,
};

export type OnUpdateVideoSubscription = {
  onUpdateVideo?:  {
    __typename: "Video",
    assignedSafetyLesson?: string | null,
    contentPath: string,
    createdAt: string,
    folderName?: string | null,
    id: string,
    owner?: string | null,
    resourceLibraryID?: string | null,
    safetyLesson?: boolean | null,
    sharedWithCompanyIds?: Array< string | null > | null,
    title: string,
    updatedAt: string,
  } | null,
};
